// @ts-nocheck
// Page: self-serve  (self-serve dashboard main module)
// Ported from:
//   Enrollment_modules/self-serve/main.module/module.html (inline script lines 906-964)
//   Enrollment_modules/self-serve/main.module/module.js (all 10066 lines)
// Notes:
//   1. validatePass imported from ui/validation (was the temporary window shim — now removed).
//   2. handleDescriptorInput was undefined in the original inline script; oninput stripped.
//   3. window.logoutUser / window.togglePassword moved into init() as local fns.
//   4. redirectToUpdatePaymentTab exposed on window for the dynamic HTML at module.js:7582.

import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"
import { beginOperation, type LoadingOperationHandle } from "../../ui/loading-modal"
import { validatePass } from "../../ui/validation"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/self-serve/self-serve.ts","init",[root,_config],["root","_config"]);
  function showContent(type) {
__ea_trace("modules/self-serve/self-serve.ts","showContent",[type],["type"]);
    document.querySelector(".jnpiays-bank-details").style.display = "none"
    document.querySelector(".jnpiays-credit-details").style.display = "none"
    document.querySelector(`.jnpiays-${type}-details`).style.display = "block"
  }
  function showContentMP(type) {
__ea_trace("modules/self-serve/self-serve.ts","showContentMP",[type],["type"]);
    document.querySelector(".mp-jnpiays-bank-details").style.display = "none"
    document.querySelector(".mp-jnpiays-credit-details").style.display = "none"
    document.querySelector(`.mp-jnpiays-${type}-details`).style.display = "block"
  }
  function showOptionsContentMP(type) {
__ea_trace("modules/self-serve/self-serve.ts","showOptionsContentMP",[type],["type"]);
    document.getElementById("mp-opt1").checked = false
    document.getElementById("mp-opt2").checked = false
    document.getElementById("mp-opt3").checked = false
    document.getElementById(`mp-opt${type}`).checked = true

    if (type === 1) {
      document.getElementById("goToUpdatePaymentTab").style.display = "none"
      document.getElementById("makePaymentMethods").style.display = "none"
      document.getElementById("paymentDetails").style.display = "block"
    } else if (type === 2) {
      document.getElementById("paymentDetails").style.display = "none"
      document.getElementById("makePaymentMethods").style.display = "none"
      document.getElementById("goToUpdatePaymentTab").style.display = "block"
    } else if (type === 3) {
      document.getElementById("goToUpdatePaymentTab").style.display = "none"
      document.getElementById("paymentDetails").style.display = "none"
      document.getElementById("makePaymentMethods").style.display = "block"
    }
  }
  function redirectToUpdatePaymentTab() {
__ea_trace("modules/self-serve/self-serve.ts","redirectToUpdatePaymentTab",[],[]);
    document.getElementById("payment-info").click()
  }
  window.logoutUser = () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
    // Show the logout popup
    document.getElementById("logout-popup").style.display = "flex"

    // Remove 'RecordId' from localStorage
    storage.rawRemove("RecordId")
  }
  document.querySelector(".enrolledAccounts-btn a").onclick = (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
    event.preventDefault() // Prevent the default redirection
    showPopup() // Show the popup
  }
  function showPopup() {
__ea_trace("modules/self-serve/self-serve.ts","showPopup",[],[]);
    document.querySelector(".lfcsiya-main.findSolarPopup").style.display = "block"
  }
  window.togglePassword = (fieldId, _icon) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[fieldId,_icon],["fieldId","_icon"]);
    setTimeout(() => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
      const input = document.getElementById(fieldId)
      if (input.type === "password") {
        input.type = "text"
      } else {
        input.type = "password"
      }
    }, 100)
  }

  // ─── Loading modal ─────────────────────────────────────────────────────────
  // Mechanical migration of the former fake-timer progress bar to the shared,
  // accessible loading modal (js/src/ui/loading-modal.ts). Kind "mutation" so a
  // genuine hang shows honest "may still be processing" copy with a Close escape,
  // never a fabricated 100%. The former 70s timer and the interval-leak are gone
  // by construction. A deferred audit will split this into read vs mutation
  // withLoader boundaries with abort/idempotency semantics.
  let loaderHandle: LoadingOperationHandle | null = null

  /** Extract the shape/structure of an object without actual data values */
  function getObjectShape(obj, depth, maxDepth) {
__ea_trace("modules/self-serve/self-serve.ts","getObjectShape",[obj,depth,maxDepth],["obj","depth","maxDepth"]);
    depth = depth || 0
    maxDepth = maxDepth || 3

    if (depth > maxDepth) return "..."

    if (obj === null) return "null"
    if (obj === undefined) return "undefined"

    var type = typeof obj
    if (type === "string") return `string(${obj.length})`
    if (type === "number") return "number"
    if (type === "boolean") return "boolean"
    if (type === "function") return "function"

    if (Array.isArray(obj)) {
      if (obj.length === 0) return "[]"
      return [getObjectShape(obj[0], depth + 1, maxDepth), `...${obj.length} items`]
    }

    if (type === "object") {
      var shape = {}
      for (var key in obj) {
        if (Object.hasOwn(obj, key)) {
          shape[key] = getObjectShape(obj[key], depth + 1, maxDepth)
        }
      }
      return shape
    }

    return type
  }

  function openProgressBar(message) {
__ea_trace("modules/self-serve/self-serve.ts","openProgressBar",[message],["message"]);
    // Preserve the original falsy-coercion: null/undefined/"" fall back to the default.
    loaderHandle = beginOperation({ kind: "mutation", message: message || "We are gathering your enrollment information." })
  }
  function closeProgressBar() {
__ea_trace("modules/self-serve/self-serve.ts","closeProgressBar",[],[]);
    loaderHandle?.complete()
    loaderHandle = null
  }
  function _saveLaterOpenLoader() {
__ea_trace("modules/self-serve/self-serve.ts","_saveLaterOpenLoader",[],[]);
    var loader = document.getElementById("saveLaterresetPassLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("saveLaterloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = true
    })
  }

  openProgressBar()
  document.querySelector(".ssmainsection-outer").style.display = "block"

  function openNoAccountAlert() {
__ea_trace("modules/self-serve/self-serve.ts","openNoAccountAlert",[],[]);
    document.querySelector("#progressBarOverlayAlert").style.display = "block"
    document.querySelector("#progressBarAlert").style.display = "block"
  }

  var responseFromAPI = ""

  var _verifyidenty
  var _bayouFormCompleted = false
  var _bayouToken = null
  var _bayouTokenType = null
  var _bayouUtility = null
  var _bayouId = null
  var _bayouAccountNo = null
  var firstId = null
  var _meterId = null
  var meterType = null
  var _rateClass = null
  var meterCity = null
  var meterState = null
  var meterLine1 = null
  var meterLine2 = null
  var _meterCountry = null
  var meterPostalCode = null
  var additionalAttributeItem = null
  var additionalAttributeValue = null
  var accountNofuncCallCount = 0
  var _mfaRequired = "No"
  var _customerTriedCount = 1

  /* ------------------ Update Utility Login -------------- */
  /* ------- Bayou utility code ----------- */
  async function addBayouAuthenticateToContactRecord(value) {
__ea_trace("modules/self-serve/self-serve.ts","addBayouAuthenticateToContactRecord",[value],["value"]);
    var email = storage.rawGet("logEmail")
    var _catchdata = ""
    try {
      const data = {
        properties: {
          email: email,
          bayou_user_authenticate: value,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      if (response.ok) {
      }

      const _result = await response.json()
      //         responseFromAPI = JSON.stringify(result);
    } catch (error) {
      console.error("Error:", error)
    }
    // attcode not null and rows length not exist
  }
  async function getDataFromUANConfigTable() {
__ea_trace("modules/self-serve/self-serve.ts","getDataFromUANConfigTable",[],[]);
    var exampleUtilityId = storage.rawGet("utility_id")
    var stateForUANConfig = storage.rawGet("stateForLMIConfig")
    var _utilityNameForUANConfig = storage.rawGet("utility_Name")
    const hubDBEndpointUANC = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.uanConfig}/rows?portalId=${window.__ENV__.dataPortalId}&orderBy=uan_field_display_sequence&utility_id=${exampleUtilityId}&state_name=${stateForUANConfig}`
    const responseUANC = await fetch(hubDBEndpointUANC, { method: "GET" })
    const dataUANC = await responseUANC.json()
    const rowsUANC = dataUANC.objects
    if (rowsUANC.length >= 1) {
      rowsUANC.forEach((element, _index) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element,_index],["element","_index"]);
        var _uanFieldDisplaySequence = element.values["6"]
        if (element.values["16"] !== undefined && element.values["16"] !== "undefined") {
          var additionalAttributes = element.values["16"]
          additionalAttributeItem = additionalAttributes
        }
      })
    }
  }
  async function _getAccountNumberByWebhook(token, type, utility, id) {
__ea_trace("modules/self-serve/self-serve.ts","_getAccountNumberByWebhook",[token,type,utility,id],["token","type","utility","id"]);
    //         var ContactId = storage.rawGet("RecordId");
    const hensonApiUrl = `https://hansen.danmarcrm.com/getAccountNumbers.php?contact_id=${id}`
    const requestBody = {
      contact_id: id,
    }
    var catchdata = ""
    try {
      const response = await fetch(hensonApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      })
      catchdata = requestBody
      const responseData = await response.json()
      responseFromAPI = JSON.stringify(responseData)

      // Check if there is at least one id
      if (responseData.length > 0) {
        if (responseData.length >= 1) {
          var Accdiv = document.createElement("div")
          var h2 = document.createElement("h2")
          h2.textContent = "Please select Account Number"
          Accdiv.appendChild(h2)
          const accul = document.createElement("ul")
          accul.classList.add("accountNumbersUl")
          await getDataFromUANConfigTable()
          var existAccNoLength = 0
          for (const item of responseData) {
            const accli = document.createElement("li")
            const accspan = document.createElement("span")
            accli.classList.add(`acc${item.id}`) // Add class to li
            accspan.textContent = item.id
            accli.id = item.id
            accli.appendChild(accspan)
            if (item.meters.length >= 1) {
              var div = document.createElement("div")
              div.classList.add("meterWrapper")
              var h4 = document.createElement("h4")
              h4.textContent = "Please select Additional Attributes"
              div.appendChild(h4)
              div.id = `meterId${item.id}`
              const meterul = document.createElement("ul")
              meterul.id = "meterList"
              item.meters.forEach((meter) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[meter],["meter"]);
                const meterli = document.createElement("li")
                var mtType = meter.type
                mtType = mtType.toUpperCase()
                if (mtType === "ELECTRIC") {
                  meterli.id = `${meter.id}`
                  meterli.type = meter.type
                  meterli.setAttribute("city", meter.address.city)
                  meterli.setAttribute("state", meter.address.state)
                  meterli.setAttribute("line_1", meter.address.line_1)
                  meterli.setAttribute("line_2", meter.address.line_2)
                  meterli.setAttribute("country", meter.address.country)
                  meterli.setAttribute("postal_code", meter.address.postal_code)
                  meterli.setAttribute("tariff", meter.tariffs[0].tariff)
                  if (meter.additional_attributes != null) {
                    meterli.setAttribute(
                      "aa",
                      meter.additional_attributes[additionalAttributeItem]
                        ? meter.additional_attributes[additionalAttributeItem]
                        : "",
                    )
                  }

                  _meterId = `${meter.id}`
                  meterType = meter.type
                  _rateClass = meter.tariffs[0].tariff
                  meterCity = meter.address.city
                  meterState = meter.address.state
                  meterLine1 = meter.address.line_1
                  meterLine2 = meter.address.line_2
                  _meterCountry = meter.address.country
                  meterPostalCode = meter.address.postal_code
                  if (meter.additional_attributes[additionalAttributeItem] != null) {
                    accli.classList.remove("hidden")
                    div.classList.remove("hidden")
                    if (
                      additionalAttributeValue !== "" &&
                      additionalAttributeValue != null &&
                      additionalAttributeValue !== undefined
                    ) {
                      if (additionalAttributeValue === meter.additional_attributes[additionalAttributeItem]) {
                        div.classList.add("hidden")
                      } else {
                        div.classList.remove("hidden")
                      }
                    } else {
                      div.classList.add("hidden")
                    }
                    additionalAttributeValue = meter.additional_attributes[additionalAttributeItem]
                  } else {
                    div.classList.add("hidden")

                    if (storage.rawGet("utility_id") === "COMED-SF") {
                      accli.classList.add("hidden")
                      document.querySelector("#serviceAddAtt").style.display = "block"
                      document.querySelector(".serviceAddAttLabel").style.display = "block"
                    } else {
                      accli.classList.remove("hidden")
                      document.querySelector("#serviceAddAtt").style.display = "none"
                      document.querySelector(".serviceAddAttLabel").style.display = "none"
                    }
                  }
                  //                                     meterli.textContent = `${meter.id}`;
                  if (additionalAttributeValue == null) {
                    additionalAttributeValue = ""
                  }
                  meterli.textContent = additionalAttributeValue
                  meterul.appendChild(meterli)
                  div.appendChild(meterul)
                  accli.appendChild(div)
                }
              })
            }
            var property = "uan_1_value"
            var value = item.id
            const response = await fetch(apiUrl("SearchUANValuesInDealRecord"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ property, value }),
            })
            const data = await response.json()
            if (response.ok) {
              if (data.total === 0 || data.total === undefined) {
              } else if (data.total === 1) {
                var dealIdFromDealFound = data.results[0].id
                var dealIdFromCurrentPage = storage.rawGet("dealId")
                if (dealIdFromDealFound === dealIdFromCurrentPage) {
                } else {
                  ++existAccNoLength
                  accli.style.cursor = "not-allowed"
                  accli.style.pointerEvents = "none"
                  accli.style.color = "#999"
                  accli.style.opacity = "0.5"
                }
              } else {
                ++existAccNoLength
                accli.style.cursor = "not-allowed"
                accli.style.pointerEvents = "none"
                accli.style.color = "#999"
                accli.style.opacity = "0.5"
              }
            }
            accul.appendChild(accli)
            Accdiv.appendChild(accul)
            document.querySelector(".have-online-details").appendChild(Accdiv)
          }
          //                 closeProgressBar();
          if (existAccNoLength === responseData.length) {
            _verifyidenty = "no"
            //                             alert("Account number already exists. Please try again.");
            passUpdatedOpenLoader()
          }
          document.querySelectorAll(".meterWrapper").forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
            li.style.display = "none"
          })
          function accountNumberSelected(event) {
__ea_trace("modules/self-serve/self-serve.ts","accountNumberSelected",[event],["event"]);
            document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
              span.style.backgroundColor = "#ffffff"
            })
            document.querySelectorAll(".meterWrapper").forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
              li.style.display = "none"
            })
            const clickedElement = event.target
            firstId = clickedElement.parentElement.id
            _bayouAccountNo = firstId
            const meterWrapper = clickedElement.parentElement.querySelector(".meterWrapper")
            //                         if (!meterWrapper.classList.contains('hidden')) {
            const ulElement = meterWrapper.querySelector("ul")
            const liElements = ulElement.querySelectorAll("li")
            const numberOfLi = liElements.length
            if (numberOfLi === 1) {
              _verifyidenty = "yes"
              meterWrapper.style.display = "none"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                _meterId = li.id
                meterType = li.type
                meterCity = li.getAttribute("city")
                meterState = li.getAttribute("state")
                meterLine1 = li.getAttribute("line_1")
                meterLine2 = li.getAttribute("line_2")
                _meterCountry = li.getAttribute("country")
                meterPostalCode = li.getAttribute("postal_code")
                additionalAttributeValue = li.getAttribute("aa")
                if (li.tariffs) {
                  _rateClass = li.tariffs[0].tariff
                }
              })
            } else {
              ulElement.querySelectorAll("li").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
                span.style.backgroundColor = "#ffffff"
              })
              meterWrapper.style.display = "block"
              ulElement.querySelectorAll("li").forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                li.addEventListener("click", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
                  _verifyidenty = "yes"
                  ulElement.querySelectorAll("li").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
                    span.style.backgroundColor = "#ffffff"
                  })
                  this.style.backgroundColor = "#f18020"
                  _meterId = this.id
                  meterType = this.type
                  meterCity = this.getAttribute("city")
                  meterState = this.getAttribute("state")
                  meterLine1 = this.getAttribute("line_1")
                  meterLine2 = this.getAttribute("line_2")
                  _meterCountry = this.getAttribute("country")
                  meterPostalCode = this.getAttribute("postal_code")
                  additionalAttributeValue = this.getAttribute("aa")
                  if (this.tariffs) {
                    _rateClass = this.tariffs[0].tariff
                  }
                })
              })
            }
            clickedElement.style.backgroundColor = "#f18020"
            document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
              span.removeAttribute("data-selected")
            })
            clickedElement.setAttribute("data-selected", "true")
            document.querySelector(".selectedItemDetails #name").value = meterType
            document.querySelector(".selectedItemDetails #serviceAddress").value = meterLine1
            document.querySelector(".selectedItemDetails #serviceAddress2").value = meterLine2
            document.querySelector(".selectedItemDetails #serviceCity").value = meterCity
            document.querySelector(".selectedItemDetails #serviceState").value = meterState
            document.querySelector(".selectedItemDetails #serviceZipCode").value = meterPostalCode
            document.querySelector(".selectedItemDetails #serviceAddAtt").value = additionalAttributeValue
            document.querySelector(".selectedItemDetails").style.display = "block"
            document.getElementById("addressSameCheckbox").addEventListener("change", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
              const content = document.querySelector(".selectedItemDetails .mailingItems")
              if (this.checked) {
                content.style.display = "none" // Show content
              } else {
                content.style.display = "block" // Hide content
              }
            })
          }
          document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
            span.addEventListener("click", accountNumberSelected)
          })
        }
        _bayouToken = token
        _bayouTokenType = type
        _bayouUtility = utility
        _bayouId = id
        _bayouAccountNo = firstId
      } else {
        if (accountNofuncCallCount === 50) {
          _verifyidenty = "no"
          alert(
            "We successfully validated your credentials but were unable to find any Electric accounts. If you recently created your utility login, please try again later.",
          )
        } else {
          ++accountNofuncCallCount
          await _getAccountNumberByWebhook(token, type, utility, id)
        }
      }
    } catch (error) {
      console.error("Error calling API:", error)
    }
  }
  async function _getTokenAndDateStamp() {
__ea_trace("modules/self-serve/self-serve.ts","_getTokenAndDateStamp",[],[]);
    var email = storage.rawGet("logEmail")
    var _catchdata = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      var dateStamp = dataa.userValue.properties.date_stamp
      var bToken = dataa.userValue.properties.bayou_onboarding_token
      var bContactId = dataa.userValue.properties.bayou_id
      storage.rawSet("dateStamp", dateStamp)
      storage.rawSet("bayou_contact_id", bContactId)
      storage.rawSet("onboarding_token", bToken)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function updateTokenAndDateInContact(token, date, tokenLink, bayouid) {
__ea_trace("modules/self-serve/self-serve.ts","updateTokenAndDateInContact",[token,date,tokenLink,bayouid],["token","date","tokenLink","bayouid"]);
    var email = storage.rawGet("logEmail")
    var _catchdata = ""
    try {
      const data = {
        properties: {
          email: email,
          bayou_onboarding_token: token,
          date_stamp: date,
          bayou_onboarding_link: tokenLink,
          bayou_id: bayouid,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      responseFromAPI = await response.json()
      responseFromAPI = JSON.stringify(responseFromAPI)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function updateBayouIdInContact(bayouid) {
__ea_trace("modules/self-serve/self-serve.ts","updateBayouIdInContact",[bayouid],["bayouid"]);
    var email = storage.rawGet("logEmail")
    var _catchdata = ""
    try {
      const data = {
        properties: {
          email: email,
          bayou_id: bayouid,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      responseFromAPI = await response.json()
      responseFromAPI = JSON.stringify(responseFromAPI)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  function getCurrentDate() {
__ea_trace("modules/self-serve/self-serve.ts","getCurrentDate",[],[]);
    const today = new Date()
    const month = String(today.getMonth() + 1).padStart(2, "0") // Months are 0-based
    const day = String(today.getDate()).padStart(2, "0")
    const year = today.getFullYear()
    return `${month}/${day}/${year}`
  }
  async function _BayouGetCustomersWhenTokenExpire() {
__ea_trace("modules/self-serve/self-serve.ts","_BayouGetCustomersWhenTokenExpire",[],[]);
    var _bayou_reason = storage.rawGet("bayou_reason")
    var bayouContactId = storage.rawGet("bayou_contact_id")
    _verifyidenty = "no"
    const hensonApiUrl = `https://hansen.danmarcrm.com/getContactByID.php?contact_id=${bayouContactId}`
    const requestBody = {
      contact_id: bayouContactId,
    }
    var _catchdata = ""
    try {
      const response = await fetch(hensonApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      })
      _catchdata = requestBody
      var responseData = await response.json()
      responseFromAPI = JSON.stringify(responseData)
      var onboardingToken = responseData.onboarding_token
      var onboardingLink = responseData.onboarding_link
      storage.rawSet("onboarding_token", onboardingToken)
      storage.rawSet("dateStamp", getCurrentDate())
      await updateTokenAndDateInContact(onboardingToken, getCurrentDate(), onboardingLink)
      Bayou.loadOnboardingForm(
        document.getElementById("have-online-details"),
        60, // Found in your company settings: https://staging.bayou.energy/dashboard/settings
        onboardingToken, // Generated using this API call: https://docs.bayou.energy/v2.0/reference/get_customers-id
        (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
          document.getElementById("verification-error-message").innerHTML = ""
          if (event.type === "customerHasAuthenticated") {
            _mfaRequired = "No"
            document.querySelector(".customIframe").style.display = "block"
            storage.rawSet("bayou_contact_id", event.data.id)
            updateTokenAndDateInContact(onboardingToken, getCurrentDate(), onboardingLink, event.data.id)
          } else if (event.type === "customerEnteredInvalidCredentials") {
            document.querySelector(".customIframe").style.display = "none"
            _mfaRequired = "No"
            alert("Customer entered invalid credentials")
            _verifyidenty = "no"
          } else if (event.type === "customerEnteredInvalidMFAChallenge") {
            document.querySelector(".customIframe").style.display = "none"
            _mfaRequired = "Yes"
            alert("Customer entered invalid MFA challenge")
            _verifyidenty = "no"
          }
        },
      )
    } catch (error) {
      _verifyidenty = "no"
      console.error("Error calling API:", error)
    }
  }
  async function BayouGetCustomers() {
__ea_trace("modules/self-serve/self-serve.ts","BayouGetCustomers",[],[]);
    var _bayou_reason = storage.rawGet("bayou_reason")
    var bayouContactId = storage.rawGet("bayou_contact_id")

    if (bayouContactId !== "" && bayouContactId !== undefined && bayouContactId != null && bayouContactId !== "null") {
      bayouContactId = Number(bayouContactId)
      _verifyidenty = "no"
      const hensonApiUrl = `https://hansen.danmarcrm.com/getContactByID.php?contact_id=${bayouContactId}`
      const requestBody = {
        contact_id: bayouContactId,
      }
      var _catchdata = ""
      try {
        const response = await fetch(hensonApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        })
        _catchdata = requestBody
        var responseData = await response.json()
        responseFromAPI = JSON.stringify(responseData)
        var _onbToken = storage.rawGet("onboarding_token")
        const is_currently_authenticated = responseData.is_currently_authenticated
        if (is_currently_authenticated === true || is_currently_authenticated === "true") {
          document.querySelector(".update_utility_login #have-online-details").style.display = "none"
          document.querySelector(".customIframe").style.display = "none"
          document.querySelector(".featureNotAvailable h2").innerHTML =
            'Our records indicate that your credentials are currently authenticated. If you believe this to be incorrect, please contact our Customer Care team at <a href="tel:1-866-969-4129" target="_blank">1-866-969-4129</a> or <a href="mailto:customercare@nautilussolar.com" target="_blank">customercare@nautilussolar.com</a>'
          await addBayouAuthenticateToContactRecord(is_currently_authenticated)
        } else {
          await addBayouAuthenticateToContactRecord(is_currently_authenticated)
          document.querySelector("#utility-creds").style.display = "block"
          document.querySelector(".update_utility_login #have-online-details").style.display = "block"
          var onboardingToken = responseData.onboarding_token
          var onboardingLink = responseData.onboarding_link
          Bayou.loadOnboardingForm(
            document.getElementById("have-online-details"),
            60, // Found in your company settings: https://staging.bayou.energy/dashboard/settings
            onboardingToken, // Generated using this API call: https://docs.bayou.energy/v2.0/reference/get_customers-id
            (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
              document.getElementById("verification-error-message").innerHTML = ""
              updateTokenAndDateInContact(onboardingToken, getCurrentDate(), onboardingLink, event.data.id)
              if (event.type === "customerHasAuthenticated") {
                _mfaRequired = "No"
                document.querySelector(".customIframe").style.display = "block"
              } else if (event.type === "customerEnteredInvalidCredentials") {
                document.querySelector(".customIframe").style.display = "none"
                _mfaRequired = "No"
                alert("Customer entered invalid credentials")
                _verifyidenty = "no"
              } else if (event.type === "customerEnteredInvalidMFAChallenge") {
                document.querySelector(".customIframe").style.display = "none"
                _mfaRequired = "Yes"
                alert("Customer entered invalid MFA challenge")
                _verifyidenty = "no"
              }
            },
          )
        }
        if (response.status === 500 || response.status === 404) {
          _verifyidenty = "no"
        }
      } catch (error) {
        _verifyidenty = "no"
        console.error("Error calling API:", error)
      }
    } else {
      var UtilitySessionDetails = JSON.parse(storage.rawGet("UtilitySessionDetails"))
      var ContactId = storage.rawGet("RecordId")
      var FirstDealId = storage.rawGet("FirstDealId")
      const hensonApiUrl = "https://hansen.danmarcrm.com/bayouCreateCustomer.php"
      const requestBody = {
        utility: UtilitySessionDetails["9"],
        external_id: ContactId,
        deal_id: FirstDealId,
      }

      var onbToken = storage.rawGet("onboarding_token")
      if (onbToken == null || onbToken === "null" || onbToken === undefined || onbToken === "undefined") {
        //             var catchdata = '';
        try {
          const response = await fetch(hensonApiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          })
          //                 catchdata = requestBody;
          const responseData = await response.text()
          responseFromAPI = JSON.stringify(responseData)

          if (typeof Sentry !== "undefined" && Sentry.captureMessage) {
            Sentry.captureMessage("API Response", {
              level: "info",
              tags: {
                api_endpoint: "bayouCreateCustomer",
                api_method: "POST",
                api_status: response.status,
                api_ok: response.ok,
              },
              extra: {
                requestBodyShape: getObjectShape(requestBody),
                responseDataShape: getObjectShape(responseData),
              },
            })
          }

          // Log to Nautilus API
          try {
            fetch("/_hcms/api/LogToNautilus", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                url: "https://dev2hansen.danmarcrm.com/bayouCreateCustomer.php",
                request_method: "POST",
                request_body: requestBody,
                response: {
                  status: response.status,
                  ok: response.ok,
                  data: responseData,
                },
                metadata: {
                  module_name: "Self_Serve_Main_Section",
                  api_endpoint: "bayouCreateCustomer",
                  timestamp: new Date().toISOString(),
                },
              }),
            }).catch((e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
              console.error("Failed to log to Nautilus:", e.message)
            })
          } catch (e) {
            // Silent fail - don't let logging errors break main flow
            console.error("Nautilus logging error:", e)
          }

          const onboardingTokenMatch = responseData.match(/"onboarding_token"\s*:\s*"([^"]+)"/)
          const onboardingLinkMatch = responseData.match(/"onboarding_link"\s*:\s*"([^"]+)"/)
          const onboardingLink = onboardingLinkMatch ? onboardingLinkMatch[1] : null

          if (onboardingTokenMatch?.[1]) {
            var onboardingToken = onboardingTokenMatch[1]
            storage.rawSet("onboarding_token", onboardingToken)
            Bayou.loadOnboardingForm(
              document.getElementById("have-online-details"),
              60, // Found in your company settings: https://staging.bayou.energy/dashboard/settings
              onboardingToken, // Generated using this API call: https://docs.bayou.energy/v2.0/reference/get_customers-id
              (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
                document.getElementById("verification-error-message").innerHTML = ""
                if (event.type === "customerHasAuthenticated") {
                  _mfaRequired = "No"
                  document.querySelector(".customIframe").style.display = "block"
                  storage.rawSet("bayou_contact_id", event.data.id)
                  updateTokenAndDateInContact(onboardingToken, getCurrentDate(), onboardingLink, event.data.id)
                } else if (event.type === "customerEnteredInvalidCredentials") {
                  document.querySelector(".customIframe").style.display = "none"
                  _mfaRequired = "No"
                  alert("Customer entered invalid credentials")
                  _verifyidenty = "no"
                } else if (event.type === "customerEnteredInvalidMFAChallenge") {
                  document.querySelector(".customIframe").style.display = "none"
                  _mfaRequired = "Yes"
                  alert("Customer entered invalid MFA challenge")
                  _verifyidenty = "no"
                }
              },
            )
          }
        } catch (error) {
          console.error("Error calling API:", error)
        }
      } else {
        Bayou.loadOnboardingForm(
          document.getElementById("have-online-details"),
          60, // Found in your company settings: https://staging.bayou.energy/dashboard/settings
          onbToken, // Generated using this API call: https://docs.bayou.energy/v2.0/reference/get_customers-id
          (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
            document.getElementById("verification-error-message").innerHTML = ""
            if (event.type === "customerHasAuthenticated") {
              _mfaRequired = "No"
              document.querySelector(".customIframe").style.display = "block"
              updateBayouIdInContact(event.data.id)
            } else if (event.type === "customerEnteredInvalidCredentials") {
              document.querySelector(".customIframe").style.display = "none"
              _mfaRequired = "No"
              alert("Customer entered invalid credentials")
              _verifyidenty = "no"
            } else if (event.type === "customerEnteredInvalidMFAChallenge") {
              document.querySelector(".customIframe").style.display = "none"
              _mfaRequired = "Yes"
              alert("Customer entered invalid MFA challenge")
              _verifyidenty = "no"
            }
          },
        )
      }
    }
  }
  async function _findmultiAccountNumber(_contactId, _accountnumber, responseData) {
__ea_trace("modules/self-serve/self-serve.ts","_findmultiAccountNumber",[_contactId,_accountnumber,responseData],["_contactId","_accountnumber","responseData"]);
    await getDataFromUANConfigTable()
    var Accdiv = document.createElement("div")
    var h2 = document.createElement("h2")
    h2.textContent = "Please select Account Number"
    Accdiv.appendChild(h2)
    const accul = document.createElement("ul")
    accul.classList.add("accountNumbersUl")
    var existAccNoLength = 0

    for (const item of responseData) {
      const accli = document.createElement("li")
      const accspan = document.createElement("span")
      accli.classList.add(`acc${item.account_number}`) // Add class to li
      accspan.textContent = item.account_number
      accli.id = item.account_number
      accli.appendChild(accspan)
      if (item.meters.length >= 1) {
        var div = document.createElement("div")
        div.classList.add("meterWrapper")
        var h4 = document.createElement("h4")
        h4.textContent = "Please select Additional Attributes"
        div.appendChild(h4)
        div.id = `meterId${item.account_number}`
        const meterul = document.createElement("ul")
        meterul.id = "meterList"
        item.meters.forEach((meter) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[meter],["meter"]);
          const meterli = document.createElement("li")
          var mtType = meter.type
          mtType = mtType.toUpperCase()
          if (mtType === "ELECTRIC") {
            meterli.id = `${meter.id}`
            meterli.type = meter.type
            meterli.setAttribute("tariff", meter.tariffs[0].tariff)
            if (meter.additional_attributes != null) {
              meterli.setAttribute("aa", meter.additional_attributes[additionalAttributeItem])
            }
            _meterId = `${meter.id}`
            meterType = meter.type
            _rateClass = meter.tariffs[0].tariff
            if (meter.additional_attributes != null) {
              div.classList.remove("hidden")
              if (
                additionalAttributeValue !== "" &&
                additionalAttributeValue != null &&
                additionalAttributeValue !== undefined
              ) {
                if (additionalAttributeValue === meter.additional_attributes[additionalAttributeItem]) {
                  div.classList.add("hidden")
                } else {
                  div.classList.remove("hidden")
                }
              } else {
                div.classList.add("hidden")
              }
              additionalAttributeValue = meter.additional_attributes[additionalAttributeItem]
            } else {
              div.classList.add("hidden")
            }
            //                         meterli.textContent = `${meter.id}`;
            meterli.textContent = additionalAttributeValue
            meterul.appendChild(meterli)
            div.appendChild(meterul)
            accli.appendChild(div)
          }
        })
      }

      accul.appendChild(accli)
      Accdiv.appendChild(accul)
      document.querySelector(".have-online-details").appendChild(Accdiv)
    }
    if (existAccNoLength === responseData.length) {
      _verifyidenty = "no"
    }
    document.querySelectorAll(".meterWrapper").forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
      li.style.display = "none"
    })
    function accountNumberSelected(event) {
__ea_trace("modules/self-serve/self-serve.ts","accountNumberSelected",[event],["event"]);
      document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
        span.style.backgroundColor = "#ffffff"
      })
      document.querySelectorAll(".meterWrapper").forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
        li.style.display = "none"
      })
      const clickedElement = event.target
      firstId = clickedElement.parentElement.id
      _bayouAccountNo = firstId
      const meterWrapper = clickedElement.parentElement.querySelector(".meterWrapper")
      if (!meterWrapper.classList.contains("hidden")) {
        const ulElement = meterWrapper.querySelector("ul")
        const liElements = ulElement.querySelectorAll("li")
        const numberOfLi = liElements.length
        if (numberOfLi === 1) {
          _verifyidenty = "yes"
          meterWrapper.style.display = "none"
          liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
            _meterId = li.id
            meterType = li.type
            if (li.tariffs) {
              _rateClass = li.tariffs[0].tariff
            }
            additionalAttributeValue = li.getAttribute("aa")
          })
        } else {
          ulElement.querySelectorAll("li").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
            span.style.backgroundColor = "#ffffff"
          })
          meterWrapper.style.display = "block"
          ulElement.querySelectorAll("li").forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
            li.addEventListener("click", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
              _verifyidenty = "yes"
              ulElement.querySelectorAll("li").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
                span.style.backgroundColor = "#ffffff"
              })
              this.style.backgroundColor = "#f18020"
              _meterId = this.id
              meterType = this.type
              if (this.tariffs) {
                _rateClass = this.tariffs[0].tariff
              }
              additionalAttributeValue = this.getAttribute("aa")
            })
          })
        }
      } else {
        _verifyidenty = "yes"
      }
      clickedElement.style.backgroundColor = "#f18020"
      document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
        span.removeAttribute("data-selected")
      })
      clickedElement.setAttribute("data-selected", "true")
    }
    document.querySelectorAll(".accountNumbersUl li span").forEach((span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
      span.addEventListener("click", accountNumberSelected)
    })
  }
  /* ------- Bayou utility code ----------- */

  /* ----------------- Update Payment Info ------------------- */

  /* ------- iCheck function --------- */
  function ICCiframe() {
__ea_trace("modules/self-serve/self-serve.ts","ICCiframe",[],[]);
    var FirstName = storage.rawGet("FirstName")
    var LastName = storage.rawGet("LastName")
    var RecordId = storage.rawGet("RecordId")
    var companyName = storage.rawGet("CompanyName")
    var iframe = document.getElementById("iFrameCC")
    // Set dynamic values
    var appId = "l63I6y1i7KAuldPia6zedbnVWM68lXZS"
    var appSecret = "1XHOeroaWB4kzhh6EjGxuCyQj60novml"
    var custId = RecordId
    var firstName = FirstName
    var lastName = LastName
    // Construct the dynamic src URL
    var dynamicSrc =
      "https://portals.icheckgateway.com/iFrame/iFrameCC.aspx?" +
      "appId=" +
      encodeURIComponent(appId) +
      "&appSecret=" +
      encodeURIComponent(appSecret) +
      "&custId=" +
      encodeURIComponent(custId) +
      "&firstName=" +
      firstName +
      "&lastName=" +
      lastName +
      "&company=" +
      companyName +
      "&css=payment{background:white;}"
    // Set the src attribute of the iframe

    iframe.src = dynamicSrc
  }
  function IBNiframe() {
__ea_trace("modules/self-serve/self-serve.ts","IBNiframe",[],[]);
    var FirstName = storage.rawGet("FirstName")
    var LastName = storage.rawGet("LastName")
    var RecordId = storage.rawGet("RecordId")
    var iframe = document.getElementById("iFrameBN")
    var companyName = storage.rawGet("CompanyName")

    // Set dynamic values
    var appId = "l63I6y1i7KAuldPia6zedbnVWM68lXZS"
    // var appId = '222222';

    var appSecret = "1XHOeroaWB4kzhh6EjGxuCyQj60novml"
    // var appSecret = '222222';

    var custId = RecordId
    var firstName = FirstName
    var lastName = LastName
    // Construct the dynamic src URL
    var dynamicSrc =
      "https://portals.icheckgateway.com/iFrame/iFrameBA.aspx?" +
      "appId=" +
      encodeURIComponent(appId) +
      "&appSecret=" +
      encodeURIComponent(appSecret) +
      "&custId=" +
      encodeURIComponent(custId) +
      "&firstName=" +
      encodeURIComponent(firstName) +
      "&lastName=" +
      encodeURIComponent(lastName) +
      "&company=" +
      companyName +
      "&css=payment{background:white;}"
    // Set the src attribute of the iframe
    iframe.src = dynamicSrc
  }

  /* --------- make payment ---------- */
  function MPICCiframe() {
__ea_trace("modules/self-serve/self-serve.ts","MPICCiframe",[],[]);
    var FirstName = storage.rawGet("FirstName")
    var LastName = storage.rawGet("LastName")
    var RecordId = storage.rawGet("RecordId")
    var companyName = storage.rawGet("CompanyName")
    var iframe = document.getElementById("mp-iFrameCC")
    // Set dynamic values
    var appId = "l63I6y1i7KAuldPia6zedbnVWM68lXZS"
    var appSecret = "1XHOeroaWB4kzhh6EjGxuCyQj60novml"
    var custId = RecordId
    var firstName = FirstName
    var lastName = LastName
    // Construct the dynamic src URL
    var dynamicSrc =
      "https://portals.icheckgateway.com/iFrame/iFrameCC.aspx?" +
      "appId=" +
      encodeURIComponent(appId) +
      "&appSecret=" +
      encodeURIComponent(appSecret) +
      "&custId=" +
      encodeURIComponent(custId) +
      "&firstName=" +
      firstName +
      "&lastName=" +
      lastName +
      "&company=" +
      companyName +
      "&css=payment{background:white;}"
    // Set the src attribute of the iframe

    iframe.src = dynamicSrc
  }
  function MPIBNiframe() {
__ea_trace("modules/self-serve/self-serve.ts","MPIBNiframe",[],[]);
    var FirstName = storage.rawGet("FirstName")
    var LastName = storage.rawGet("LastName")
    var RecordId = storage.rawGet("RecordId")
    var iframe = document.getElementById("mp-iFrameBN")
    var companyName = storage.rawGet("CompanyName")

    // Set dynamic values
    var appId = "l63I6y1i7KAuldPia6zedbnVWM68lXZS"
    // var appId = '222222';

    var appSecret = "1XHOeroaWB4kzhh6EjGxuCyQj60novml"
    // var appSecret = '222222';

    var custId = RecordId
    var firstName = FirstName
    var lastName = LastName
    // Construct the dynamic src URL
    var dynamicSrc =
      "https://portals.icheckgateway.com/iFrame/iFrameBA.aspx?" +
      "appId=" +
      encodeURIComponent(appId) +
      "&appSecret=" +
      encodeURIComponent(appSecret) +
      "&custId=" +
      encodeURIComponent(custId) +
      "&firstName=" +
      encodeURIComponent(firstName) +
      "&lastName=" +
      encodeURIComponent(lastName) +
      "&company=" +
      companyName +
      "&css=payment{background:white;}"
    // Set the src attribute of the iframe
    iframe.src = dynamicSrc
  }
  /* --------- make payment ---------- */
  // Getting values from iframe --------------------------------------------------------------------------------
  var iFrameRoutingNo
  var iFrameaccountNumber
  var iFrameaccountName
  var iFrameaccountType
  var _iFrameBankamount
  var iFrameBanktoken
  var _iFrameBankoperation
  var iFrameBanksource
  var iFrameCreditCardNo
  var iFrameCreditaccountName
  var iFrameCreditcardExpDate
  var _IFrameCreditamount
  var _IFrameCreditcardType
  var _IFrameCreditcardOperation
  var IFrameCreditcardToken
  var IFrameCreditcardsource
  var iFrameCreditcardExpFullDate
  var _iFrameCreditcardExpFullDateIso
  var _IsCreditCheckDone = false
  var _IsValidateDisclosure = true
  var pageloaded = false
  var sourceIframeId = ""

  ///this is the function for getting last month in expiry date........
  function getExpiryDateWithLastDay(expiryDate) {
__ea_trace("modules/self-serve/self-serve.ts","getExpiryDateWithLastDay",[expiryDate],["expiryDate"]);
    const month = expiryDate.substring(0, 2)
    const year = `20${expiryDate.substring(2, 4)}` // Assuming the year is in the 2000s
    const lastDay = new Date(year, month, 0).getDate() // Get the last day of the month
    return `${month}/${lastDay.toString().padStart(2, "0")}/${year}`
  }
  function getExpiryDateWithISO(expiryDate) {
__ea_trace("modules/self-serve/self-serve.ts","getExpiryDateWithISO",[expiryDate],["expiryDate"]);
    const month = expiryDate.substring(0, 2)
    const year = `20${expiryDate.substring(2, 4)}` // Assuming the year is in the 2000s
    const lastDay = new Date(year, month, 0).getDate() // Get the last day of the month
    const lastDayDate = new Date(Date.UTC(year, month - 1, lastDay))
    // month is zero-based in JavaScript Date
    return lastDayDate.toISOString()
  }
  var _paymentprovider = storage.rawGet("FarmPayment")
  window.addEventListener("message", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
    var jsonData = e.data
    const iframes = document.querySelectorAll("iframe")
    const sourceIframe = Array.from(iframes).find((iframe) => iframe.contentWindow === e.source)
    if (!sourceIframe) {
      return
    }
    sourceIframeId = sourceIframe?.id
    if (!sourceIframeId) {
      return
    }
    if (jsonData.error == null) {
      if (jsonData.command != null || jsonData.command !== undefined) {
        return
      } else {
      }

      if (jsonData.token == null || jsonData.token === "") {
        _IsCreditCheckDone = false
        if (pageloaded === true) {
        }
        return
      }

      if (jsonData.routingNumber == null || jsonData.routingNumber === "") {
        _IsCreditCheckDone = true
        if (sourceIframeId === "mp-iFrameCC") {
          document.getElementById("mp-iBNMSG").innerHTML = ""
          document.getElementById("mp-ICCMSG").innerHTML =
            "Thank you, your card information is approved. Please click the button below to save the data."
        } else {
          document.querySelector(".update-card-info").classList.remove("disabled")
          document.querySelector(".update-card-info").disabled = false
          document.getElementById("payment-error-message").textContent = ""
          document.getElementById("payment-error-message").style.display = "none"
          document.getElementById("iBNMSG").innerHTML = ""
          document.getElementById("ICCMSG").innerHTML =
            "Thank you, your card information is approved. Please click the button below to save the data."
        }
        iFrameCreditCardNo = jsonData.cardNumber
        iFrameCreditaccountName = jsonData.accountName
        iFrameCreditcardExpDate = jsonData.cardExpDate
        IFrameCreditcardToken = jsonData.token
        _IFrameCreditcardType = jsonData.cardType
        _IFrameCreditamount = jsonData.amount
        _IFrameCreditcardOperation = jsonData.operation
        IFrameCreditcardsource = jsonData.source
        IFrameCreditcardsource = IFrameCreditcardsource.toUpperCase()
        iFrameCreditcardExpFullDate = getExpiryDateWithLastDay(iFrameCreditcardExpDate)
        _iFrameCreditcardExpFullDateIso = getExpiryDateWithISO(iFrameCreditcardExpDate)
      } else {
        _IsCreditCheckDone = true
        if (sourceIframeId === "mp-iFrameBN") {
          document.getElementById("mp-ICCMSG").innerHTML = ""
          document.getElementById("mp-iBNMSG").innerHTML =
            "Thank you, your bank information is approved. Please click on update button below to save the data."
        } else {
          document.querySelector(".update-card-info").classList.remove("disabled")
          document.querySelector(".update-card-info").disabled = false
          document.getElementById("payment-error-message").textContent = ""
          document.getElementById("payment-error-message").style.display = "none"
          document.getElementById("ICCMSG").innerHTML = ""
          document.getElementById("iBNMSG").innerHTML =
            "Thank you, your bank information is approved. Please click on update button below to save the data."
        }

        iFrameRoutingNo = jsonData.routingNumber
        iFrameaccountNumber = jsonData.accountNumber
        iFrameaccountName = jsonData.accountName
        iFrameaccountType = jsonData.accountType
        _iFrameBankamount = jsonData.amount
        iFrameBanktoken = jsonData.token
        _iFrameBankoperation = jsonData.operation
        iFrameBanksource = jsonData.source
        iFrameBanksource = iFrameBanksource.toUpperCase()
      }
    } else {
      _IsCreditCheckDone = false
      //         alert('Sorry, the account details were not verified');
    }
  })

  /* ----------------- make a payment functionality -------------------  */
  const amountField = document.getElementById("amountField")
  const amountButton = document.getElementById("amountCheckButton")
  const paymentField = document.getElementById("fwtoMain")
  const errorMessage = document.querySelector(".error-message")
  function getAccountBalance() {
__ea_trace("modules/self-serve/self-serve.ts","getAccountBalance",[],[]);
    const balanceElement = document.querySelector(".accountBalanceCol1 .amount p span")
    return balanceElement ? parseFloat(balanceElement.innerText.replace(/,/g, "")) : 0 // Remove commas & parse float
  }
  // Allow numbers and a single decimal point
  amountField.addEventListener("keypress", function (event) {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
    document.querySelectorAll(".success-message").forEach((el) => el.remove())
    const char = event.key
    const currentValue = this.value

    if (!/[0-9.]/.test(char) || (char === "." && currentValue.includes("."))) {
      event.preventDefault()
    }
  })
  amountField.addEventListener("paste", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
    document.querySelectorAll(".success-message").forEach((el) => el.remove())
    const pastedText = (event.clipboardData || window.clipboardData).getData("text")
    if (!/^\d*\.?\d*$/.test(pastedText)) {
      event.preventDefault()
    }
  })
  amountField.addEventListener("input", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
    document.querySelectorAll(".success-message").forEach((el) => el.remove())
    validateAmount()
  })
  amountButton.addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
    document.querySelectorAll(".success-message").forEach((el) => el.remove())
    if (validateAmount()) {
      document.querySelector(".checkAmountSectionWrapper").style.display = "none"
      paymentField.style.display = "block" // Show payment fields
    } else {
      document.querySelector(".checkAmountSectionWrapper").style.display = "block"
    }
  })
  function validateAmount() {
__ea_trace("modules/self-serve/self-serve.ts","validateAmount",[],[]);
    const enteredAmount = parseFloat(amountField.value) || 0
    const accountBalance = getAccountBalance()

    if (enteredAmount <= 0 || enteredAmount > accountBalance) {
      errorMessage.style.display = "block"
      paymentField.style.display = "none"
      return false
    } else {
      errorMessage.style.display = "none"
      //         document.querySelector('.payAmntOpt1').textContent  =  '$'+enteredAmount;
      return true
    }
  }
  /* ---------------- make a payment functionality -------------------  */

  function formatMoney(number) {
__ea_trace("modules/self-serve/self-serve.ts","formatMoney",[number],["number"]);
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(number)
  }

  var customerEmail = ""
  async function getDataFromSSPTable(_value) {
__ea_trace("modules/self-serve/self-serve.ts","getDataFromSSPTable",[_value],["_value"]);
    var billingType = storage.rawGet("billingType")
    var currentErStatus = storage.rawGet("currentErStatus")
    var hubDBEndpointHubDB = ""
    if (currentErStatus === "TBR" && billingType !== "Net Bill (RR)") {
      currentErStatus = currentErStatus.toLowerCase()
      var value = "Billing Type <> Net Bill (RR)"
      hubDBEndpointHubDB = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.erCriteria}/rows?portalId=${window.__ENV__.dataPortalId}&er_criteria__contains=${currentErStatus}&billing_type=${value}`
      document.querySelector(".accountBalance").style.display = "flex"
    } else if (currentErStatus === "TBR" && billingType === "Net Bill (RR)") {
      currentErStatus = currentErStatus.toLowerCase()
      var value = "Billing Type = Net Bill (RR)"
      hubDBEndpointHubDB = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.erCriteria}/rows?portalId=${window.__ENV__.dataPortalId}&er_criteria__contains=${currentErStatus}&billing_type=${value}`
      document.querySelector(".accountBalance").style.display = "flex"
    } else if (currentErStatus === "FNLD" && billingType !== "Net Bill (RR)") {
      currentErStatus = currentErStatus.toLowerCase()
      var value = "Billing Type <> Net Bill (RR)"
      hubDBEndpointHubDB = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.erCriteria}/rows?portalId=${window.__ENV__.dataPortalId}&er_criteria__contains=${currentErStatus}&billing_type=${value}`
      document.querySelector(".accountBalance").style.display = "flex"
    } else if (currentErStatus === "FNLD" && billingType === "Net Bill (RR)") {
      currentErStatus = currentErStatus.toLowerCase()
      var value = "Billing Type = Net Bill (RR)"
      hubDBEndpointHubDB = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.erCriteria}/rows?portalId=${window.__ENV__.dataPortalId}&er_criteria__contains=${currentErStatus}&billing_type=${value}`
      document.querySelector(".accountBalance").style.display = "flex"
    } else if (currentErStatus === "TBC" && billingType !== "Net Bill (RR)") {
      currentErStatus = currentErStatus.toLowerCase()
      var value = "Billing Type <> Net Bill (RR)"
      hubDBEndpointHubDB = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.erCriteria}/rows?portalId=${window.__ENV__.dataPortalId}&er_criteria__contains=${currentErStatus}&billing_type=${value}`
      document.querySelector(".accountBalance").style.display = "flex"
    } else if (currentErStatus === "TBC" && billingType === "Net Bill (RR)") {
      currentErStatus = currentErStatus.toLowerCase()
      var value = "Billing Type = Net Bill (RR)"
      hubDBEndpointHubDB = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.erCriteria}/rows?portalId=${window.__ENV__.dataPortalId}&er_criteria__contains=${currentErStatus}&billing_type=${value}`
      document.querySelector(".accountBalance").style.display = "flex"
    } else if (currentErStatus === "CUST" && billingType !== "Net Bill (RR)") {
      currentErStatus = currentErStatus.toLowerCase()
      var value = "Billing Type <> Net Bill (RR)"
      hubDBEndpointHubDB = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.erCriteria}/rows?portalId=${window.__ENV__.dataPortalId}&er_criteria__contains=${currentErStatus}&billing_type=${value}`
      document.querySelector(".accountBalance").style.display = "flex"
    } else if (currentErStatus === "CUST" && billingType === "Net Bill (RR)") {
      currentErStatus = currentErStatus.toLowerCase()
      var value = "Billing Type = Net Bill (RR)"
      hubDBEndpointHubDB = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.erCriteria}/rows?portalId=${window.__ENV__.dataPortalId}&er_criteria__contains=${currentErStatus}&billing_type=${value}`
      document.querySelector(".accountBalance").style.display = "flex"
    } else {
      var value = "Unknown"
      hubDBEndpointHubDB = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.erCriteria}/rows?portalId=${window.__ENV__.dataPortalId}&billing_type=${value}`
      document.querySelector(".accountBalance").style.display = "none"
    }

    fetch(hubDBEndpointHubDB, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
        const rows = data.objects
        if (rows.length >= 1) {
          rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
            var accountsummary = element.values[7]
            var updatePaymentInfo = element.values[8]
            var makePayment = element.values[9]
            var billPaymentHistory = element.values[10]
            var changePassword = element.values[11]
            var updateUtilityInfo = element.values[12]
            var contactPrefrences = element.values[13]
            var contracts = element.values[14]
            var enrollments = element.values[15]
            var firstBlockElement = 0
            var tabs = document.querySelectorAll(".ssmainsection-tabs ul li")
            tabs.forEach((t) => t.classList.remove("active"))

            if (accountsummary === 1) {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")

              var specificValue = "home"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "block"
                  ++firstBlockElement
                  if (firstBlockElement === 1) {
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .home").style.display = "block"
                  }
                }
              })
            } else {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "home"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "none"
                  document.querySelector(".ssmainsection-tabContent .home").style.display = "none"
                }
              })
            }
            if (updatePaymentInfo === 1) {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "update_payment_info"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "block"
                  ++firstBlockElement
                  if (firstBlockElement === 1) {
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .update_payment_info").style.display = "block"
                  }
                }
              })
            } else {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "update_payment_info"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "none"
                  document.querySelector(".ssmainsection-tabContent > .update_payment_info").style.display = "none"
                }
              })
            }
            if (makePayment === 1) {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "make_a_payment"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "block"
                  ++firstBlockElement
                  if (firstBlockElement === 1) {
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .make_a_payment").style.display = "block"
                  }
                }
              })
            } else {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "make_a_payment"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "none"
                  document.querySelector(".ssmainsection-tabContent > .make_a_payment").style.display = "none"
                }
              })
            }
            if (billPaymentHistory === 1) {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "bill_&_payment_history"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "block"
                  ++firstBlockElement
                  if (firstBlockElement === 1) {
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .bill_payment_history").style.display = "block"
                  }
                }
              })
            } else {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "bill_&_payment_history"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "none"
                  document.querySelector(".ssmainsection-tabContent > .bill_payment_history").style.display = "none"
                }
              })
            }
            if (changePassword === 1) {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "change_password"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "block"
                  ++firstBlockElement
                  if (firstBlockElement === 1) {
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .change_password").style.display = "block"
                  }
                }
              })
            } else {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "change_password"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "none"
                  document.querySelector(".ssmainsection-tabContent > .change_password").style.display = "none"
                }
              })
            }
            if (updateUtilityInfo === 1) {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "update_utility_login"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "block"
                  ++firstBlockElement
                  if (firstBlockElement === 1) {
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .update_utility_login").style.display = "block"
                  }
                }
              })
            } else {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "update_utility_login"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "none"
                  document.querySelector(".ssmainsection-tabContent > .update_utility_login").style.display = "none"
                }
              })
            }
            if (contactPrefrences === 1) {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "contact_preferences"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "block"
                  ++firstBlockElement
                  if (firstBlockElement === 1) {
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .contact_preferences").style.display = "block"
                  }
                }
              })
            } else {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "contact_preferences"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "none"
                  document.querySelector(".ssmainsection-tabContent > .contact_preferences").style.display = "none"
                }
              })
            }
            if (contracts === 1) {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "contracts"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "block"
                  ++firstBlockElement
                  if (firstBlockElement === 1) {
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .contracts").style.display = "block"
                  }
                }
              })
            } else {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "contracts"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "none"
                  document.querySelector(".ssmainsection-tabContent > .contracts").style.display = "none"
                }
              })
            }
            if (enrollments === 1) {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "enrollments"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "block"
                  ++firstBlockElement
                  if (firstBlockElement === 1) {
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .enrollments").style.display = "block"
                  }
                }
              })
            } else {
              var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
              var specificValue = "enrollments"
              liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                if (li.getAttribute("data") === specificValue) {
                  li.style.display = "none"
                  document.querySelector(".ssmainsection-tabContent > .enrollments").style.display = "none"
                }
              })
            }
            // closeProgressBar();
          })
        }
      })
  }
  async function getBills(value) {
__ea_trace("modules/self-serve/self-serve.ts","getBills",[value],["value"]);
    document.querySelector(".billLoader").style.display = "flex"
    var hubDBEndpointHubDB = `https://hansen.danmarcrm.com/dmcNSE.php?getBills=1&enrollNumber=${value}`
    var sentryClient = typeof Sentry !== "undefined" ? Sentry : null
    var requestPayload = {
      enrollNumber: value,
    }

    function addBillsBreadcrumb(message, data, level) {
__ea_trace("modules/self-serve/self-serve.ts","addBillsBreadcrumb",[message,data,level],["message","data","level"]);
      if (!sentryClient || typeof sentryClient.addBreadcrumb !== "function") {
        return
      }

      sentryClient.addBreadcrumb({
        category: "api.getBills",
        message: message,
        level: level || "info",
        data: data,
      })
    }

    var runGetBillsRequest = async () => {
__ea_trace("modules/self-serve/self-serve.ts","runGetBillsRequest",[],[]);
      addBillsBreadcrumb("Preparing getBills request", {
        method: "GET",
        url: hubDBEndpointHubDB,
        payload: requestPayload,
      })

      const response = await fetch(hubDBEndpointHubDB, {
        method: "GET",
      })

      addBillsBreadcrumb("Received getBills HTTP response", {
        status: response.status,
        ok: response.ok,
      })

      const data = await response.json()
      var statuss = data.Status
      var rows = data.Bills

      var docslocation = data.DocumentsLocation

      addBillsBreadcrumb("Parsed getBills response body", {
        status: statuss,
        billCount: Array.isArray(rows) ? rows.length : 0,
        hasDocumentsLocation: !!docslocation,
      })

      if (statuss !== "Not Found") {
        if (rows.length >= 1) {
          // Helper function to format a date string to 'dd-mm-yyyy'
          function formatDate(dateStr) {
__ea_trace("modules/self-serve/self-serve.ts","formatDate",[dateStr],["dateStr"]);
            const date = new Date(dateStr)
            const day = String(date.getDate()).padStart(2, "0")
            const month = String(date.getMonth() + 1).padStart(2, "0")
            const year = date.getFullYear()
            return `${month}/${day}/${year}`
          }

          // Sort rows by StatementDate (descending)
          rows.sort((a, b) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[a,b],["a","b"]);
            const dateA = new Date(a.StatementDate)
            const dateB = new Date(b.StatementDate)
            return dateB - dateA // most recent first
          })

          let items = ""
          rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
            const startDate = formatDate(element.ReadingStartDate)
            const endDate = formatDate(element.ReadingEndDate)
            const statementDate = formatDate(element.StatementDate)
            var totalbillamnt = formatMoney(element.TotalBillAmount)
            if (element.Documents.length !== 0) {
              items += `<div class="row">
                  <div class="row_inner"><p>${element.TransactionKey}</p></div>
                  <div class="row_inner"><p>${startDate}</p></div>
                  <div class="row_inner"><p>${endDate}</p></div>
                  <div class="row_inner"><p>${statementDate}</p></div>
                  <div class="row_inner"><p>${totalbillamnt}</p></div>
                  <div class="row_inner">
                      <a target="_blank" href="https://hansen.danmarcrm.com/__downloadedFiles/${element.Documents[0].DocumentKey}/${element.Documents[0].DocumentName}">View</a>
                  </div>
              </div>`
            }
          })

          document.querySelector(".bill_info_inner .row_inner_part").innerHTML = items
          addBillsBreadcrumb("Rendered bills into DOM", {
            renderedCount: rows.length,
          })
        }
      } else {
        addBillsBreadcrumb(
          "Bills not found from API",
          {
            status: statuss,
          },
          "warning",
        )
      }

      return {
        status: statuss,
        rows: rows,
        requestPayload: requestPayload,
        responseData: data,
      }
    }

    try {
      if (sentryClient && typeof sentryClient.startSpan === "function") {
        await sentryClient.startSpan(
          {
            op: "http.client",
            name: "GET dmcNSE.php getBills",
            attributes: {
              "http.method": "GET",
              "http.url": hubDBEndpointHubDB,
              "api.payload": JSON.stringify(requestPayload),
            },
          },
          async (span) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[span],["span"]);
            var result = await runGetBillsRequest()

            if (span && typeof span.setAttribute === "function") {
              span.setAttribute("api.response.status", String(result.status))
              span.setAttribute("api.response.bill_count", Array.isArray(result.rows) ? result.rows.length : 0)
              span.setAttribute("api.response.body", JSON.stringify(result.responseData))
            }
          },
        )
      } else {
        await runGetBillsRequest()
      }
    } catch (error) {
      addBillsBreadcrumb(
        "getBills request failed",
        {
          message: error?.message ? error.message : String(error),
          url: hubDBEndpointHubDB,
          payload: requestPayload,
        },
        "error",
      )

      if (sentryClient && typeof sentryClient.captureException === "function") {
        sentryClient.captureException(error, {
          tags: {
            functionName: "getBills",
          },
          extra: {
            method: "GET",
            url: hubDBEndpointHubDB,
            payload: requestPayload,
          },
        })
      }

      throw error
    } finally {
      document.querySelector(".billLoader").style.display = "none"
    }
  }
  async function paymentHistory(value) {
__ea_trace("modules/self-serve/self-serve.ts","paymentHistory",[value],["value"]);
    document.querySelector(".paymentLoader").style.display = "flex"
    var hubDBEndpointHubDB = `https://hansen.danmarcrm.com/dmcNSE.php?getPayments=1&enrollNumber=${value}`
    fetch(hubDBEndpointHubDB, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
        var statusHistory = data.Status
        var rowss = data.response

        if (statusHistory !== "Not Found") {
          if (rowss != null) {
            if (rowss.length >= 1) {
              // Helper function to format date from 'yyyy-mm-dd' or 'mm/dd/yyyy' to 'dd-mm-yyyy'
              function formatDate(dateStr) {
__ea_trace("modules/self-serve/self-serve.ts","formatDate",[dateStr],["dateStr"]);
                const date = new Date(dateStr)
                const day = String(date.getDate()).padStart(2, "0")
                const month = String(date.getMonth() + 1).padStart(2, "0")
                const year = date.getFullYear()
                return `${month}/${day}/${year}`
              }
              // Sort by dt_received (recent first)
              rowss.sort((a, b) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[a,b],["a","b"]);
                const dateA = new Date(a.dt_received.split(" ")[0])
                const dateB = new Date(b.dt_received.split(" ")[0])
                return dateB - dateA
              })
              let itemss = ""
              rowss.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
                //                         if(element.cd_status.split(".")[0] != 'ABANDONED'){
                const _dtReceivedFormatted = formatDate(element.dt_received.split(" ")[0])
                const dtToProcessFormatted = formatDate(element.dt_to_process.split(" ")[0])
                var totalbillqyamount = formatMoney(element.qy_amount.split(" ")[0])

                itemss += `<div class="row">
                      <div class="row_inner"><p>${element.ky_payment_hdr_seq.split(".")[0]}</p></div>
                      <div class="row_inner"><p>${dtToProcessFormatted}</p></div>
                      <div class="row_inner"><p>${totalbillqyamount}</p></div>
                  </div>`
                //                         }
              })
              //                     <div class="row_inner"><p>${dtReceivedFormatted}</p></div>
              document.querySelector(".payment_info .row_inner_part").innerHTML = itemss
              document.querySelector(".paymentLoader").style.display = "none"
            }
          } else {
            const itemss = '<div class="notFound">Payment history not found</div>'
            document.querySelector(".payment_info .row_inner_part").innerHTML = itemss
            document.querySelector(".paymentLoader").style.display = "none"
          }
        } else {
          const itemss = '<div class="notFound">Payment history not found</div>'
          document.querySelector(".payment_info .row_inner_part").innerHTML = itemss
          document.querySelector(".paymentLoader").style.display = "none"
        }
      })
  }
  async function getContracts(value) {
__ea_trace("modules/self-serve/self-serve.ts","getContracts",[value],["value"]);
    var hubDBEndpointHubDB = `https://hansen.danmarcrm.com/dmcNSE.php?apiVer=1&getContracts=true&enrollNumber=${value}`
    fetch(hubDBEndpointHubDB, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
        var statusContracts = data.Status
        var rowsss = data.Documents
        var docsLocation = data.DocumentsLocation
        if (statusContracts !== "Not Found") {
          if (rowsss != null) {
            if (rowsss.length >= 1) {
              // Helper function to format date to 'dd-mm-yyyy'
              function formatDate(dateStr) {
__ea_trace("modules/self-serve/self-serve.ts","formatDate",[dateStr],["dateStr"]);
                const date = new Date(dateStr)
                const day = String(date.getDate()).padStart(2, "0")
                const month = String(date.getMonth() + 1).padStart(2, "0")
                const year = date.getFullYear()
                return `${month}/${day}/${year}`
              }

              let itemsss = ""
              rowsss.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
                docsLocation.forEach((event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
                  Object.values(event).forEach((doc) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[doc],["doc"]);
                    if (event.Status !== "System Error" && event.Status !== "Not Authorized") {
                      if (doc.url.includes(element.DocumentName)) {
                        if (
                          element.DocumentSubType === "Terms & Conditions" ||
                          element.DocumentSubType === "AGREEMENT"
                        ) {
                          const formattedDate = formatDate(element.DocumentCreatedDate)
                          itemsss += `
                                          <div class="row">
                                              <div class="row_inner"><p>${element.DocumentKey}</p></div>
                                              <div class="row_inner"><p>${element.DocumentSubType.replace("&", "")}</p></div>
                                              <div class="row_inner"><p>${formattedDate}</p></div>
                                              <div class="row_inner"><a target="_blank" href="${doc.url}">View</a></div>
                                          </div>`
                        } else {
                        }
                      }
                    } else {
                    }
                  })
                })
              })

              document.querySelector(".contracts_info_inner .row_inner_part").innerHTML = itemsss
            }
          } else {
            const itemsss = '<div class="notFound">Contracts not found</div>'
            document.querySelector(".contracts_info_inner .row_inner_part").innerHTML = itemsss
          }
        } else {
          const itemsss = '<div class="notFound">Contracts not found</div>'
          document.querySelector(".contracts_info_inner .row_inner_part").innerHTML = itemsss
        }
        //         closeProgressBar();
      })
  }
  document.addEventListener("DOMContentLoaded", async () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
    // let stripe, elements, paymentElement;
    var stripe = ""
    var elements = ""
    var elementsMp = ""
    var paymentElement = ""
    var paymentElementMp = ""
    async function updateStripeCustomerId(value) {
__ea_trace("modules/self-serve/self-serve.ts","updateStripeCustomerId",[value],["value"]);
      //         var paymentAmount = document.querySelector('#amountField').value;
      var subscriptionID = storage.rawGet("selectedSubscriptionId")
      let paymentData
      paymentData = {
        subscriptionId: subscriptionID,
        properties: {
          stripe_customer_id: value,
        },
      }

      try {
        const updateResponse = await fetch('/_hcms/api/update-subscription-data', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData),
        })

        const updateResult = await updateResponse.json()
        responseFromAPI = JSON.stringify(updateResult)

        if (updateResult.status === "success") {
        } else {
          throw new Error("Failed to update Customer Id in Subscription record.")
        }
      } catch (error) {
        closeProgressBar()
        console.error("❌ Error Updating Subscription:", error)
      }
    }
    async function initializeStripeUp() {
__ea_trace("modules/self-serve/self-serve.ts","initializeStripeUp",[],[]);
      try {
        // TODO: GRRRRRR
        stripe = Stripe(
          "pk_live_51JXAglFcE6xpXM1PYkO5cQWow0PbPrjzBS1QSoy7JZJg3SQjo7KwcKkfUeqsniU8HBUgsHregSMuTCVdjjx3FaRN003bqVtFDB",
        )
        const customer_email = storage.rawGet("logEmail")
        const customer_id = storage.rawGet("StripeCustomerId")
        const _amount = 50

        const res = await fetch("https://stripe.nautilussolar.com/stripeserver/setup/create", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ customer_email, customer_id }),
        })

        if (!res.ok) {
          throw new Error(`Setup intent creation failed with status ${res.status}`)
        }

        const data = await res.json()
        const clientSecret = data.clientSecret

        if (data.customerId) {
          storage.rawSet("StripeCustomerId", data.customerId)
          await updateStripeCustomerId(data.customerId)
        }

        elements = stripe.elements({
          clientSecret,
          wallets: {
            link: false, // 🔒 THIS DISABLES LINK
          },
        })

        elementsMp = stripe.elements({
          clientSecret,
          wallets: {
            link: false, // 🔒 THIS DISABLES LINK
          },
        })
        paymentElement = elements.create("payment")
        paymentElementMp = elementsMp.create("payment")
        paymentElement.mount("#payment-elementUp")
        paymentElementMp.mount("#payment-element")

        paymentElement.on("change", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
          if (event.value?.type) {
            const selectedMethod = event.value.type

            const methodMessage = document.getElementById("method-messageUp")
            if (selectedMethod === "card") {
              methodMessage.textContent = ""
            } else if (selectedMethod === "us_bank_account") {
              methodMessage.textContent = ""
            } else {
              methodMessage.textContent = ""
            }
          }
        })

        paymentElementMp.on("change", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
          if (event.value?.type) {
            const selectedMethod = event.value.type

            const methodMessage = document.getElementById("method-message")
            if (selectedMethod === "card") {
              methodMessage.textContent = ""
            } else if (selectedMethod === "us_bank_account") {
              methodMessage.textContent = ""
            } else {
              methodMessage.textContent = ""
            }
          }
        })
      } catch (error) {
        console.error("Error during Stripe initialization:", error)
        alert("There was an error initializing the payment form. Please try again later.")
      }
    }

    // call it on page load
    var _stripe_amountUp = ""
    var _stripe_currencyUp = ""
    var stripe_payment_idUp = ""
    var stripe_microdeposittypeUp = ""
    var stripe_microdeposittypeMp = ""
    var stripe_payment_statusUp = ""
    var stripe_payment_methodUp = ""
    var stripe_payment_method_idUp = ""
    var stripe_transaction_responseUp = ""
    var stripe_payment_receipt_emailUp = ""
    var _stripe_payment_verification_methodUp = ""
    var microdepostiType = ""
    var _microdepostiTypeMp = ""

    var billingTypeUp = ""
    var billingDetailsUp = ""
    var billingResponseUp = ""
    var billingStatusUp = ""
    var billingStatusMp = ""
    var StripeCCbrandUp = ""
    var StripeCCCountryUp = ""
    var StripeCCExpMonthUp = ""
    var StripeCCExpYearUp = ""
    var StripeCCLast4Up = ""
    var StripeACHLast4Up = ""
    var _StripeWalletUp = ""
    var StripeAccountHolderUp = ""
    var StripeAccountTypeUp = ""
    var StripeBankNameUp = ""
    var _StripeFinancialConnectionAccUp = ""
    var _StripeFingerPrintUp = ""
    var StripeRountingNumberUp = ""
    var StripePaymentMethodUp = ""
    var StripeCCUserAuthUp = "false"
    var StripeAchUserAuthUp = "false"
    var successMessageUp = ""
    var _paymentServiceProviderUp = ""
    var IsStripeFormDone = false
    var IsStripeFormDoneUp = false
    var isAllContractDone = false
    var StripeCustomerId = ""
    var setupIntentResponse = ""
    var setupIntentResponseMp = ""

    async function getPaymentDetailBasedOnPaymentMethodIdUp() {
__ea_trace("modules/self-serve/self-serve.ts","getPaymentDetailBasedOnPaymentMethodIdUp",[],[]);
      const res = await fetch("https://stripe.nautilussolar.com/stripeserver/payment/get-payment-method-by-id", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ payment_method_id: stripe_payment_method_idUp }),
      })

      const paymentMethodDetailsUp = await res.json()
      billingResponseUp = JSON.stringify(paymentMethodDetailsUp)
      billingDetailsUp = JSON.stringify(paymentMethodDetailsUp.billing_details)
      billingTypeUp = JSON.stringify(paymentMethodDetailsUp.type)
      StripeCustomerId = JSON.stringify(paymentMethodDetailsUp.customer)

      if (paymentMethodDetailsUp.type === "card") {
        StripeCCbrandUp = paymentMethodDetailsUp.card.brand
        StripeCCCountryUp = paymentMethodDetailsUp.card.country
        StripeCCExpMonthUp = paymentMethodDetailsUp.card.exp_month
        StripeCCExpYearUp = paymentMethodDetailsUp.card.exp_year
        StripeCCLast4Up = paymentMethodDetailsUp.card.last4
        _StripeWalletUp = paymentMethodDetailsUp.card.wallet
        StripeCCUserAuthUp = "true"
        StripeAchUserAuthUp = "false"
        StripePaymentMethodUp = "Credit Card"
        successMessageUp = "Thank you, we have saved your preferred payment method."
        IsStripeFormDoneUp = true
      } else if (paymentMethodDetailsUp.type === "us_bank_account") {
        StripeAccountHolderUp = paymentMethodDetailsUp.us_bank_account.account_holder_type
        StripeAccountTypeUp = paymentMethodDetailsUp.us_bank_account.account_type
        StripeBankNameUp = paymentMethodDetailsUp.us_bank_account.bank_name
        _StripeFinancialConnectionAccUp = paymentMethodDetailsUp.us_bank_account.financial_connections_account
        StripeACHLast4Up = paymentMethodDetailsUp.us_bank_account.last4
        _StripeFingerPrintUp = paymentMethodDetailsUp.us_bank_account.fingerprint
        StripeRountingNumberUp = paymentMethodDetailsUp.us_bank_account.routing_number
        StripeCCUserAuthUp = "false"
        StripeAchUserAuthUp = "true"
        StripePaymentMethodUp = "ACH"
        successMessageUp = "Thank you, we have saved your preferred payment method."
        IsStripeFormDoneUp = true
        if (setupIntentResponse.next_action !== "null" && setupIntentResponse.next_action != null) {
          stripe_microdeposittypeUp = setupIntentResponse.next_action.verify_with_microdeposits.microdeposit_type
        }
      } else {
        StripeCCbrandUp = ""
        StripeCCCountryUp = ""
        StripeCCExpMonthUp = ""
        StripeCCExpYearUp = ""
        StripeCCLast4Up = ""
        StripeACHLast4Up = ""
        _StripeWalletUp = ""
        StripeAccountHolderUp = ""
        StripeAccountTypeUp = ""
        StripeBankNameUp = ""
        _StripeFinancialConnectionAccUp = ""
        _StripeFingerPrintUp = ""
        StripeRountingNumberUp = ""
        StripeCCUserAuthUp = "false"
        StripeAchUserAuthUp = "false"
        StripePaymentMethodUp = ""
        successMessageUp = ""
        IsStripeFormDoneUp = false
      }
      await updateStripeBillingDetailUp()
    }
    async function getPaymentDetailBasedOnPaymentMethodId() {
__ea_trace("modules/self-serve/self-serve.ts","getPaymentDetailBasedOnPaymentMethodId",[],[]);
      const res = await fetch("https://stripe.nautilussolar.com/stripeserver/payment/get-payment-method-by-id", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ payment_method_id: stripe_payment_method_idUp }),
      })

      const paymentMethodDetailsUp = await res.json()
      billingResponseUp = JSON.stringify(paymentMethodDetailsUp)
      billingDetailsUp = JSON.stringify(paymentMethodDetailsUp.billing_details)
      billingTypeUp = JSON.stringify(paymentMethodDetailsUp.type)
      StripeCustomerId = JSON.stringify(paymentMethodDetailsUp.customer)

      if (paymentMethodDetailsUp.type === "card") {
        StripeCCbrandUp = paymentMethodDetailsUp.card.brand
        StripeCCCountryUp = paymentMethodDetailsUp.card.country
        StripeCCExpMonthUp = paymentMethodDetailsUp.card.exp_month
        StripeCCExpYearUp = paymentMethodDetailsUp.card.exp_year
        StripeCCLast4Up = paymentMethodDetailsUp.card.last4
        _StripeWalletUp = paymentMethodDetailsUp.card.wallet
        StripeCCUserAuthUp = "true"
        StripeAchUserAuthUp = "false"
        StripePaymentMethodUp = "Credit Card"
        successMessageUp = "Thank you, we have saved your preferred payment method."
        IsStripeFormDone = true
        document.querySelector("#mp-strp-update-card-info").style.display = "block"
      } else if (paymentMethodDetailsUp.type === "us_bank_account") {
        StripeAccountHolderUp = paymentMethodDetailsUp.us_bank_account.account_holder_type
        StripeAccountTypeUp = paymentMethodDetailsUp.us_bank_account.account_type
        StripeBankNameUp = paymentMethodDetailsUp.us_bank_account.bank_name
        _StripeFinancialConnectionAccUp = paymentMethodDetailsUp.us_bank_account.financial_connections_account
        StripeACHLast4Up = paymentMethodDetailsUp.us_bank_account.last4
        _StripeFingerPrintUp = paymentMethodDetailsUp.us_bank_account.fingerprint
        StripeRountingNumberUp = paymentMethodDetailsUp.us_bank_account.routing_number
        StripeCCUserAuthUp = "false"
        StripeAchUserAuthUp = "true"
        StripePaymentMethodUp = "ACH"
        successMessageUp = "Thank you, we have saved your preferred payment method."
        IsStripeFormDone = true
        document.querySelector("#mp-strp-update-card-info").style.display = "block"
        if (setupIntentResponse.next_action !== "null" && setupIntentResponse.next_action != null) {
          stripe_microdeposittypeMp = setupIntentResponse.next_action.verify_with_microdeposits.microdeposit_type
        }
      } else {
        StripeCCbrandUp = ""
        StripeCCCountryUp = ""
        StripeCCExpMonthUp = ""
        StripeCCExpYearUp = ""
        StripeCCLast4Up = ""
        StripeACHLast4Up = ""
        _StripeWalletUp = ""
        StripeAccountHolderUp = ""
        StripeAccountTypeUp = ""
        StripeBankNameUp = ""
        _StripeFinancialConnectionAccUp = ""
        _StripeFingerPrintUp = ""
        StripeRountingNumberUp = ""
        StripeCCUserAuthUp = "false"
        StripeAchUserAuthUp = "false"
        StripePaymentMethodUp = ""
        successMessageUp = ""
        IsStripeFormDone = false
        document.querySelector("#mp-strp-update-card-info").style.display = "none"
      }
      await updateStripeBillingDetail()
    }
    async function updateStripeBillingDetailUp() {
__ea_trace("modules/self-serve/self-serve.ts","updateStripeBillingDetailUp",[],[]);
      //         var paymentAmount = document.querySelector('#amountField').value;
      var subscriptionID = storage.rawGet("selectedSubscriptionId")
      if (StripeAccountHolderUp === "individual" && StripeAccountTypeUp === "checking") {
        StripeAccountTypeUp = "Personal Checking"
      } else if (StripeAccountHolderUp === "individual" && StripeAccountTypeUp === "savings") {
        StripeAccountTypeUp = "Personal Savings"
      }
      let paymentData
      paymentData = {
        subscriptionId: subscriptionID,
        //                         paymentType: "Credit Card",
        properties: {
          stripe_billing_type: billingTypeUp,
          stripe_billing_details: billingDetailsUp,
          stripe_billing_response: billingResponseUp,
          stripe_cc_bnrand: StripeCCbrandUp,
          stripe_country: StripeCCCountryUp,
          cc_last_4: StripeCCLast4Up,
          cc_exp: `${StripeCCExpMonthUp}/${StripeCCExpYearUp}`,
          cc_exp_date: `${StripeCCExpMonthUp}/${StripeCCExpYearUp}`,
          stripe_customer_id: StripeCustomerId,
          //                 token_expiration_date: '',
          cc_user_auth: StripeCCUserAuthUp,
          card_type: StripeCCbrandUp,
          wallet_token: stripe_payment_method_idUp,
          payment_vendor: "STRIPE",
          ach_name: StripeBankNameUp,
          ach_rout_number: StripeRountingNumberUp,
          ach_account_number: StripeACHLast4Up,
          ach_account_type: StripeAccountTypeUp,
          ach_user_auth: StripeAchUserAuthUp,
          payment_method: StripePaymentMethodUp,
          billing_status: billingStatusUp,
          microdeposit_type: stripe_microdeposittypeUp,
        },
      }

      try {
        const updateResponse = await fetch('/_hcms/api/update-subscription-data', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData),
        })

        const updateResult = await updateResponse.json()
        responseFromAPI = JSON.stringify(updateResult)

        if (updateResult.status === "success") {
          const errorMessageUp = document.getElementById("up-strp-payment-error-message")
          errorMessageUp.textContent = ""
          errorMessageUp.style.display = "none"
          const errorMessageUp1 = document.getElementById("error-messageUp")
          errorMessageUp1.textContent = ""
          errorMessageUp1.style.display = "none"
          document.querySelector("#success-messageUp").textContent = successMessageUp
          document.querySelector("#success-messageUp").style.color = "#006AC6"
          setTimeout(() => (document.querySelector("#success-messageUp").textContent = ""), 10000)
          closeProgressBar()
        } else {
          closeProgressBar()
          console.error("❌ Update Failed:", updateResult)
          throw new Error("Failed to update subscription with payment details.")
        }
      } catch (error) {
        closeProgressBar()
        console.error("❌ Error Updating Subscription:", error)
      }
    }
    async function updateManualACHDetailUp() {
__ea_trace("modules/self-serve/self-serve.ts","updateManualACHDetailUp",[],[]);
      var subscriptionID = storage.rawGet("selectedSubscriptionId")
      let paymentData
      paymentData = {
        subscriptionId: subscriptionID,
        properties: {
          stripe_billing_type: billingTypeUp,
          stripe_billing_details: billingDetailsUp,
          stripe_billing_response: billingResponseUp,
          stripe_cc_bnrand: StripeCCbrandUp,
          stripe_country: StripeCCCountryUp,
          wallet_token: stripe_payment_method_idUp,
          payment_vendor: "STRIPE",
          ach_name: StripeBankNameUp,
          ach_rout_number: StripeRountingNumberUp,
          ach_account_number: StripeACHLast4Up,
          ach_account_type: StripeAccountTypeUp,
          ach_user_auth: StripeAchUserAuthUp,
          payment_method: StripePaymentMethodUp,
          billing_status: billingStatusUp,
          microdeposit_type: stripe_microdeposittypeUp,
        },
      }

      try {
        const updateResponse = await fetch('/_hcms/api/update-subscription-data', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData),
        })

        const updateResult = await updateResponse.json()
        responseFromAPI = JSON.stringify(updateResult)

        if (updateResult.status === "success") {
          const errorMessageUp = document.getElementById("up-strp-payment-error-message")
          errorMessageUp.textContent = ""
          errorMessageUp.style.display = "none"
          const errorMessageUp1 = document.getElementById("error-messageUp")
          errorMessageUp1.textContent = ""
          errorMessageUp1.style.display = "none"
          document.querySelector("#success-messageUp").textContent = successMessageUp
          document.querySelector("#success-messageUp").style.color = "#006AC6"
          setTimeout(() => (document.querySelector("#success-messageUp").textContent = ""), 10000)
          if (billingStatusUp === "requires_action") {
            document.querySelector("#ACHDepositButtonUp").style.display = "none"
            document.querySelector("#stripeBankCreditMainUp").style.display = "none"
            if (stripe_microdeposittypeUp === "descriptor_code") {
              document.querySelector(".achVerificationMainUp #andtext").innerHTML =
                "<span>Please verify the Descriptor code from Stripe into your bank account.</span><br><h4>Stripe Descriptor code can take 2 - 3 days to enter your account. If you do not see any Descriptor code from Stripe, please come back later.</h4>"
            } else {
              document.querySelector(".achVerificationMainUp #andtext").innerHTML =
                "<span>Please verify the two deposits from Stripe into your bank account.</span><br><h4>Stripe deposits can take 2 - 3 days to enter your account. If you do not see any deposits from Stripe, please come back later.</h4>"
            }
            document.querySelector("#achVerificationMainUp").style.display = "block"
          } else {
            document.querySelector("#stripeBankCreditMainUp").style.display = "block"
            document.querySelector("#achVerificationMainUp").style.display = "none"
          }
          closeProgressBar()
        } else {
          closeProgressBar()
          console.error("❌ Update Failed:", updateResult)
          throw new Error("Failed to update subscription with payment details.")
        }
      } catch (error) {
        closeProgressBar()
        console.error("❌ Error Updating Subscription:", error)
      }
    }
    async function updateManualACHDetailMp() {
__ea_trace("modules/self-serve/self-serve.ts","updateManualACHDetailMp",[],[]);
      var subscriptionID = storage.rawGet("selectedSubscriptionId")
      let paymentData
      paymentData = {
        subscriptionId: subscriptionID,
        //                         paymentType: "Credit Card",
        properties: {
          stripe_billing_type: billingTypeUp,
          stripe_billing_details: billingDetailsUp,
          stripe_billing_response: billingResponseUp,
          stripe_cc_bnrand: StripeCCbrandUp,
          stripe_country: StripeCCCountryUp,
          wallet_token: stripe_payment_method_idUp,
          payment_vendor: "STRIPE",
          ach_name: StripeBankNameUp,
          ach_rout_number: StripeRountingNumberUp,
          ach_account_number: StripeACHLast4Up,
          ach_account_type: StripeAccountTypeUp,
          ach_user_auth: StripeAchUserAuthUp,
          payment_method: StripePaymentMethodUp,
          billing_status_mp: billingStatusMp,
          microdeposit_type_mp: stripe_microdeposittypeMp,
        },
      }

      try {
        const updateResponse = await fetch('/_hcms/api/update-subscription-data', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData),
        })

        const updateResult = await updateResponse.json()
        responseFromAPI = JSON.stringify(updateResult)

        if (updateResult.status === "success") {
          const errorMessage = document.getElementById("mp-strp-payment-error-message")
          errorMessage.textContent = ""
          errorMessage.style.display = "none"
          const errorMessage1 = document.getElementById("error-message")
          errorMessage1.textContent = ""
          errorMessage1.style.display = "none"
          document.querySelector("#success-messageMp").textContent = successMessageUp
          document.querySelector("#success-messageMp").style.color = "#006AC6"
          setTimeout(() => (document.querySelector("#success-messageMp").textContent = ""), 10000)
          if (billingStatusMp === "requires_action") {
            document.querySelector("#ACHDepositButton").style.display = "none"
            document.querySelector("#stripeBankCreditMain").style.display = "none"
            if (stripe_microdeposittypeMp === "descriptor_code") {
              document.querySelector(".achVerificationMain #andtextMp").innerHTML =
                "<span>Please verify the Descriptor code from Stripe into your bank account.</span><br><h4>Stripe Descriptor code can take 2 - 3 days to enter your account. If you do not see any Descriptor code from Stripe, please come back later.</h4>"
            } else {
              document.querySelector(".achVerificationMain #andtextMp").innerHTML =
                "<span>Please verify the two deposits from Stripe into your bank account.</span><br><h4>Stripe deposits can take 2 - 3 days to enter your account. If you do not see any deposits from Stripe, please come back later.</h4>"
            }
            document.querySelector("#achVerificationMain").style.display = "block"
          } else {
            document.querySelector("#stripeBankCreditMain").style.display = "block"
            document.querySelector("#achVerificationMain").style.display = "none"
          }
          closeProgressBar()
        } else {
          closeProgressBar()
          console.error("❌ Update Failed:", updateResult)
          throw new Error("Failed to update subscription with payment details.")
        }
      } catch (error) {
        closeProgressBar()
        console.error("❌ Error Updating Subscription:", error)
      }
    }
    async function updateStripePaymentDetailUp() {
__ea_trace("modules/self-serve/self-serve.ts","updateStripePaymentDetailUp",[],[]);
      //         var paymentAmount = document.querySelector('#amountField').value;
      var subscriptionID = storage.rawGet("selectedSubscriptionId")
      let paymentData
      paymentData = {
        subscriptionId: subscriptionID,
        properties: {
          stripe_payment_id: stripe_payment_idUp,
          stripe_payment_status: stripe_payment_statusUp,
          stripe_payment_method: stripe_payment_methodUp,
          stripe_payment_method_id: stripe_payment_method_idUp,
          stripe_transaction_response: stripe_transaction_responseUp,
          stripe_payment_receipt_email: stripe_payment_receipt_emailUp,
        },
      }

      try {
        const updateResponse = await fetch('/_hcms/api/update-subscription-data', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData),
        })

        const updateResult = await updateResponse.json()
        responseFromAPI = JSON.stringify(updateResult)

        if (updateResult.status === "success") {
          //                         alert("🎉 Payment details updated successfully in the service action record!");
        } else {
          closeProgressBar()
          console.error("❌ Update Failed:", updateResult)
          throw new Error("Failed to update subscription with payment details.")
        }
      } catch (error) {
        closeProgressBar()
        console.error("❌ Error Updating Subscription:", error)
      }
    }

    async function updateStripeBillingDetail() {
__ea_trace("modules/self-serve/self-serve.ts","updateStripeBillingDetail",[],[]);
      //         var paymentAmount = document.querySelector('#amountField').value;
      var subscriptionID = storage.rawGet("selectedSubscriptionId")
      if (StripeAccountHolderUp === "individual" && StripeAccountTypeUp === "checking") {
        StripeAccountTypeUp = "Personal Checking"
      } else if (StripeAccountHolderUp === "individual" && StripeAccountTypeUp === "savings") {
        StripeAccountTypeUp = "Personal Savings"
      }
      let paymentData
      paymentData = {
        subscriptionId: subscriptionID,
        //                         paymentType: "Credit Card",
        properties: {
          stripe_billing_type: billingTypeUp,
          stripe_billing_details: billingDetailsUp,
          stripe_billing_response: billingResponseUp,
          stripe_cc_bnrand: StripeCCbrandUp,
          stripe_country: StripeCCCountryUp,
          stripe_customer_id: StripeCustomerId,
          cc_last_4: StripeCCLast4Up,
          cc_exp: `${StripeCCExpMonthUp}/${StripeCCExpYearUp}`,
          cc_exp_date: `${StripeCCExpMonthUp}/${StripeCCExpYearUp}`,
          //                 token_expiration_date: '',
          cc_user_auth: StripeCCUserAuthUp,
          card_type: StripeCCbrandUp,
          wallet_token: stripe_payment_method_idUp,
          payment_vendor: "STRIPE",
          ach_name: StripeBankNameUp,
          ach_rout_number: StripeRountingNumberUp,
          ach_account_number: StripeACHLast4Up,
          ach_account_type: StripeAccountTypeUp,
          ach_user_auth: StripeAchUserAuthUp,
          payment_method: StripePaymentMethodUp,
          billing_status_mp: billingStatusMp,
          microdeposit_type_mp: stripe_microdeposittypeMp,
        },
      }

      try {
        const updateResponse = await fetch('/_hcms/api/update-subscription-data', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData),
        })

        const updateResult = await updateResponse.json()
        responseFromAPI = JSON.stringify(updateResult)

        if (updateResult.status === "success") {
          const errorMessage = document.getElementById("mp-strp-payment-error-message")
          errorMessage.textContent = ""
          errorMessage.style.display = "none"
          const errorMessage1 = document.getElementById("error-message")
          errorMessage1.textContent = ""
          errorMessage1.style.display = "none"
          document.querySelector("#success-messageMp").textContent = successMessageUp
          document.querySelector("#success-messageMp").style.color = "#006AC6"
          setTimeout(() => (document.querySelector("#success-message").textContent = ""), 10000)
          closeProgressBar()
        } else {
          closeProgressBar()
          console.error("❌ Update Failed:", updateResult)
          throw new Error("Failed to update subscription with payment details.")
        }
      } catch (error) {
        closeProgressBar()
        console.error("❌ Error Updating Subscription:", error)
      }
    }

    document.getElementById("submitUp").addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
      e.preventDefault()
      openProgressBar("We are saving your payment information")
      document.querySelector("#success-messageUp").textContent = ""
      const errorMessageUp = document.getElementById("error-messageUp")

      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: "/thank-you",
        },
        redirect: "if_required", // prevents full redirect if not needed
      })

      if (error) {
        console.error(error)
        errorMessageUp.textContent = error.message
        closeProgressBar()
      } else {
        setupIntentResponse = setupIntent
        stripe_payment_idUp = setupIntent.id
        stripe_payment_statusUp = setupIntent.status
        stripe_payment_methodUp = JSON.stringify(setupIntent.payment_method_options)
        stripe_payment_method_idUp = setupIntent.payment_method
        stripe_transaction_responseUp = JSON.stringify(setupIntent)

        billingStatusUp = setupIntent.status

        if (setupIntent.object === "setup_intent") {
          if (setupIntent.next_action !== "null" && setupIntentResponse.next_action != null) {
            stripe_microdeposittypeUp = setupIntentResponse.next_action.verify_with_microdeposits.microdeposit_type
            document.querySelector("#up-strp-jnpiays-update").style.display = "none"
            await updateManualACHDetailUp()
          } else {
            await updateStripePaymentDetailUp()
            await getPaymentDetailBasedOnPaymentMethodIdUp()
          }
        } else {
          await updateStripePaymentDetailUp()
          await getPaymentDetailBasedOnPaymentMethodIdUp()
        }
      }
    })
    document.getElementById("submit").addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
      e.preventDefault()
      openProgressBar("We are saving your payment information")
      document.querySelector("#success-messageMp").textContent = ""
      const errorMessage = document.getElementById("error-message")

      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: "/thank-you",
        },
        redirect: "if_required", // prevents full redirect if not needed
      })

      if (error) {
        console.error(error)
        errorMessage.textContent = error.message
        closeProgressBar()
      } else {
        setupIntentResponseMp = setupIntent
        stripe_payment_idUp = setupIntent.id
        stripe_payment_statusUp = setupIntent.status
        stripe_payment_methodUp = JSON.stringify(setupIntent.payment_method_options)
        stripe_payment_method_idUp = setupIntent.payment_method
        stripe_transaction_responseUp = JSON.stringify(setupIntent)

        billingStatusMp = setupIntent.status
        if (setupIntent.object === "setup_intent") {
          if (setupIntent.next_action !== "null" && setupIntentResponse.next_action != null) {
            stripe_microdeposittypeMp = setupIntentResponseMp.next_action.verify_with_microdeposits.microdeposit_type
            document.querySelector("#mp-strp-update-card-info").style.display = "none"
            await updateManualACHDetailMp()
          } else {
            await updateStripePaymentDetailUp()
            await getPaymentDetailBasedOnPaymentMethodId()
          }
        } else {
          await updateStripePaymentDetailUp()
          await getPaymentDetailBasedOnPaymentMethodId()
        }
      }
    })

    /* ----- Ach Verification method ------- */
    var paymentMethodIdUp = ""
    var _paymentMethodUp = ""
    var paymentIdUp = ""
    async function _GetPaymentMethodIdUp() {
__ea_trace("modules/self-serve/self-serve.ts","_GetPaymentMethodIdUp",[],[]);
      openProgressBar()
      //         var email = storage.rawGet("userEmail");
      var dealId = storage.rawGet("dealId")
      var _catchdata = ""
      try {
        const data = {
          deal_id: dealId,
        }
        const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
        _catchdata = data
        const dataa = await response.json()
        responseFromAPI = JSON.stringify(dataa)
        if (dataa.message === "No User Found") {
        } else if (dataa.message === "User Found") {
          paymentMethodIdUp = dataa.userValue.properties.stripe_payment_method_id
          paymentMethodIdUp = paymentMethodIdUp
          _paymentMethodUp = dataa.userValue.properties.stripe_payment_method
          paymentIdUp = dataa.userValue.properties.stripe_payment_id
          microdepostiType = dataa.userValue.properties.microdeposit_type
          paymentIdUp = paymentIdUp
          closeProgressBar()
          if (microdepostiType === "amounts") {
            document.getElementById("ACHDepositAmount1Up").style.display = "block"
            document.getElementById("ACHDepositAmount2Up").style.display = "block"
            document.getElementById("descriptorCode").style.display = "none"
            document.getElementById("descriptorCodeLabel").style.display = "none"
            document.querySelector(".achVerificationMainUp #andtext").style.display = "none"
          } else if (microdepostiType === "descriptor_code") {
            document.getElementById("ACHDepositAmount1Up").style.display = "none"
            document.getElementById("ACHDepositAmount2Up").style.display = "none"
            document.getElementById("descriptorCode").style.display = "block"
            document.getElementById("descriptorCodeLabel").style.display = "block"
            document.querySelector(".achVerificationMainUp #andtext").style.display = "none"
          } else {
            document.getElementById("ACHDepositAmount1Up").style.display = "none"
            document.getElementById("ACHDepositAmount2Up").style.display = "none"
            document.getElementById("descriptorCode").style.display = "none"
            document.getElementById("descriptorCodeLabel").style.display = "none"
            document.querySelector(".achVerificationMainUp #andtext").style.display = "block"
          }
        }
      } catch (error) {
        console.error("Error:", error)
      }
    }

    function enforceTwoTwoFormatUp(inputId, errorId) {
__ea_trace("modules/self-serve/self-serve.ts","enforceTwoTwoFormatUp",[inputId,errorId],["inputId","errorId"]);
      const input = document.getElementById(inputId)
      const error = document.getElementById(errorId)

      input.addEventListener("input", (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
        let val = e.target.value

        // Remove all non-numeric and non-dot characters
        val = val.replace(/[^0-9.]/g, "")

        // Enforce only one dot
        const dotIndex = val.indexOf(".")
        if (dotIndex !== -1) {
          const beforeDot = val.substring(0, dotIndex).slice(0, 2) // Max 2 digits before dot
          const afterDot = val.substring(dotIndex + 1).slice(0, 2) // Max 2 digits after dot
          val = `${beforeDot}.${afterDot}`
        } else {
          // If no dot, allow max 2 digits only
          val = val.slice(0, 2)
        }

        input.value = val

        const validPattern = /^(\d{0,2})\.\d{2}$/
        if (!validPattern.test(val)) {
          error.textContent = "Enter a valid amount in format: .33, 0.33, or 11.33"
          input.style.borderColor = "red"
        } else {
          error.textContent = ""
          input.style.borderColor = ""
        }
      })
    }

    // Apply to both inputs
    enforceTwoTwoFormatUp("ACHDepositAmount1Up", "ACHDepositAmount1-error-messageUp")
    enforceTwoTwoFormatUp("ACHDepositAmount2Up", "ACHDepositAmount2-error-messageUp")

    document.getElementById("ach-verification-formUp").addEventListener("submit", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
      e.preventDefault()
      openProgressBar()

      const setup_intent_id = paymentIdUp
      const amount1 = document.getElementById("ACHDepositAmount1Up").value.trim()
      const amount2 = document.getElementById("ACHDepositAmount2Up").value.trim()
      const discriptorCode = document.getElementById("descriptorCode").value.trim()
      const resultBox = document.getElementById("finalCheck-errorUp")

      if (microdepostiType === "amounts") {
        if (!setup_intent_id || !amount1 || Number.isNaN(amount1) || !amount2 || Number.isNaN(amount2)) {
          resultBox.textContent = "Please enter valid numbers and payment method ID."
          resultBox.style.color = "red"
          closeProgressBar()
          return
        }
      } else if (microdepostiType === "descriptor_code") {
        if (!setup_intent_id || !discriptorCode) {
          resultBox.textContent = "Please enter valid discriptor Code and payment method ID."
          resultBox.style.color = "red"
          closeProgressBar()
          return
        }
      } else {
        if (!setup_intent_id || !amount1 || Number.isNaN(amount1) || !amount2 || Number.isNaN(amount2)) {
          resultBox.textContent = "Please enter valid numbers and payment method ID."
          resultBox.style.color = "red"
          closeProgressBar()
          return
        }
      }

      try {
        const response = await fetch("https://stripe.nautilussolar.com/stripeserver/ping", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })

        const res = await response.json()
        if (res.success) {
          try {
            if (microdepostiType === "amounts") {
              const response = await fetch("https://stripe.nautilussolar.com/stripeserver/verify/setup-intent", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  setup_intent_id,
                  amount1,
                  amount2,
                }),
              })

              const data = await response.json()
              if (data.success) {
                resultBox.textContent = "Your payment is verified now"
                resultBox.style.color = "green"
                await updateDepositAmountUp(amount1, amount2, JSON.stringify(data), "")
                document.querySelector("#achVerificationMainUp").style.display = "none"
                document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                closeProgressBar()
              } else {
                await updateDepositAmountUp(amount1, amount2, JSON.stringify(data), "requires_action")
                resultBox.textContent =
                  "The two deposit amounts that you entered, do not match what Stripe deposited into your account."
                resultBox.style.color = "red"
                document.querySelector("#achVerificationMainUp").style.display = "block"
                document.querySelector("#stripeBankCreditMainUp").style.display = "none"
                closeProgressBar()
              }
            } else if (microdepostiType === "descriptor_code") {
              const response = await fetch("https://stripe.nautilussolar.com/stripeserver/verify/setup-intent", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  setup_intent_id,
                  discriptorCode,
                }),
              })

              const data = await response.json()
              if (data.success) {
                if (data.verified.last_setup_error.code === "setup_intent_setup_attempt_expired") {
                  document.getElementById("descriptorCodeLabel").remove()
                  document.getElementById("descriptorCode").remove()
                  resultBox.textContent = "This validation request has expired. Please reach out to Customer Care"
                  resultBox.style.color = "red"
                  closeProgressBar()
                } else {
                  resultBox.textContent = "Your payment is verified now"
                  resultBox.style.color = "green"
                  await updateDepositAmountUp(amount1, amount2, JSON.stringify(data), "")
                  document.querySelector("#achVerificationMainUp").style.display = "none"
                  document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                  closeProgressBar()
                }
              } else {
                await updateDepositAmountUp(amount1, amount2, JSON.stringify(data), "requires_action")
                if (
                  data.message ===
                  'This SetupIntent cannot be actioned on because it has a status of succeeded. Only a SetupIntent with one of the following statuses may be actioned on: ["requires_action"].'
                ) {
                  document.getElementById("descriptorCodeLabel").remove()
                  document.getElementById("descriptorCode").remove()
                  resultBox.textContent = "Your payment method has already been validated. Thank you!"
                  resultBox.style.color = "green"
                } else if (data.message === "You have exceeded the number of allowed verification attempts.") {
                  document.getElementById("descriptorCodeLabel").remove()
                  document.getElementById("descriptorCode").remove()
                  resultBox.textContent =
                    "You have reached the maximum number of unsuccessful attempts. Please reach out to Customer Care."
                  resultBox.style.color = "red"
                } else {
                  document.getElementById("descriptorCode").value = ""
                  resultBox.textContent = "This code does not match what we have on file. Please try again."
                  resultBox.style.color = "red"
                }
                document.querySelector("#achVerificationMainUp").style.display = "block"
                document.querySelector("#stripeBankCreditMainUp").style.display = "none"
                closeProgressBar()
              }
            } else {
              const response = await fetch("https://stripe.nautilussolar.com/stripeserver/verify/setup-intent", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  setup_intent_id,
                  amount1,
                  amount2,
                }),
              })

              const data = await response.json()
              if (data.success) {
                resultBox.textContent = "Your payment is verified now"
                resultBox.style.color = "green"
                await updateDepositAmountUp(amount1, amount2, JSON.stringify(data), "")
                document.querySelector("#achVerificationMainUp").style.display = "none"
                document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                closeProgressBar()
              } else {
                await updateDepositAmountUp(amount1, amount2, JSON.stringify(data), "requires_action")
                resultBox.textContent =
                  "The two deposit amounts that you entered, do not match what Stripe deposited into your account."
                resultBox.style.color = "red"
                document.querySelector("#achVerificationMainUp").style.display = "block"
                document.querySelector("#stripeBankCreditMainUp").style.display = "none"
                closeProgressBar()
              }
            }
          } catch (error) {
            console.error(error)
            resultBox.textContent = "Unexpected error occurred."
            resultBox.style.color = "red"
            document.querySelector("#achVerificationMainUp").style.display = "block"
            document.querySelector("#stripeBankCreditMainUp").style.display = "none"
            closeProgressBar()
          }
        } else {
          resultBox.textContent = "Server error occurred."
          resultBox.style.color = "red"
          document.querySelector("#achVerificationMainUp").style.display = "block"
          document.querySelector("#stripeBankCreditMainUp").style.display = "none"
          closeProgressBar()
        }
      } catch (error) {
        console.error(error)
        resultBox.textContent = "Server error occurred."
        resultBox.style.color = "red"
        closeProgressBar()
      }
    })
    async function updateDepositAmountUp(amount1, amount2, res, billingStatus) {
__ea_trace("modules/self-serve/self-serve.ts","updateDepositAmountUp",[amount1,amount2,res,billingStatus],["amount1","amount2","res","billingStatus"]);
      var subscriptionID = storage.rawGet("selectedSubscriptionId")
      let paymentData
      paymentData = {
        subscriptionId: subscriptionID,
        //                         paymentType: "Credit Card",
        properties: {
          ach_deposit_amount_1: amount1,
          ach_deposit_amount_2: amount2,
          ach_verification_manual_response: res,
          billing_status: billingStatus,
          stripe_payment_status: billingStatus,
        },
      }

      try {
        const updateResponse = await fetch('/_hcms/api/update-subscription-data', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData),
        })

        const updateResult = await updateResponse.json()
        responseFromAPI = JSON.stringify(updateResult)

        if (updateResult.status === "success") {
          await createNseDepositAmountUp(amount1, amount2, res, billingStatus)
          //                         alert("🎉 Payment details updated successfully in the service action record!");
        } else {
          closeProgressBar()
          console.error("❌ Update Failed:", updateResult)
          throw new Error("Failed to update subscription with payment details.")
        }
      } catch (error) {
        closeProgressBar()
        console.error("Error:", error)
      }
      return true
    }
    async function createNseDepositAmountUp(amount1, amount2, res, billingStatus) {
__ea_trace("modules/self-serve/self-serve.ts","createNseDepositAmountUp",[amount1,amount2,res,billingStatus],["amount1","amount2","res","billingStatus"]);
      var subscriptionID = storage.rawGet("selectedSubscriptionId")
      let _paymentData
      _paymentData = {
        subscriptionId: subscriptionID,
        //                         paymentType: "Credit Card",
        properties: {
          ach_deposit_amount_1: amount1,
          ach_deposit_amount_2: amount2,
          ach_verification_manual_response: res,
          billing_status: billingStatus,
          stripe_payment_status: billingStatus,
        },
      }

      const selectElement = document.querySelector("#subSelect")
      if (!selectElement) return

      const selectedSubscriptionId = selectElement.value
      const selectedSubscription = window.nseSubscriptionVars.find((sub) => sub.hsObjectId === selectedSubscriptionId)

      if (!selectedSubscription) return

      const enrollmentNumber = selectedSubscription.enrollmentNumber
      const contactId = storage.rawGet("RecordId") || (window.contactData ? window.contactData.id : null)
      const email = window.contactData ? window.contactData.email : null

      let serviceActionID = storage.rawGet("nse_service_action") // Check if service action already exists

      try {
        var fName = ""
        var lName = ""
        fName = storage.rawGet("FirstName")
        lName = storage.rawGet("LastName")
        if (st === "admin") {
          var admnEmail = storage.rawGet("adminEmail")
          var _serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              enrollmentNumber: enrollmentNumber,
              contactId: contactId,
              email: email,
              // paymentType: selectedPaymentType.value,
              updatedBy: "Admin",
              adminEmail: admnEmail,
              type: "Updated Payment Info",
              fName: fName,
              lName: lName,
            }),
          })
        } else {
          var serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              enrollmentNumber: enrollmentNumber,
              contactId: contactId,
              email: email,
              // paymentType: selectedPaymentType.value,
              updatedBy: "Customer",
              adminEmail: "",
              type: "Updated Payment Info",
              fName: fName,
              lName: lName,
            }),
          })
        }

        const serviceActionData = await serviceActionResponse.json()
        responseFromAPI = JSON.stringify(serviceActionData)

        if (serviceActionData.serviceActionId) {
          storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
          serviceActionID = serviceActionData.serviceActionId

          // Associate service action with NSE subscription
          const associateResponse = await fetch('/_hcms/api/associate-service-action', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              serviceActionId: serviceActionID,
              nseSubscriptionId: selectedSubscriptionId,
              contactId: contactId,
            }),
          })

          const associateData = await associateResponse.json()

          if (associateData.status === "success") {
            await updateServiceActionWithStripeAchVerificationDetails(
              serviceActionID,
              amount1,
              amount2,
              res,
              billingStatus,
            )
            var buttonParent = document.querySelector(".up-strp-jnpiays-update")
            if (buttonParent?.querySelector(".up-strp-update-card-info")) {
              var textElement = document.createElement("p")
              textElement.classList.add("success-message")
              textElement.textContent = "Your payment information is submited"
              buttonParent.after(textElement)
              // Remove the message after 4 seconds
              setTimeout(() => textElement.remove(), 10000)
              closeProgressBar()
            }
            if (billingStatusUp === "requires_action") {
              document.querySelector("#stripeBankCreditMainUp").style.display = "none"
              document.querySelector("#achVerificationMainUp").style.display = "block"
            } else {
              document.querySelector("#stripeBankCreditMainUp").style.display = "block"
              document.querySelector("#achVerificationMainUp").style.display = "none"
            }
          } else {
            closeProgressBar()
            console.error("❌ Association Error:", associateData)
            throw new Error("Failed to associate service action.")
          }
        } else {
          closeProgressBar()
          console.error("❌ Service Action Creation Failed:", serviceActionData)
          throw new Error("Failed to create service action.")
        }
      } catch (error) {
        closeProgressBar()
        console.error("❌ Error:", error)
      }

      return true
    }
    const contactId = storage.rawGet("RecordId")

    // Tabbing functionality
    const sections = document.querySelectorAll(".ssmainsection-tabContent > div")
    sections.forEach((section, index) => (section.style.display = index === 0 ? "block" : "none"))

    document.querySelector(".makePayment a").addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
      const listItem = document.querySelector('li[data="make_a_payment"]')
      if (listItem && listItem.offsetParent !== null) listItem.click()
    })

    async function getHubspotUser(email) {
__ea_trace("modules/self-serve/self-serve.ts","getHubspotUser",[email],["email"]);
      // var useremail = 'support@digitalj2.com';
      const userData = JSON.stringify({ email: email })

      // Fetch Contact Data
      const fetchUser = () => {
__ea_trace("modules/self-serve/self-serve.ts","fetchUser",[],[]);
        return fetch('/_hcms/api/find-hubspot-user', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: userData,
        })
          .then((response) => response.json())
          .then((result) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[result],["result"]);
            responseFromAPI = JSON.stringify(result)
            const supportType = result.primaryTeamId
            const supportEmail = result.email
            var agent = 52689144
            var admin = 52689201
            email = customerEmail
            // Fetch request to validate user credentials
            if (supportType === agent) {
              fetch('/_hcms/api/get-login', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }), // Only send email
              })
                .then((response) => response.json())
                .then((result) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[result],["result"]);
                  responseFromAPI = JSON.stringify(result)
                  if (result.contactId) {
                    getAssoContractRecord(result.contactId, result.email, supportEmail, true, "agent")
                  } else {
                    closeProgressBar()
                  }
                })
                .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
                  closeProgressBar()
                  console.error("Login Error:", error)
                })
            } else if (supportType === admin) {
              fetch('/_hcms/api/get-login', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }), // Only send email
              })
                .then((response) => response.json())
                .then((result) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[result],["result"]);
                  responseFromAPI = JSON.stringify(result)
                  if (result.contactId) {
                    getAssoContractRecord(result.contactId, result.email, supportEmail, true, "admin")
                  } else {
                    closeProgressBar()
                  }
                })
                .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
                  closeProgressBar()
                  console.error("Login Error:", error)
                })
            } else {
              document.querySelector("#admin_agent_email-message").innerHTML =
                "You are not authorized to access this account."
              closeProgressBar()
            }
          })
          .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
            console.error("Fetch Error:", error)
            closeProgressBar()
            document.querySelector("#admin_agent_email-message").innerHTML =
              "You are not authorized to access this account."
          })
      }
      fetchUser()
    }
    function decrypteEmail(value) {
__ea_trace("modules/self-serve/self-serve.ts","decrypteEmail",[value],["value"]);
      fetch('/_hcms/api/dcrypt-the-email', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encryptedEmail: value }),
      })
        .then((response) => response.json())
        .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
          customerEmail = data.email
        })
        .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
          closeProgressBar()
          console.error("Error:", error)
        })
    }

    async function getAssoContractRecord(contact, email, supportEmail, isHubspotUser, adminOrAgent) {
__ea_trace("modules/self-serve/self-serve.ts","getAssoContractRecord",[contact,email,supportEmail,isHubspotUser,adminOrAgent],["contact","email","supportEmail","isHubspotUser","adminOrAgent"]);
      var _catchdata = ""
      try {
        const data = {
          id: contact,
        }
        const response = await fetch(apiUrl("get-contracts-based-on-contact"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
        _catchdata = data
        const dataa = await response.json()
        var index = 0
        if (JSON.stringify(dataa.contracts) === undefined || JSON.stringify(dataa.contracts) === "undefined") {
          isAllContractDone = true
          if (isHubspotUser === true) {
            //                     closeProgressBar();
            storage.rawSet("RecordId", contact)
            storage.rawSet("logEmail", email)
            if (adminOrAgent === "agent") {
              storage.rawSet("supportType", "agent")
              storage.rawSet("agentEmail", supportEmail)
            }
            if (adminOrAgent === "admin") {
              storage.rawSet("supportType", "admin")
              storage.rawSet("adminEmail", supportEmail)
            }

            location.reload()
          } else {
            //                     closeProgressBar();
            storage.rawSet("RecordId", contact)
            storage.rawSet("logEmail", email)
            location.reload()
          }
        } else {
          for (const assoc of dataa.contracts) {
            var _gh = await getContractRecord(assoc.toObjectId)
            if (index === dataa.contracts.length - 1) {
              if (isAllContractDone === true) {
                if (isHubspotUser === true) {
                  closeProgressBar()
                  storage.rawSet("RecordId", contact)
                  storage.rawSet("logEmail", email)
                  if (adminOrAgent === "agent") {
                    storage.rawSet("supportType", "agent")
                    storage.rawSet("agentEmail", supportEmail)
                  }
                  if (adminOrAgent === "admin") {
                    storage.rawSet("supportType", "admin")
                    storage.rawSet("adminEmail", supportEmail)
                  }

                  location.reload()
                } else {
                  closeProgressBar()
                  storage.rawSet("RecordId", contact)
                  storage.rawSet("logEmail", email)
                  location.reload()
                }
              }
            } else {
              isAllContractDone = false
            }
            index++
          }
        }
        if (response.status === 500 || response.status === 404) {
          isAllContractDone = true
          if (isHubspotUser === true) {
            closeProgressBar()
            storage.rawSet("RecordId", contact)
            storage.rawSet("logEmail", email)
            if (adminOrAgent === "agent") {
              storage.rawSet("supportType", "agent")
              storage.rawSet("agentEmail", supportEmail)
            }
            if (adminOrAgent === "admin") {
              storage.rawSet("supportType", "admin")
              storage.rawSet("adminEmail", supportEmail)
            }

            location.reload()
          } else {
            closeProgressBar()
            storage.rawSet("RecordId", contact)
            storage.rawSet("logEmail", email)
            location.reload()
          }
        }
      } catch (error) {
        isAllContractDone = true
        console.error("Error:", error)
      }
    }
    async function getContractRecord(contract) {
__ea_trace("modules/self-serve/self-serve.ts","getContractRecord",[contract],["contract"]);
      var _contractId = storage.rawGet("contractId")
      var _catchdata = ""
      try {
        const data = {
          id: contract,
        }
        const response = await fetch(apiUrl("get-contracts-reprocess"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
        _catchdata = data
        const dataa = await response.json()
        var crpStatus = dataa.properties.crp_status
        var reSignAccessUrl = dataa.properties.re_sign_access_url
        if (
          crpStatus === "Signature Captured" ||
          crpStatus === "Uploaded (IL Only)" ||
          crpStatus === "Sent to Staging" ||
          crpStatus === "Completed"
        ) {
          isAllContractDone = true
        } else {
          isAllContractDone = false
          document.querySelector(".progMessageAlert").innerHTML =
            `<h4>We just need a quick signature!</h4><p>We have an outstanding document related to your Nautilus Solar subscription. Please <a target="_blank" href="${reSignAccessUrl}">click here</a> to review and sign</p>`
          openNoAccountAlert()
        }

        if (response.status === 500 || response.status === 404) {
          isAllContractDone = true
        }
      } catch (error) {
        isAllContractDone = true
        console.error("Error:", error)
      }

      return isAllContractDone
    }

    var _limitt = 1000
    var _offsett = 0
    var _allFarmRowss = []
    async function getAvailability(uid) {
__ea_trace("modules/self-serve/self-serve.ts","getAvailability",[uid],["uid"]);
      var exampleUtilityId = uid
      const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id__eq=${exampleUtilityId}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      const rows = data.objects
      if (rows.length >= 1) {
        rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
          if (exampleUtilityId === element.values["1"]) {
            storage.rawSet("UtilitySessionDetails", JSON.stringify(element.values))
          } else {
          }
        })
      } else {
      }
    }
    function checkUtilityIdInFarmTable(
      U_Id,
      selectedBillingStatus,
      selectedStripePaymentMethodid,
      selectedStripePaymentMethod,
      selectedStripePaymentId,
      selectedBillingStatusMP,
      selectedpaymentMethod,
    ) {
__ea_trace("modules/self-serve/self-serve.ts","checkUtilityIdInFarmTable",[U_Id,selectedBillingStatus,selectedStripePaymentMethodid,selectedStripePaymentMethod,selectedStripePaymentId,selectedBillingStatusMP,selectedpaymentMethod],["U_Id","selectedBillingStatus","selectedStripePaymentMethodid","selectedStripePaymentMethod","selectedStripePaymentId","selectedBillingStatusMP","selectedpaymentMethod"]);
      //live farm table id 15223639
      getAvailability(U_Id)
      const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityFarm}/rows?portalId=${window.__ENV__.dataPortalId}&&utility_id=${U_Id}`
      fetch(hubDBEndpoint, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
          const rowss = data.objects
          const priorityArray = []
          var _inc = 0
          for (var i = 0; i <= rowss.length; i++) {
            const currentobj = rowss[i]
            const _FarmStateAbbreviation = currentobj.values[5]
            ++_inc
            var FarmPayment = ""
            const priority = currentobj.values[12]
            if (currentobj.values[36] !== undefined && currentobj.values[36] !== "undefined") {
              FarmPayment = currentobj.values[36].name
            }
            const myObject = {
              FarmPayment: FarmPayment,
              priority: priority,
            }
            if (currentobj.values[9] === 1) {
              priorityArray.push(myObject)
            }
            //                 }
            if (i === rowss.length - 1) {
              if (priorityArray.length > 0) {
                // Now correspondingObject contains the object with the lowest priority
                const minPriorityObject = priorityArray.reduce(
                  (min, obj) => (obj.priority < min.priority ? obj : min),
                  priorityArray[0],
                )
                storage.rawSet("FarmPayment", minPriorityObject.FarmPayment)
                var fp = storage.rawGet("FarmPayment")
                if (fp === "icheck") {
                  document.querySelector("#jnpiays-bank-credit").style.display = "block"
                  document.querySelector("#stripeBankCreditMainUp").style.display = "none"
                  document.querySelector("#mp-jnpiays-bank-credit").style.display = "block"
                  document.querySelector("#stripeBankCreditMain").style.display = "none"
                } else if (fp === "stripe") {
                  document.querySelector("#jnpiays-bank-credit").style.display = "none"
                  document.querySelector("#mp-jnpiays-bank-credit").style.display = "none"
                  initializeStripeUp()
                  setTimeout(() => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
                    if (selectedpaymentMethod === "ACH") {
                      if (selectedBillingStatus === "requires_action") {
                        document.querySelector("#stripeBankCreditMainUp").style.display = "none"
                        document.querySelector("#achVerificationMainUp").style.display = "block"
                        paymentMethodIdUp = selectedStripePaymentMethodid
                        _paymentMethodUp = selectedStripePaymentMethod
                        paymentIdUp = selectedStripePaymentId
                      } else {
                        document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                        document.querySelector("#achVerificationMainUp").style.display = "none"
                      }
                    } else {
                      document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                      document.querySelector("#achVerificationMainUp").style.display = "none"
                    }
                    storage.rawSet("billingStatus", selectedBillingStatus)

                    if (selectedpaymentMethod === "ACH") {
                      if (selectedBillingStatusMP === "requires_action") {
                        document.querySelector("#stripeBankCreditMain").style.display = "none"
                        document.querySelector("#achVerificationMain").style.display = "block"
                        paymentMethodIdUp = selectedStripePaymentMethodid
                        _paymentMethodUp = selectedStripePaymentMethod
                        paymentIdUp = selectedStripePaymentId
                      } else {
                        document.querySelector("#stripeBankCreditMain").style.display = "block"
                        document.querySelector("#achVerificationMain").style.display = "none"
                      }
                    } else {
                      document.querySelector("#stripeBankCreditMain").style.display = "block"
                      document.querySelector("#achVerificationMain").style.display = "none"
                    }
                    storage.rawSet("billingStatusMP", selectedBillingStatusMP)
                  }, 5000)
                  //             await stripeClientSide();
                } else {
                  document.querySelector("#jnpiays-bank-credit").style.display = "none"
                  document.querySelector("#mp-jnpiays-bank-credit").style.display = "none"
                  initializeStripeUp()
                  setTimeout(() => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
                    if (selectedpaymentMethod === "ACH") {
                      if (selectedBillingStatus === "requires_action") {
                        document.querySelector("#stripeBankCreditMainUp").style.display = "none"
                        document.querySelector("#achVerificationMainUp").style.display = "block"
                        paymentMethodIdUp = selectedStripePaymentMethodid
                        _paymentMethodUp = selectedStripePaymentMethod
                        paymentIdUp = selectedStripePaymentId
                      } else {
                        document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                        document.querySelector("#achVerificationMainUp").style.display = "none"
                      }
                    } else {
                      document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                      document.querySelector("#achVerificationMainUp").style.display = "none"
                    }
                    storage.rawSet("billingStatus", selectedBillingStatus)

                    if (selectedpaymentMethod === "ACH") {
                      if (selectedBillingStatusMP === "requires_action") {
                        document.querySelector("#stripeBankCreditMain").style.display = "none"
                        document.querySelector("#achVerificationMain").style.display = "block"
                        paymentMethodIdUp = selectedStripePaymentMethodid
                        _paymentMethodUp = selectedStripePaymentMethod
                        paymentIdUp = selectedStripePaymentId
                      } else {
                        document.querySelector("#stripeBankCreditMain").style.display = "block"
                        document.querySelector("#achVerificationMain").style.display = "none"
                      }
                    } else {
                      document.querySelector("#stripeBankCreditMain").style.display = "block"
                      document.querySelector("#achVerificationMain").style.display = "none"
                    }
                    storage.rawSet("billingStatusMP", selectedBillingStatusMP)
                  }, 5000)
                  //             await stripeClientSide();
                }
                break
              } else {
                document.querySelector("#jnpiays-bank-credit").style.display = "none"
                document.querySelector("#mp-jnpiays-bank-credit").style.display = "none"
                initializeStripeUp()
                setTimeout(() => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
                  if (selectedpaymentMethod === "ACH") {
                    if (selectedBillingStatus === "requires_action") {
                      document.querySelector("#stripeBankCreditMainUp").style.display = "none"
                      document.querySelector("#achVerificationMainUp").style.display = "block"
                      paymentMethodIdUp = selectedStripePaymentMethodid
                      _paymentMethodUp = selectedStripePaymentMethod
                      paymentIdUp = selectedStripePaymentId
                    } else {
                      document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                      document.querySelector("#achVerificationMainUp").style.display = "none"
                    }
                  } else {
                    document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                    document.querySelector("#achVerificationMainUp").style.display = "none"
                  }
                  storage.rawSet("billingStatus", selectedBillingStatus)

                  if (selectedpaymentMethod === "ACH") {
                    if (selectedBillingStatusMP === "requires_action") {
                      document.querySelector("#stripeBankCreditMain").style.display = "none"
                      document.querySelector("#achVerificationMain").style.display = "block"
                      paymentMethodIdUp = selectedStripePaymentMethodid
                      _paymentMethodUp = selectedStripePaymentMethod
                      paymentIdUp = selectedStripePaymentId
                    } else {
                      document.querySelector("#stripeBankCreditMain").style.display = "block"
                      document.querySelector("#achVerificationMain").style.display = "none"
                    }
                  } else {
                    document.querySelector("#stripeBankCreditMain").style.display = "block"
                    document.querySelector("#achVerificationMain").style.display = "none"
                  }
                  storage.rawSet("billingStatusMP", selectedBillingStatusMP)
                }, 5000)
                //             await stripeClientSide();
                break
              }
            }
          }
        })
        .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
          console.error("Error fetching data from HubDB:", error)
        })
    }
    if (contactId) {
      const searchInput = document.querySelector(".search-input")
      const selectBox = document.getElementById("subSelect")
      const resultsBox = document.getElementById("searchResults")
      const searchWrapper = document.querySelector(".searchResultsWrapper")

      searchInput.addEventListener("input", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
        const query = this.value.toLowerCase().trim()
        resultsBox.innerHTML = ""

        if (!query) {
          resultsBox.style.display = "none"
          return
        }

        const options = selectBox.querySelectorAll("option")
        let hasMatch = false

        options.forEach((option) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[option],["option"]);
          if (option.disabled) return

          const serviceAddress1 = (option.getAttribute("serviceaddress1") || "").toLowerCase()
          const accountNum = (option.getAttribute("combinedutilityaccountnum") || "").toLowerCase()

          if (serviceAddress1.includes(query) || accountNum.includes(query)) {
            hasMatch = true

            const div = document.createElement("div")
            div.className = "search-item"
            div.textContent = option.textContent

            div.onclick = () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
              selectBox.value = option.value

              // 🔥 Trigger change event manually
              selectBox.dispatchEvent(new Event("change", { bubbles: true }))

              searchInput.value = ""
              resultsBox.style.display = "none"
            }

            resultsBox.appendChild(div)
          }
        })

        resultsBox.style.display = hasMatch ? "block" : "none"
      })

      var utmSource = storage.rawGet("utm_source")
      if (utmSource === "SSP") {
        document.querySelector(".conditionPopup").style.display = "block"

        const closeBtn = document.querySelector(".conditionPopup-crossIcon img")
        const popup = document.querySelector(".conditionPopup")

        if (closeBtn && popup) {
          closeBtn.addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
            popup.style.display = "none"
          })
        }
      } else {
        document.querySelector(".conditionPopup").style.display = "none"
      }

      var checkbox = false
      var initialCheckboxValue = false
      const targetUrl = "/account"
      const sptype = storage.rawGet("supportType")
      const _currentUrl = window.location.href
      if (currentUrl === targetUrl && sptype) {
        storage.clear()
        location.reload()
      }
      const postcontactData = JSON.stringify({ id: contactId })
      // Fetch Contact Data
      const fetchContactData = () => {
__ea_trace("modules/self-serve/self-serve.ts","fetchContactData",[],[]);
        return fetch('/_hcms/api/get-contact', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: postcontactData,
        })
          .then((response) => response.json())
          .then((result) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[result],["result"]);
            responseFromAPI = JSON.stringify(result)
            window.contactData = result.properties // Store contact data globally
            populateFields(window.contactData) // Populate fields with the fetched contact data
          })
          .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
            closeProgressBar()
            console.error("Fetch Error:", error)
          })
      }
      // Fetched Property from Contact
      const populateFields = (contact) => {
__ea_trace("modules/self-serve/self-serve.ts","populateFields",[contact],["contact"]);
        document.querySelector(".accountEmailId span.accountEmail").textContent = contact.email || ""
        document.querySelector('input[name="current_email"]').value = contact.email || ""
        document.querySelector('input[name="current_phone"]').value = contact.phone || ""
        document.querySelector('input[name="current_cellphone"]').value = contact.mobilephone || ""
        document.querySelector('input[name="current_mailtostreet"]').value = contact.address || ""
        document.querySelector('input[name="current_mailetosuite"]').value = contact.street_address_2 || ""
        document.querySelector('input[name="current_mailtocity"]').value = contact.city || ""
        document.querySelector('input[name="current_mailtostate"]').value = contact.state || ""
        document.querySelector('input[name="current_mailtozip"]').value = contact.zip || ""
        storage.rawSet("bayou_onboarding_token", contact.bayou_onboarding_token)
        storage.rawSet("onboarding_token", contact.bayou_onboarding_token)
        storage.rawSet("CompanyName", `${contact.firstname}&${contact.lastname}`)
        storage.rawSet("FirstName", contact.firstname)
        storage.rawSet("LastName", contact.lastname)
        storage.rawSet("name", `${contact.firstname} ${contact.lastname}`)
        storage.rawSet("bayou_contact_id", contact.bayou_id)
        storage.rawSet("DateOfBirth", contact.date_of_birth)
        storage.rawSet("FirstDealId", contact.first_deal_record_associated_with_contact)

        if (contact.account_updates_news__and_surveys_via_email === "true") {
          document.querySelector('input[name="current_accountupdate_email"]').checked = true
        } else {
          document.querySelector('input[name="current_accountupdate_email"]').checked = false
        }
        checkboxx = document.getElementById("current_accountupdate_email")
        if (checkbox.checked) {
          initialCheckboxValue = true
        } else {
          initialCheckboxValue = false
        }
        if (
          contact.firstname !== "" &&
          contact.firstname != null &&
          contact.firstname !== undefined &&
          contact.firstname !== "undefined"
        ) {
          document.querySelector("#welFirstName").innerHTML = `, ${contact.firstname}`
        }
      }
      // Once contact data is fetched, fetch subscription data
      fetchContactData().then(() => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
        fetchNSESubscriptions() // Now that contact data is available, fetch subscription data
      })

      // Fetch deals
      var dealRecordLength = ""
      var openDealsCount = 0
      var subsciptionRecordLength = 0
      var mpAccountDetailNone = false

      async function findAssociatedDeals(contactId, isSubscription) {
__ea_trace("modules/self-serve/self-serve.ts","findAssociatedDeals",[contactId,isSubscription],["contactId","isSubscription"]);
        openProgressBar()
        var _catchdata = ""
        try {
          const data = {
            contactId: contactId,
          }
          const response = await fetch(apiUrl("FetchAssociatedDealsBasedOnContactId"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
          _catchdata = data
          const dataa = await response.json()
          // responseFromAPI = JSON.stringify(dataa);
          dealRecordLength = dataa.userValue.associations.deals.results.length
          var checkIfAnyPrevDealWithIn24Hour = false
          var isAttributionCodeAvaialble = false
          var attributionCode
          var repId
          var refrralUrl
          var dealOwner
          if (dealRecordLength === 1) {
            var dealIdLog = dataa.userValue.associations.deals.results
            for (var i = 0; i < dealIdLog.length; i++) {
              var deal = dealIdLog[i].id
              var postdealtData = JSON.stringify({ id: deal })
              try {
                const response = await fetch(apiUrl("get-nse-subscription-bases-on-deal"), {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: postdealtData,
                })
                const dataa = await response.json()
                //                             responseFromAPI = JSON.stringify(dataa);
                if (dataa.has_nse_subscription === false) {
                  try {
                    const data = {
                      deal_id: deal,
                    }
                    const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(data),
                    })
                    const dataa = await response.json()
                    //                             responseFromAPI = JSON.stringify(dataa);
                    if (dataa.message === "No User Found") {
                    } else if (dataa.message === "User Found") {
                      var _l_dealStage = dataa.userValue.properties.dealstage
                      if (
                        l_dealStage === 157471033 /* Account Created (Sales Pipeline) */ ||
                        l_dealStage === 261673350 /* Account Verification (Sales Pipeline) */ ||
                        l_dealStage === 157471034 /* My Info (Sales Pipeline) */ ||
                        l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */ ||
                        l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */ ||
                        l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */ ||
                        l_dealStage === 127892568 /* Consent All (Sales Pipeline) */ ||
                        l_dealStage === 127892569 /* Usage (Sales Pipeline) */ ||
                        l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */ ||
                        l_dealStage ===
                          127892572 /* Verify LMI (Sales Pipeline) */ /*|| l_dealStage == 127892573  Verify HU (Sales Pipeline) */ ||
                        l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */ ||
                        l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */ ||
                        l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */ ||
                        l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */ ||
                        l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */ ||
                        l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */ ||
                        l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */ ||
                        l_dealStage === 1142098958 /* Verify Utility Info/Verify ACH (Sales Pipeline) */
                      ) {
                        openDealsCount = 1
                        var l_dealStage = dataa.userValue.properties.dealstage
                        var log_repid = dataa.userValue.properties.attribution_rep
                        var log_attcode = dataa.userValue.properties.attribution_code
                        var log_refUrl = dataa.userValue.properties.referral_url
                        var _log_email = dataa.userValue.properties.deal_email_test
                        var street_address_1 = dataa.userValue.properties.street_address
                        var street_address_2 = dataa.userValue.properties.street_address_2
                        var servicestateabbreviation = dataa.userValue.properties.service_state_abbreviation

                        if (street_address_1 == null) {
                          street_address_1 = ""
                        }
                        if (street_address_2 == null) {
                          street_address_2 = ""
                        }
                        // var stagedStageEnteredDate = dataa['userValue']['properties']['hs_v2_date_entered_127892575'];
                        var stagedStageEnteredDate = dataa.userValue.properties.hs_v2_date_entered_127892570

                        var log_dealOwner = dataa.userValue.properties.hubspot_owner_id
                        var utility_id = dataa.userValue.properties.utility_id
                        //                     storage.rawSet('utility_id', utility_idd);
                        if (stagedStageEnteredDate != null) {
                          //                         var completionDate = "2024-06-11T16:33:58.535Z";
                          var completionDateObject = new Date(stagedStageEnteredDate)
                          var currentDate = new Date()
                          var timeDifference = currentDate - completionDateObject
                          var differenceInHours = timeDifference / (1000 * 60 * 60)
                          if (differenceInHours <= 24) {
                            checkIfAnyPrevDealWithIn24Hour = true
                            if (log_attcode != null) {
                              isAttributionCodeAvaialble = true
                              attributionCode = log_attcode
                              repId = log_repid
                              refrralUrl = log_refUrl
                              dealOwner = log_dealOwner
                            }
                          }
                        }
                        var l_dealId = dataa.userValue.id
                        var comb_utility_account_numberMain = dataa.userValue.properties.combined_utility_account_number
                        var _lmiMyUsage = dataa.userValue.properties.lmi_my_usage
                        var lmiOption = dataa.userValue.properties.lmi_option
                        if (comb_utility_account_numberMain == null || comb_utility_account_numberMain === "") {
                          comb_utility_account_numberMain = "Not Yet Provided"
                        }
                        var skip_bayou_submission = dataa.userValue.properties.skip_bayou_submission
                        var dealStage
                        var buttonBasedDealStage = "View Details"
                        var buttonClassBasedDealStage = "submitted"
                        // storage.rawSet("repid", log_repid);
                        if (l_dealStage === 127892578 /* completed */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892575 /* Staged (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892570 /* Submitted (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471033 /* Account Created (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471034 /* My Info (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892569 /* Usage (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 127892568 /* Consent All (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "PaymentInfo"
                        } else if (l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityCredentials"
                        } else if (l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */) {
                          dealStage = "Verify ACH"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "VeryfyACH"
                        } else if (l_dealStage === 127892572 /* Verify LMI (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892574 /* Verified (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892577 /* Dormant (Sales Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892579 /* Graveyard (Sales Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892580 /* Trashcan (Sales Pipeline) */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471031 /* Assisted Create (Sales Pipeline) */) {
                          dealStage = "Assisted Create"
                        } else if (l_dealStage === 157471032 /* Invite Sent (Sales Pipeline) */) {
                          dealStage = "Invite Sent"
                        } else if (l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278689 /* 7. Submitted (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984219225 /* 8. Staged (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341032 /* 9. Interfaced (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341033 /* Dormant (IL Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341035 /* Graveyard (IL Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341036 /* Trashcan (IL Pipeline)  */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else {
                          dealStage = "Pending"
                        }
                        var name = storage.rawGet("name")
                        var contentListSelector = document.querySelector(".enrolledAccounts-list .listContent")
                        var stt = storage.rawGet("supportType")
                        if (stt === "agent") {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li style="pointer-events: none;" class="lastBtn disabled list_manage ${buttonClassBasedDealStage}" disabled="true">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        } else {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li class="lastBtn list_manage ${buttonClassBasedDealStage}">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        }

                        if (
                          subsciptionRecordLength === 0 ||
                          subsciptionRecordLength == null ||
                          subsciptionRecordLength === undefined ||
                          subsciptionRecordLength === ""
                        ) {
                          // document.querySelector('#enrollments').click();
                        } else {
                          document.querySelector("#home").click()
                        }
                      } else {
                        var l_dealStage = dataa.userValue.properties.dealstage
                        var log_repid = dataa.userValue.properties.attribution_rep
                        var log_attcode = dataa.userValue.properties.attribution_code
                        var log_refUrl = dataa.userValue.properties.referral_url
                        var _log_email = dataa.userValue.properties.deal_email_test
                        var street_address_1 = dataa.userValue.properties.street_address
                        var street_address_2 = dataa.userValue.properties.street_address_2
                        var servicestateabbreviation = dataa.userValue.properties.service_state_abbreviation

                        if (street_address_1 == null) {
                          street_address_1 = ""
                        }
                        if (street_address_2 == null) {
                          street_address_2 = ""
                        }
                        // var stagedStageEnteredDate = dataa['userValue']['properties']['hs_v2_date_entered_127892575'];
                        var stagedStageEnteredDate = dataa.userValue.properties.hs_v2_date_entered_127892570

                        var log_dealOwner = dataa.userValue.properties.hubspot_owner_id
                        var utility_id = dataa.userValue.properties.utility_id
                        //                     storage.rawSet('utility_id', utility_idd);
                        if (stagedStageEnteredDate != null) {
                          //                         var completionDate = "2024-06-11T16:33:58.535Z";
                          var completionDateObject = new Date(stagedStageEnteredDate)
                          var currentDate = new Date()
                          var timeDifference = currentDate - completionDateObject
                          var differenceInHours = timeDifference / (1000 * 60 * 60)
                          if (differenceInHours <= 24) {
                            checkIfAnyPrevDealWithIn24Hour = true
                            if (log_attcode != null) {
                              isAttributionCodeAvaialble = true
                              attributionCode = log_attcode
                              repId = log_repid
                              refrralUrl = log_refUrl
                              dealOwner = log_dealOwner
                            }
                          }
                        }
                        var l_dealId = dataa.userValue.id
                        var comb_utility_account_numberMain = dataa.userValue.properties.combined_utility_account_number
                        var _lmiMyUsage = dataa.userValue.properties.lmi_my_usage
                        var lmiOption = dataa.userValue.properties.lmi_option
                        if (comb_utility_account_numberMain == null || comb_utility_account_numberMain === "") {
                          comb_utility_account_numberMain = "Not Yet Provided"
                        }
                        var skip_bayou_submission = dataa.userValue.properties.skip_bayou_submission
                        var dealStage
                        var buttonBasedDealStage = "View Details"
                        var buttonClassBasedDealStage = "submitted"
                        // storage.rawSet("repid", log_repid);
                        if (l_dealStage === 127892578 /* completed */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892575 /* Staged (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892570 /* Submitted (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471033 /* Account Created (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471034 /* My Info (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892569 /* Usage (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 127892568 /* Consent All (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "PaymentInfo"
                        } else if (l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityCredentials"
                        } else if (l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */) {
                          dealStage = "Verify ACH"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "VeryfyACH"
                        } else if (l_dealStage === 127892572 /* Verify LMI (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892574 /* Verified (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892577 /* Dormant (Sales Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892579 /* Graveyard (Sales Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892580 /* Trashcan (Sales Pipeline) */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471031 /* Assisted Create (Sales Pipeline) */) {
                          dealStage = "Assisted Create"
                        } else if (l_dealStage === 157471032 /* Invite Sent (Sales Pipeline) */) {
                          dealStage = "Invite Sent"
                        } else if (l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278689 /* 7. Submitted (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984219225 /* 8. Staged (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341032 /* 9. Interfaced (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341033 /* Dormant (IL Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341035 /* Graveyard (IL Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341036 /* Trashcan (IL Pipeline)  */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else {
                          dealStage = "Pending"
                        }
                        var name = storage.rawGet("name")
                        var contentListSelector = document.querySelector(".enrolledAccounts-list .listContent")
                        var stt = storage.rawGet("supportType")
                        if (stt === "agent") {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li style="pointer-events: none;" class="lastBtn disabled list_manage ${buttonClassBasedDealStage}" disabled="true">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        } else {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li class="lastBtn list_manage ${buttonClassBasedDealStage}">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        }

                        if (
                          subsciptionRecordLength === 0 ||
                          subsciptionRecordLength == null ||
                          subsciptionRecordLength === undefined ||
                          subsciptionRecordLength === ""
                        ) {
                          document.querySelector("#enrollments").click()
                        } else {
                          document.querySelector("#home").click()
                        }
                      }
                    }
                  } catch (error) {
                    console.error("Error:", error)
                  }
                }
                if (dataa.has_nse_subscription === true) {
                  try {
                    const data = {
                      deal_id: deal,
                    }
                    const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(data),
                    })
                    const dataa = await response.json()
                    //                             responseFromAPI = JSON.stringify(dataa);
                    if (dataa.message === "No User Found") {
                    } else if (dataa.message === "User Found") {
                      var _l_dealStage = dataa.userValue.properties.dealstage
                      if (
                        l_dealStage === 157471033 /* Account Created (Sales Pipeline) */ ||
                        l_dealStage === 261673350 /* Account Verification (Sales Pipeline) */ ||
                        l_dealStage === 157471034 /* My Info (Sales Pipeline) */ ||
                        l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */ ||
                        l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */ ||
                        l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */ ||
                        l_dealStage === 127892568 /* Consent All (Sales Pipeline) */ ||
                        l_dealStage === 127892569 /* Usage (Sales Pipeline) */ ||
                        l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */ ||
                        l_dealStage ===
                          127892572 /* Verify LMI (Sales Pipeline) */ /*|| l_dealStage == 127892573  Verify HU (Sales Pipeline) */ ||
                        l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */ ||
                        l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */ ||
                        l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */ ||
                        l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */ ||
                        l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */ ||
                        l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */ ||
                        l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */ ||
                        l_dealStage === 1142098958 /* Verify Utility Info/Verify ACH (Sales Pipeline) */
                      ) {
                        openDealsCount = 1
                        var l_dealStage = dataa.userValue.properties.dealstage
                        var log_repid = dataa.userValue.properties.attribution_rep
                        var log_attcode = dataa.userValue.properties.attribution_code
                        var log_refUrl = dataa.userValue.properties.referral_url
                        var _log_email = dataa.userValue.properties.deal_email_test
                        var street_address_1 = dataa.userValue.properties.street_address
                        var street_address_2 = dataa.userValue.properties.street_address_2
                        var servicestateabbreviation = dataa.userValue.properties.service_state_abbreviation

                        if (street_address_1 == null) {
                          street_address_1 = ""
                        }
                        if (street_address_2 == null) {
                          street_address_2 = ""
                        }
                        // var stagedStageEnteredDate = dataa['userValue']['properties']['hs_v2_date_entered_127892575'];
                        var stagedStageEnteredDate = dataa.userValue.properties.hs_v2_date_entered_127892570

                        var log_dealOwner = dataa.userValue.properties.hubspot_owner_id
                        var utility_id = dataa.userValue.properties.utility_id
                        //                     storage.rawSet('utility_id', utility_idd);
                        if (stagedStageEnteredDate != null) {
                          //                         var completionDate = "2024-06-11T16:33:58.535Z";
                          var completionDateObject = new Date(stagedStageEnteredDate)
                          var currentDate = new Date()
                          var timeDifference = currentDate - completionDateObject
                          var differenceInHours = timeDifference / (1000 * 60 * 60)
                          if (differenceInHours <= 24) {
                            checkIfAnyPrevDealWithIn24Hour = true
                            if (log_attcode != null) {
                              isAttributionCodeAvaialble = true
                              attributionCode = log_attcode
                              repId = log_repid
                              refrralUrl = log_refUrl
                              dealOwner = log_dealOwner
                            }
                          }
                        }
                        var l_dealId = dataa.userValue.id
                        var comb_utility_account_numberMain = dataa.userValue.properties.combined_utility_account_number
                        var _lmiMyUsage = dataa.userValue.properties.lmi_my_usage
                        var lmiOption = dataa.userValue.properties.lmi_option
                        if (comb_utility_account_numberMain == null || comb_utility_account_numberMain === "") {
                          comb_utility_account_numberMain = "Not Yet Provided"
                        }
                        var skip_bayou_submission = dataa.userValue.properties.skip_bayou_submission
                        var dealStage
                        var buttonBasedDealStage = "View Details"
                        var buttonClassBasedDealStage = "submitted"
                        // storage.rawSet("repid", log_repid);
                        if (l_dealStage === 127892578 /* completed */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892575 /* Staged (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892570 /* Submitted (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471033 /* Account Created (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471034 /* My Info (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892569 /* Usage (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 127892568 /* Consent All (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "PaymentInfo"
                        } else if (l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityCredentials"
                        } else if (l_dealStage === 127892572 /* Verify LMI (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */) {
                          dealStage = "Verify ACH"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "VeryfyACH"
                        } else if (l_dealStage === 127892574 /* Verified (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892577 /* Dormant (Sales Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892579 /* Graveyard (Sales Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892580 /* Trashcan (Sales Pipeline) */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471031 /* Assisted Create (Sales Pipeline) */) {
                          dealStage = "Assisted Create"
                        } else if (l_dealStage === 157471032 /* Invite Sent (Sales Pipeline) */) {
                          dealStage = "Invite Sent"
                        } else if (l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278689 /* 7. Submitted (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984219225 /* 8. Staged (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341032 /* 9. Interfaced (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341033 /* Dormant (IL Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341035 /* Graveyard (IL Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341036 /* Trashcan (IL Pipeline)  */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else {
                          dealStage = "Pending"
                        }
                        var name = storage.rawGet("name")
                        var contentListSelector = document.querySelector(".enrolledAccounts-list .listContent")
                        var stt = storage.rawGet("supportType")
                        if (stt === "agent") {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li style="pointer-events: none;" class="lastBtn disabled list_manage ${buttonClassBasedDealStage}" disabled="true">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        } else {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li class="lastBtn list_manage ${buttonClassBasedDealStage}">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        }

                        if (
                          subsciptionRecordLength === 0 ||
                          subsciptionRecordLength == null ||
                          subsciptionRecordLength === undefined ||
                          subsciptionRecordLength === ""
                        ) {
                          // document.querySelector('#enrollments').click();
                        } else {
                          document.querySelector("#home").click()
                        }
                      } else {
                        var l_dealStage = dataa.userValue.properties.dealstage
                        var log_repid = dataa.userValue.properties.attribution_rep
                        var log_attcode = dataa.userValue.properties.attribution_code
                        var log_refUrl = dataa.userValue.properties.referral_url
                        var _log_email = dataa.userValue.properties.deal_email_test
                        var street_address_1 = dataa.userValue.properties.street_address
                        var street_address_2 = dataa.userValue.properties.street_address_2
                        var servicestateabbreviation = dataa.userValue.properties.service_state_abbreviation

                        if (street_address_1 == null) {
                          street_address_1 = ""
                        }
                        if (street_address_2 == null) {
                          street_address_2 = ""
                        }
                        // var stagedStageEnteredDate = dataa['userValue']['properties']['hs_v2_date_entered_127892575'];
                        var stagedStageEnteredDate = dataa.userValue.properties.hs_v2_date_entered_127892570

                        var log_dealOwner = dataa.userValue.properties.hubspot_owner_id
                        var utility_id = dataa.userValue.properties.utility_id
                        //                     storage.rawSet('utility_id', utility_idd);
                        if (stagedStageEnteredDate != null) {
                          //                         var completionDate = "2024-06-11T16:33:58.535Z";
                          var completionDateObject = new Date(stagedStageEnteredDate)
                          var currentDate = new Date()
                          var timeDifference = currentDate - completionDateObject
                          var differenceInHours = timeDifference / (1000 * 60 * 60)
                          if (differenceInHours <= 24) {
                            checkIfAnyPrevDealWithIn24Hour = true
                            if (log_attcode != null) {
                              isAttributionCodeAvaialble = true
                              attributionCode = log_attcode
                              repId = log_repid
                              refrralUrl = log_refUrl
                              dealOwner = log_dealOwner
                            }
                          }
                        }
                        var l_dealId = dataa.userValue.id
                        var comb_utility_account_numberMain = dataa.userValue.properties.combined_utility_account_number
                        var _lmiMyUsage = dataa.userValue.properties.lmi_my_usage
                        var lmiOption = dataa.userValue.properties.lmi_option
                        if (comb_utility_account_numberMain == null || comb_utility_account_numberMain === "") {
                          comb_utility_account_numberMain = "Not Yet Provided"
                        }
                        var skip_bayou_submission = dataa.userValue.properties.skip_bayou_submission
                        var dealStage
                        var buttonBasedDealStage = "View Details"
                        var buttonClassBasedDealStage = "submitted"
                        // storage.rawSet("repid", log_repid);
                        if (l_dealStage === 127892578 /* completed */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892575 /* Staged (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892570 /* Submitted (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471033 /* Account Created (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471034 /* My Info (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892569 /* Usage (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 127892568 /* Consent All (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "PaymentInfo"
                        } else if (l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityCredentials"
                        } else if (l_dealStage === 127892572 /* Verify LMI (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */) {
                          dealStage = "Verify ACH"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "VeryfyACH"
                        } else if (l_dealStage === 127892574 /* Verified (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892577 /* Dormant (Sales Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892579 /* Graveyard (Sales Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892580 /* Trashcan (Sales Pipeline) */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471031 /* Assisted Create (Sales Pipeline) */) {
                          dealStage = "Assisted Create"
                        } else if (l_dealStage === 157471032 /* Invite Sent (Sales Pipeline) */) {
                          dealStage = "Invite Sent"
                        } else if (l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278689 /* 7. Submitted (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984219225 /* 8. Staged (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341032 /* 9. Interfaced (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341033 /* Dormant (IL Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341035 /* Graveyard (IL Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341036 /* Trashcan (IL Pipeline)  */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else {
                          dealStage = "Pending"
                        }
                        var name = storage.rawGet("name")
                        var contentListSelector = document.querySelector(".enrolledAccounts-list .listContent")
                        var stt = storage.rawGet("supportType")
                        if (stt === "agent") {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li style="pointer-events: none;" class="lastBtn disabled list_manage ${buttonClassBasedDealStage}" disabled="true">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        } else {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li class="lastBtn list_manage ${buttonClassBasedDealStage}">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        }

                        if (
                          subsciptionRecordLength === 0 ||
                          subsciptionRecordLength == null ||
                          subsciptionRecordLength === undefined ||
                          subsciptionRecordLength === ""
                        ) {
                          document.querySelector("#enrollments").click()
                        } else {
                          document.querySelector("#home").click()
                        }
                      }
                    }
                  } catch (error) {
                    console.error("Error:", error)
                  }
                }
              } catch (error) {
                console.error("Error:", error)
              }
            }
            if (openDealsCount !== 0) {
              if (isSubscription === "no") {
                var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
                var specificValue = "enrollments"
                liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                  if (li.getAttribute("data") === specificValue) {
                    li.style.display = "block"
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .enrollments").style.display = "block"
                  } else {
                    li.style.display = "none"
                  }
                })
                document.querySelector('li[data="enrollments"]').click()
              } else {
                document
                  .querySelector(".ssmainsection-outer")
                  .insertAdjacentHTML(
                    "beforebegin",
                    '<div class="topBarMessage"><p>You have incomplete enrollments. <a class="goToEnroll" href="javascript:;">Click here</a> to view and finish them.</p></div>',
                  )
                document.querySelector(".goToEnroll").addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
                  document.querySelector('li[data="enrollments"]').click()
                })
              }
            }

            if (checkIfAnyPrevDealWithIn24Hour === true) {
              if (isAttributionCodeAvaialble === true) {
                storage.rawSet("gotAttCode", "Yes")
                storage.rawSet("attcode", attributionCode)
                storage.rawSet("repid", repId)
                storage.rawSet("referralUrl", refrralUrl)
                storage.rawSet("dealOwner", dealOwner)
                //                             document.querySelector('#gsicode').style.display = 'none';
              } else {
                var currentUrl = storage.rawGet("first_visited_url")
                function getQueryParam(name) {
__ea_trace("modules/self-serve/self-serve.ts","getQueryParam",[name],["name"]);
                  var urlParams = new URLSearchParams(currentUrl)
                  return urlParams.get(name)
                }
                var attcode = getQueryParam("attcode")
                var reppid = getQueryParam("repid")
                if (attcode != null) {
                  if (attcode !== "") {
                    storage.rawSet("attcode", attcode)
                    storage.rawSet("repid", reppid)
                    storage.rawSet("referralUrl", currentUrl)
                    //                                     document.querySelector('#gsicode').style.display = 'none';
                  } else {
                    //                                     document.querySelector('#gsicode').style.display = 'block';
                  }
                } else {
                  //                                 document.querySelector('#gsicode').style.display = 'block';
                }
              }
            } else {
              var currentUrl = storage.rawGet("first_visited_url")
              function getQueryParam(name) {
__ea_trace("modules/self-serve/self-serve.ts","getQueryParam",[name],["name"]);
                var urlParams = new URLSearchParams(currentUrl)
                return urlParams.get(name)
              }
              var attcode = getQueryParam("attcode")
              var reppid = getQueryParam("repid")
              if (attcode != null) {
                if (attcode !== "") {
                  storage.rawSet("attcode", attcode)
                  storage.rawSet("repid", reppid)
                  storage.rawSet("referralUrl", currentUrl)
                  //                                 document.querySelector('#gsicode').style.display = 'none';
                } else {
                  //                                 document.querySelector('#gsicode').style.display = 'block';
                }
              } else {
                //                             document.querySelector('#gsicode').style.display = 'block';
              }
            }
            //             alert("dataa: "+JSON.stringify(dataa));
            document.querySelector(".enrolledAccounts-listSection").style.display = "block"

            //                     closeProgressBar();
          } else if (dealRecordLength > 1) {
            var dealIdLog = dataa.userValue.associations.deals.results
            for (var i = 0; i < dealIdLog.length; i++) {
              var deal = dealIdLog[i].id
              var postdealtData = JSON.stringify({ id: deal })
              try {
                const response = await fetch(apiUrl("get-nse-subscription-bases-on-deal"), {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: postdealtData,
                })
                const dataa = await response.json()
                //                             responseFromAPI = JSON.stringify(dataa);
                if (dataa.has_nse_subscription === false) {
                  try {
                    const data = {
                      deal_id: deal,
                    }
                    const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(data),
                    })
                    const dataa = await response.json()
                    //                             responseFromAPI = JSON.stringify(dataa);
                    if (dataa.message === "No User Found") {
                    } else if (dataa.message === "User Found") {
                      var _l_dealStage = dataa.userValue.properties.dealstage
                      if (
                        l_dealStage === 157471033 /* Account Created (Sales Pipeline) */ ||
                        l_dealStage === 261673350 /* Account Verification (Sales Pipeline) */ ||
                        l_dealStage === 157471034 /* My Info (Sales Pipeline) */ ||
                        l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */ ||
                        l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */ ||
                        l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */ ||
                        l_dealStage === 127892568 /* Consent All (Sales Pipeline) */ ||
                        l_dealStage === 127892569 /* Usage (Sales Pipeline) */ ||
                        l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */ ||
                        l_dealStage ===
                          127892572 /* Verify LMI (Sales Pipeline) */ /*|| l_dealStage == 127892573  Verify HU (Sales Pipeline) */ ||
                        l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */ ||
                        l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */ ||
                        l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */ ||
                        l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */ ||
                        l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */ ||
                        l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */ ||
                        l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */ ||
                        l_dealStage === 1142098958 /* Verify Utility Info/Verify ACH (Sales Pipeline) */
                      ) {
                        openDealsCount = 1
                        var l_dealStage = dataa.userValue.properties.dealstage
                        var log_repid = dataa.userValue.properties.attribution_rep
                        var log_attcode = dataa.userValue.properties.attribution_code
                        var log_refUrl = dataa.userValue.properties.referral_url
                        var _log_email = dataa.userValue.properties.deal_email_test
                        var street_address_1 = dataa.userValue.properties.street_address
                        var street_address_2 = dataa.userValue.properties.street_address_2
                        var servicestateabbreviation = dataa.userValue.properties.service_state_abbreviation

                        if (street_address_1 == null) {
                          street_address_1 = ""
                        }
                        if (street_address_2 == null) {
                          street_address_2 = ""
                        }
                        // var stagedStageEnteredDate = dataa['userValue']['properties']['hs_v2_date_entered_127892575'];
                        var stagedStageEnteredDate = dataa.userValue.properties.hs_v2_date_entered_127892570

                        var log_dealOwner = dataa.userValue.properties.hubspot_owner_id
                        var utility_id = dataa.userValue.properties.utility_id
                        //                     storage.rawSet('utility_id', utility_idd);
                        if (stagedStageEnteredDate != null) {
                          //                         var completionDate = "2024-06-11T16:33:58.535Z";
                          var completionDateObject = new Date(stagedStageEnteredDate)
                          var currentDate = new Date()
                          var timeDifference = currentDate - completionDateObject
                          var differenceInHours = timeDifference / (1000 * 60 * 60)
                          if (differenceInHours <= 24) {
                            checkIfAnyPrevDealWithIn24Hour = true
                            if (log_attcode != null) {
                              isAttributionCodeAvaialble = true
                              attributionCode = log_attcode
                              repId = log_repid
                              refrralUrl = log_refUrl
                              dealOwner = log_dealOwner
                            }
                          }
                        }
                        var l_dealId = dataa.userValue.id
                        var comb_utility_account_numberMain = dataa.userValue.properties.combined_utility_account_number
                        var _lmiMyUsage = dataa.userValue.properties.lmi_my_usage
                        var lmiOption = dataa.userValue.properties.lmi_option
                        if (comb_utility_account_numberMain == null || comb_utility_account_numberMain === "") {
                          comb_utility_account_numberMain = "Not Yet Provided"
                        }
                        var skip_bayou_submission = dataa.userValue.properties.skip_bayou_submission
                        var dealStage
                        var buttonBasedDealStage = "View Details"
                        var buttonClassBasedDealStage = "submitted"
                        // storage.rawSet("repid", log_repid);
                        if (l_dealStage === 127892578 /* completed */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892575 /* Staged (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892570 /* Submitted (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471033 /* Account Created (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471034 /* My Info (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892569 /* Usage (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 127892568 /* Consent All (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "PaymentInfo"
                        } else if (l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityCredentials"
                        } else if (l_dealStage === 127892572 /* Verify LMI (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */) {
                          dealStage = "Verify ACH"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "VeryfyACH"
                        } else if (l_dealStage === 127892574 /* Verified (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892577 /* Dormant (Sales Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892579 /* Graveyard (Sales Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892580 /* Trashcan (Sales Pipeline) */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471031 /* Assisted Create (Sales Pipeline) */) {
                          dealStage = "Assisted Create"
                        } else if (l_dealStage === 157471032 /* Invite Sent (Sales Pipeline) */) {
                          dealStage = "Invite Sent"
                        } else if (l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278689 /* 7. Submitted (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984219225 /* 8. Staged (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341032 /* 9. Interfaced (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341033 /* Dormant (IL Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341035 /* Graveyard (IL Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341036 /* Trashcan (IL Pipeline)  */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else {
                          dealStage = "Pending"
                        }
                        var name = storage.rawGet("name")
                        var contentListSelector = document.querySelector(".enrolledAccounts-list .listContent")
                        var stt = storage.rawGet("supportType")
                        if (stt === "agent") {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li style="pointer-events: none;" class="lastBtn disabled list_manage ${buttonClassBasedDealStage}" disabled="true">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        } else {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li class="lastBtn list_manage ${buttonClassBasedDealStage}">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        }
                      } else {
                        openDealsCount = 1
                        var l_dealStage = dataa.userValue.properties.dealstage
                        var log_repid = dataa.userValue.properties.attribution_rep
                        var log_attcode = dataa.userValue.properties.attribution_code
                        var log_refUrl = dataa.userValue.properties.referral_url
                        var _log_email = dataa.userValue.properties.deal_email_test
                        var street_address_1 = dataa.userValue.properties.street_address
                        var street_address_2 = dataa.userValue.properties.street_address_2
                        var servicestateabbreviation = dataa.userValue.properties.service_state_abbreviation

                        if (street_address_1 == null) {
                          street_address_1 = ""
                        }
                        if (street_address_2 == null) {
                          street_address_2 = ""
                        }
                        // var stagedStageEnteredDate = dataa['userValue']['properties']['hs_v2_date_entered_127892575'];
                        var stagedStageEnteredDate = dataa.userValue.properties.hs_v2_date_entered_127892570

                        var log_dealOwner = dataa.userValue.properties.hubspot_owner_id
                        var utility_id = dataa.userValue.properties.utility_id
                        //                     storage.rawSet('utility_id', utility_idd);
                        if (stagedStageEnteredDate != null) {
                          //                         var completionDate = "2024-06-11T16:33:58.535Z";
                          var completionDateObject = new Date(stagedStageEnteredDate)
                          var currentDate = new Date()
                          var timeDifference = currentDate - completionDateObject
                          var differenceInHours = timeDifference / (1000 * 60 * 60)
                          if (differenceInHours <= 24) {
                            checkIfAnyPrevDealWithIn24Hour = true
                            if (log_attcode != null) {
                              isAttributionCodeAvaialble = true
                              attributionCode = log_attcode
                              repId = log_repid
                              refrralUrl = log_refUrl
                              dealOwner = log_dealOwner
                            }
                          }
                        }
                        var l_dealId = dataa.userValue.id
                        var comb_utility_account_numberMain = dataa.userValue.properties.combined_utility_account_number
                        var _lmiMyUsage = dataa.userValue.properties.lmi_my_usage
                        var lmiOption = dataa.userValue.properties.lmi_option
                        if (comb_utility_account_numberMain == null || comb_utility_account_numberMain === "") {
                          comb_utility_account_numberMain = "Not Yet Provided"
                        }
                        var skip_bayou_submission = dataa.userValue.properties.skip_bayou_submission
                        var dealStage
                        var buttonBasedDealStage = "View Details"
                        var buttonClassBasedDealStage = "submitted"
                        // storage.rawSet("repid", log_repid);
                        if (l_dealStage === 127892578 /* completed */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892575 /* Staged (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892570 /* Submitted (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471033 /* Account Created (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471034 /* My Info (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "allStepsRemaining"
                        } else if (l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892569 /* Usage (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 127892568 /* Consent All (Sales Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "PaymentInfo"
                        } else if (l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityCredentials"
                        } else if (l_dealStage === 127892572 /* Verify LMI (Sales Pipeline) */) {
                          dealStage = "My Info"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "MyInfo"
                        } else if (l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */) {
                          dealStage = "Verify ACH"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "VeryfyACH"
                        } else if (l_dealStage === 127892574 /* Verified (Sales Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892577 /* Dormant (Sales Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892579 /* Graveyard (Sales Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 127892580 /* Trashcan (Sales Pipeline) */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 157471031 /* Assisted Create (Sales Pipeline) */) {
                          dealStage = "Assisted Create"
                        } else if (l_dealStage === 157471032 /* Invite Sent (Sales Pipeline) */) {
                          dealStage = "Invite Sent"
                        } else if (l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */) {
                          dealStage = "My Usage"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "UtilityInformation"
                        } else if (l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */) {
                          dealStage = "My Consent"
                          buttonBasedDealStage = "Continue Enrollment"
                          buttonClassBasedDealStage = "ContractSignatures"
                        } else if (l_dealStage === 984278689 /* 7. Submitted (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984219225 /* 8. Staged (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341032 /* 9. Interfaced (IL Pipeline) */) {
                          dealStage = "Complete"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341033 /* Dormant (IL Pipeline) */) {
                          dealStage = "Dormant"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341035 /* Graveyard (IL Pipeline) */) {
                          dealStage = "Graveyard"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else if (l_dealStage === 984341036 /* Trashcan (IL Pipeline)  */) {
                          dealStage = "Trashcan"
                          buttonBasedDealStage = "View Details"
                          buttonClassBasedDealStage = "submitted"
                        } else {
                          dealStage = "Pending"
                        }
                        var name = storage.rawGet("name")
                        var contentListSelector = document.querySelector(".enrolledAccounts-list .listContent")
                        var stt = storage.rawGet("supportType")
                        if (stt === "agent") {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li style="pointer-events: none;" class="lastBtn disabled list_manage ${buttonClassBasedDealStage}" disabled="true">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        } else {
                          var contentList = `<ul dealid="${l_dealId}" utilityid="${utility_id}" lmioption="${lmiOption}" sbs="${skip_bayou_submission}" stabr="${servicestateabbreviation}"><li class="list_account">${comb_utility_account_numberMain}</li><li class="list_name">${name}</li><li class="list_address">${street_address_1} ${street_address_2}</li><li class="list_status">${dealStage}</li><li class="lastBtn list_manage ${buttonClassBasedDealStage}">${buttonBasedDealStage}</li></ul>`
                          contentListSelector.innerHTML += contentList
                        }
                      }
                    }
                  } catch (error) {
                    console.error("Error:", error)
                  }
                }
                if (dataa.has_nse_subscription === true) {
                  try {
                    const data = {
                      deal_id: deal,
                    }
                    const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(data),
                    })
                    const dataa = await response.json()
                    //                             responseFromAPI = JSON.stringify(dataa);
                    if (dataa.message === "No User Found") {
                    } else if (dataa.message === "User Found") {
                      var l_dealStage = dataa.userValue.properties.dealstage
                      if (
                        l_dealStage === 157471033 /* Account Created (Sales Pipeline) */ ||
                        l_dealStage === 261673350 /* Account Verification (Sales Pipeline) */ ||
                        l_dealStage === 157471034 /* My Info (Sales Pipeline) */ ||
                        l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */ ||
                        l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */ ||
                        l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */ ||
                        l_dealStage === 127892568 /* Consent All (Sales Pipeline) */ ||
                        l_dealStage === 127892569 /* Usage (Sales Pipeline) */ ||
                        l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */ ||
                        l_dealStage ===
                          127892572 /* Verify LMI (Sales Pipeline) */ /*|| l_dealStage == 127892573  Verify HU (Sales Pipeline) */ ||
                        l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */ ||
                        l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */ ||
                        l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */ ||
                        l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */ ||
                        l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */ ||
                        l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */ ||
                        l_dealStage === 1142098957 /* Verify ACH (Sales Pipeline) */ ||
                        l_dealStage === 1142098958 /* Verify Utility Info/Verify ACH (Sales Pipeline) */
                      ) {
                        if (
                          subsciptionRecordLength === 0 ||
                          subsciptionRecordLength == null ||
                          subsciptionRecordLength === undefined ||
                          subsciptionRecordLength === ""
                        ) {
                          // document.querySelector('#enrollments').click();
                          document.querySelector("#home").click()
                        } else {
                          document.querySelector("#home").click()
                        }
                      } else {
                        if (
                          subsciptionRecordLength === 0 ||
                          subsciptionRecordLength == null ||
                          subsciptionRecordLength === undefined ||
                          subsciptionRecordLength === ""
                        ) {
                          document.querySelector("#enrollments").click()
                        } else {
                          document.querySelector("#home").click()
                        }
                      }
                    }
                  } catch (error) {
                    console.error("Error:", error)
                  }
                }
              } catch (error) {
                console.error("Error:", error)
              }
            }
            if (openDealsCount !== 0) {
              if (isSubscription === "no") {
                var liElements = document.querySelectorAll(".ssmainsection-tabs ul li")
                var specificValue = "enrollments"
                liElements.forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                  if (li.getAttribute("data") === specificValue) {
                    li.style.display = "block"
                    li.classList.add("active")
                    document.querySelector(".ssmainsection-tabContent > .enrollments").style.display = "block"
                  } else {
                    li.style.display = "none"
                  }
                })
                document.querySelector('li[data="enrollments"]').click()
              } else {
                document
                  .querySelector(".ssmainsection-outer")
                  .insertAdjacentHTML(
                    "beforebegin",
                    '<div class="topBarMessage"><p>You have incomplete enrollments. <a class="goToEnroll" href="javascript:;">Click here</a> to view and finish them.</p></div>',
                  )
                document.querySelector(".goToEnroll").addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
                  document.querySelector('li[data="enrollments"]').click()
                })
              }
            }

            if (checkIfAnyPrevDealWithIn24Hour === true) {
              if (isAttributionCodeAvaialble === true) {
                storage.rawSet("gotAttCode", "Yes")
                storage.rawSet("attcode", attributionCode)
                storage.rawSet("repid", repId)
                storage.rawSet("referralUrl", refrralUrl)
                storage.rawSet("dealOwner", dealOwner)
              } else {
                var currentUrl = storage.rawGet("first_visited_url")
                function getQueryParam(name) {
__ea_trace("modules/self-serve/self-serve.ts","getQueryParam",[name],["name"]);
                  var urlParams = new URLSearchParams(currentUrl)
                  return urlParams.get(name)
                }
                var attcode = getQueryParam("attcode")
                var reppid = getQueryParam("repid")
                if (attcode != null) {
                  if (attcode !== "") {
                    storage.rawSet("attcode", attcode)
                    storage.rawSet("repid", reppid)
                    storage.rawSet("referralUrl", currentUrl)
                  }
                }
              }
            } else {
              var currentUrl = storage.rawGet("first_visited_url")
              function getQueryParam(name) {
__ea_trace("modules/self-serve/self-serve.ts","getQueryParam",[name],["name"]);
                var urlParams = new URLSearchParams(currentUrl)
                return urlParams.get(name)
              }
              var attcode = getQueryParam("attcode")
              var reppid = getQueryParam("repid")
              if (attcode != null) {
                if (attcode !== "") {
                  storage.rawSet("attcode", attcode)
                  storage.rawSet("repid", reppid)
                  storage.rawSet("referralUrl", currentUrl)
                }
              }
            }
            document.querySelector(".enrolledAccounts-listSection").style.display = "block"
          }
        } catch (error) {
          console.error("Error:", error)
        }

        /* --------------------------------------------------------------- */
        document.querySelector(".accountDetailsView-main .accCrosssBtn img").onclick = (_event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[_event],["_event"]);
          hideDetailsViewPopup() // Show the popup
        }

        function hideDetailsViewPopup() {
__ea_trace("modules/self-serve/self-serve.ts","hideDetailsViewPopup",[],[]);
          document.querySelector("body").classList.remove("body-overlay")
          document.querySelector("body").classList.remove("active")
          document.querySelector("body").classList.remove("no-scroll")
          document.querySelector(".accountDetailsView-main").style.display = "none"
        }
        function showDetailsViewPopup() {
__ea_trace("modules/self-serve/self-serve.ts","showDetailsViewPopup",[],[]);
          document.querySelector("body").classList.add("body-overlay")
          document.querySelector("body").classList.add("active")
          document.querySelector("body").classList.add("no-scroll")
          document.querySelector(".accountDetailsView-main").style.display = "flex"
        }

        var _utilityIdSession
        var _LmiAvailability
        var _LmiCensusAvailability
        var _DisplayLmiElementList = []
        var _requireLmiElementList = []
        var DisplayUsageElementList = []
        var requireUsageElementList = []
        var DisplayConsentElementList = []
        var requireConsentElementList = []
        var consetPaymentReq
        var sampleSessiontype
        var sampleOriginType
        var _errorCount = 0
        var log_Utname
        var globalDealId
        var _log_utilityID
        async function addUserAgentData(redirectUrl, particularSectionName, particularSectionValue) {
__ea_trace("modules/self-serve/self-serve.ts","addUserAgentData",[redirectUrl,particularSectionName,particularSectionValue],["redirectUrl","particularSectionName","particularSectionValue"]);
          var UserDevice_1 = storage.rawGet("User Device")
          var BrowserName_1 = storage.rawGet("Browser Name")
          var opratingSystem_1 = storage.rawGet("Operating System")
          var _catchdata = ""
          try {
            const data = {
              properties: {
                deal_id: globalDealId,
                user_agent: BrowserName_1,
                user_device: UserDevice_1,
                user_agent___operating_system: opratingSystem_1,
              },
            }
            const response = await fetch(apiUrl("UpdateDealRecord"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            _catchdata = data
            if (response.ok) {
              await CheckDealStageAndRedirectAccordingly(redirectUrl, particularSectionName, particularSectionValue)
            }

            const result = await response.json()
            responseFromAPI = JSON.stringify(result)
          } catch (error) {
            console.error("Error:", error)
          }
          return true
        }
        async function addDataToContactRecord(email, particularSectionValue) {
__ea_trace("modules/self-serve/self-serve.ts","addDataToContactRecord",[email,particularSectionValue],["email","particularSectionValue"]);
          var checkUID1 = storage.rawGet("utility_id")
          var UserDevice_1 = storage.rawGet("User Device")
          var BrowserName_1 = storage.rawGet("Browser Name")
          var opratingSystem_1 = storage.rawGet("Operating System")
          var _catchdata = ""
          try {
            const data = {
              properties: {
                email: email,
                internal_contact_source: "enrollment website",
                enrollment_utility_id: checkUID1,
                user_agent: BrowserName_1,
                user_device: UserDevice_1,
                user_agent___operating_system: opratingSystem_1,
                first_visited_url: first_visited_url,
              },
            }
            const response = await fetch(apiUrl("UpdateContactRecord"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            _catchdata = data
            if (response.ok) {
              await loggetAvalability(particularSectionValue)
            }
            responseFromAPI = await response.json()
            responseFromAPI = JSON.stringify(responseFromAPI)
          } catch (error) {
            console.error("Error:", error)
          }
          return true
        }

        var limitt = 1000
        var offsett = 0
        var allFarmRowss = []
        async function fillLocalStorage(U_Id) {
__ea_trace("modules/self-serve/self-serve.ts","fillLocalStorage",[U_Id],["U_Id"]);
          //Live farm table id 15223639
          const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityFarm}/rows?portalId=${window.__ENV__.dataPortalId}&limit=${limitt}&offset=${offsett}`
          fetch(hubDBEndpoint, {
            method: "GET",
          })
            .then((response) => response.json())
            .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
              const matchingRowss = data.objects.filter((row) => row.values[10] === U_Id)
              const rowss = data.objects
              allFarmRowss = allFarmRowss.concat(matchingRowss)
              if (rowss.length === limitt) {
                // There might be more rows, fetch the next page
                offsett += limitt
                return fillLocalStorage(U_Id)
              }
              const priorityArray = []
              for (var i = 0; i <= allFarmRowss.length; i++) {
                const currentobj = allFarmRowss[i]
                const FarmStateAbbreviation = currentobj.values[5]
                const FarmZip = currentobj.values[6]
                const FarmName = currentobj.values[7]
                const FarmID = currentobj.values[1]
                const priority = currentobj.values[12]
                const FarmDisplayName = currentobj.values[2]
                const FarmStreetAddress1 = currentobj.values[3]
                const FarmStreetAddress2 = currentobj.values[13]
                const FarmCity = currentobj.values[4]
                const FarmEmail = currentobj.values[28]
                const FarmPhoneNumber = currentobj.values[23]
                const FarmProjectDescription = currentobj.values[22]
                const FarmLlc = currentobj.values[21]
                const FarmLMIDiscount = currentobj.values[19]
                const FarmOpenDiscount = currentobj.values[20]
                const FarmCounty = currentobj.values[35]
                var FarmPayment = ""
                if (currentobj.values[36] !== undefined && currentobj.values[36] !== "undefined") {
                  FarmPayment = currentobj.values[36].name
                }
                const myObject = {
                  FarmZip: FarmZip,
                  FarmName: FarmName,
                  FarmID: FarmID,
                  priority: priority,
                  FarmDisplayName: FarmDisplayName,
                  FarmStreetAddress1: FarmStreetAddress1,
                  FarmStreetAddress2: FarmStreetAddress2,
                  FarmCity: FarmCity,
                  FarmEmail: FarmEmail,
                  FarmStateAbbreviation: FarmStateAbbreviation,
                  FarmPhoneNumber: FarmPhoneNumber,
                  FarmProjectDescription: FarmProjectDescription,
                  FarmLlc: FarmLlc,
                  FarmLMIDiscount: FarmLMIDiscount,
                  FarmOpenDiscount: FarmOpenDiscount,
                  FarmCounty: FarmCounty,
                  FarmPayment: FarmPayment,
                }
                if (currentobj.values[9] === 1) {
                  priorityArray.push(myObject)
                }
                if (i === allFarmRowss.length - 1) {
                  // Now correspondingObject contains the object with the lowest priority
                  const minPriorityObject = priorityArray.reduce(
                    (min, obj) => (obj.priority < min.priority ? obj : min),
                    priorityArray[0],
                  )
                  storage.rawSet("FarmStreetAddress1", minPriorityObject.FarmStreetAddress1)
                  storage.rawSet("FarmStreetAddress2", minPriorityObject.FarmStreetAddress2)
                  storage.rawSet("FarmCity", minPriorityObject.FarmCity)
                  storage.rawSet("FarmStateAbbreviation", minPriorityObject.FarmStateAbbreviation)
                  storage.rawSet("FarmName", minPriorityObject.FarmName)
                  storage.rawSet("FarmID", minPriorityObject.FarmID)
                  storage.rawSet("FarmPhoneNumber", minPriorityObject.FarmPhoneNumber)
                  storage.rawSet("FarmEmail", minPriorityObject.FarmEmail)
                  storage.rawSet("FarmProjectDescription", minPriorityObject.FarmProjectDescription)
                  storage.rawSet("FarmLlc", minPriorityObject.FarmLlc)
                  storage.rawSet("FarmDisplayName", minPriorityObject.FarmDisplayName)
                  storage.rawSet("FarmLMIDiscount", minPriorityObject.FarmLMIDiscount)
                  storage.rawSet("FarmOpenDiscount", minPriorityObject.FarmOpenDiscount)
                  storage.rawSet("FarmCounty", minPriorityObject.FarmCounty)
                  storage.rawSet("FarmPayment", minPriorityObject.FarmPayment)
                }
              }
            })
            .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
              console.error("Error fetching data from HubDB:", error)
            })
        }
        async function SaveSessionDetailsOnLocalStorage(exampleUtilityId) {
__ea_trace("modules/self-serve/self-serve.ts","SaveSessionDetailsOnLocalStorage",[exampleUtilityId],["exampleUtilityId"]);
          const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id__eq=${exampleUtilityId}`
          const response = await fetch(hubDBEndpoint, { method: "GET" })
          const data = await response.json()
          const rows = data.objects
          if (rows.length >= 1) {
            storage.rawSet("Config ID", rows[0].id)
            rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
              if (exampleUtilityId === element.values["1"]) {
                storage.rawSet("SessionDetails", JSON.stringify(element.values))
                storage.rawSet("stateForLMIConfig", element.values["13"].name)
                storage.rawSet("UtilitySessionDetails", JSON.stringify(element.values))
                storage.rawSet("UtilityRate", element.values["78"])
                storage.rawSet("SubSizingFactor", element.values["79"])
                storage.rawSet("standardRate", element.values["80"])
                storage.rawSet("lmiNseRate", element.values["81"])
                storage.rawSet("standardRate", element.values["80"])
                storage.rawSet("lmiNseRate", element.values["81"])
                storage.rawSet("acSystemSize", element.values["82"])
                storage.rawSet("acKwh", element.values["84"])
              } else {
              }
            })
          }
        }
        async function getUtilityNameFromDeal(dealId) {
__ea_trace("modules/self-serve/self-serve.ts","getUtilityNameFromDeal",[dealId],["dealId"]);
          globalDealId = dealId
          try {
            const data = {
              deal_id: dealId,
            }
            const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            const dataa = await response.json()
            if (dataa.message === "No User Found") {
            } else if (dataa.message === "User Found") {
              log_Utname = dataa.userValue.properties.utility_name
              var log_utilityIDn = dataa.userValue.properties.utility_id
              _log_utilityID = dataa.userValue.properties.utility_id
              var log_zipCoden = dataa.userValue.properties.postal_code
              var log_repid = dataa.userValue.properties.attribution_rep
              var log_attcode = dataa.userValue.properties.attribution_code
              var log_refUrl = dataa.userValue.properties.referral_url
              var l_dealId = dataa.userValue.id
              var street_address_1 = dataa.userValue.properties.street_address
              var street_address_2 = dataa.userValue.properties.street_address_2
              var service_city = dataa.userValue.properties.city
              var service_state_abbreviation = dataa.userValue.properties.service_state_abbreviation
              var county = dataa.userValue.properties.county
              var _Service_postal_code = dataa.userValue.properties.postal_code
              var eligible_for_lmi = dataa.userValue.properties.eligible_for_lmi
              if (eligible_for_lmi === true || eligible_for_lmi === "true") {
                storage.rawSet("isLMI", "Yes")
              } else {
                storage.rawSet("isLMI", "No")
              }
              if (log_utilityIDn != null) {
                storage.rawSet("utility_id", log_utilityIDn)
              }
              if (log_zipCoden != null) {
                storage.rawSet("zip_code", log_zipCoden)
              }
              if (log_Utname != null) {
                storage.rawSet("utility_Name", log_Utname)
              }
              storage.rawSet("city", service_city)
              storage.rawSet("county", county)
              storage.rawSet(
                "Address",
                `${street_address_1}, ${street_address_2}, ${service_city}, ${service_state_abbreviation}`,
              )
              var usage_period_from = dataa.userValue.properties.usage_period_from
              var usage_period_to = dataa.userValue.properties.usage_period_to
              var usage_period_days = dataa.userValue.properties.usage_period_days
              var electricity_consumption_wh = dataa.userValue.properties.electricity_consumption_wh
              var electricity_consumption_davg_wh = dataa.userValue.properties.electricity_consumption_davg_wh
              var electricity_consumption_watts = dataa.userValue.properties.electricity_consumption_watts
              var electricity_consumption_kwh = dataa.userValue.properties.electricity_consumption_kwh
              var electricity_consumption_davg_kwh = dataa.userValue.properties.electricity_consumption_davg_kwh
              var electricity_consumption_kwatts = dataa.userValue.properties.electricity_consumption_kwatts
              var payment_amount_per_kwh = dataa.userValue.properties.payment_amount_per_kwh
              var _sub_sizing_factor = dataa.userValue.properties.sub_sizing_factor
              var subscription_size_kwac = dataa.userValue.properties.subscription_size_kwac
              var gross_electricity_production = dataa.userValue.properties.gross_electricity_production
              var utility_rate = dataa.userValue.properties.utility_rate
              var estimatedAnnualEleCost = gross_electricity_production * utility_rate
              storage.rawSet("usage_period_from", usage_period_from)
              storage.rawSet("usage_period_to", usage_period_to)
              storage.rawSet("usage_period_days", usage_period_days)
              storage.rawSet("electricity_consumption_Wh", electricity_consumption_wh)
              storage.rawSet("electricity_consumption_davg_Wh", electricity_consumption_davg_wh)
              storage.rawSet("electricity_consumption_Watts", electricity_consumption_watts)
              storage.rawSet("electricity_consumption_kWh", electricity_consumption_kwh)
              storage.rawSet("electricity_consumption_davg_kWh", electricity_consumption_davg_kwh)
              storage.rawSet("electricity_consumption_kWatts", electricity_consumption_kwatts)
              storage.rawSet("subscription_size_kWAC", subscription_size_kwac)
              storage.rawSet("gross_electricity_production", gross_electricity_production)
              storage.rawSet("payment_amount_per_kwh", payment_amount_per_kwh)
              storage.rawSet("estimatedAnnualEleCost", estimatedAnnualEleCost)
              if (log_attcode != null) {
                if (log_attcode.trim() !== "") {
                  if (log_attcode !== "null") {
                    storage.rawSet("repid", log_repid)
                    storage.rawSet("attcode", log_attcode)
                    storage.rawSet("referralUrl", log_refUrl)

                    const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.brokerAttribution}/rows?portalId=${window.__ENV__.dataPortalId}&attribution_code=${log_attcode}&default_broker_contact=1`
                    fetch(hubDBEndpoint, {
                      method: "GET",
                    })
                      .then((response) => response.json())
                      .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
                        const rows = data.objects
                        if (rows.length >= 1) {
                          for (var i = 0; i < rows.length; i++) {
                            const element = rows[i]
                            if (element.values["5"].includes(log_repid) && element.values["5"].includes(log_attcode)) {
                              var brokerRepPhoneNo = element.values["6"]
                              var brokerRepEmail = element.values["7"]
                              var brokerRepTitle = element.values["9"]
                              var brokerRepName = element.values["4"]
                              var brokerCompany = element.values["2"]
                              if (element.values["8"] !== undefined) {
                                var brokerRepImage = element.values["8"].url
                                storage.rawSet("brokerRepImage", brokerRepImage)
                              }
                              if (element.values["13"] !== undefined) {
                                var brokerMeetingUrl = element.values["13"].url
                                storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                              }
                              storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                              storage.rawSet("brokerRepEmail", brokerRepEmail)
                              storage.rawSet("brokerRepTitle", brokerRepTitle)
                              if (brokerRepName !== undefined) {
                                storage.rawSet("brokerRepName", brokerRepName)
                              }
                              storage.rawSet("brokerCompany", brokerCompany)
                              storage.rawSet("sidebarBrokerDisplay", "Yes")
                              break
                            } else {
                              if (i === rows.length - 1) {
                                // Code to execute on the last iteration
                                for (var k = 0; k < rows.length; k++) {
                                  const elementt = rows[k]
                                  if (elementt.values["5"].includes(log_attcode)) {
                                    if (elementt.values["12"] === 1) {
                                      var brokerRepPhoneNo = elementt.values["6"]
                                      var brokerRepEmail = elementt.values["7"]
                                      var brokerRepTitle = elementt.values["9"]
                                      var brokerRepName = elementt.values["4"]
                                      var brokerCompany = elementt.values["2"]
                                      if (elementt.values["8"] !== undefined) {
                                        var brokerRepImage = elementt.values["8"].url
                                        storage.rawSet("brokerRepImage", brokerRepImage)
                                      }
                                      if (elementt.values["13"] !== undefined) {
                                        var brokerMeetingUrl = elementt.values["13"].url
                                        storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                                      }
                                      storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                                      storage.rawSet("brokerRepEmail", brokerRepEmail)
                                      storage.rawSet("brokerRepTitle", brokerRepTitle)
                                      if (brokerRepName !== undefined) {
                                        storage.rawSet("brokerRepName", brokerRepName)
                                      }
                                      storage.rawSet("brokerCompany", brokerCompany)
                                      storage.rawSet("sidebarBrokerDisplay", "Yes")
                                      break
                                    } else {
                                      if (k === rows.length - 1) {
                                        storage.rawRemove("attcode")
                                        storage.rawRemove("repid")
                                        storage.rawSet("sidebarBrokerDisplay", "No")
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          storage.rawRemove("attcode")
                          storage.rawRemove("repid")
                          storage.rawSet("sidebarBrokerDisplay", "No")
                        }
                      })
                  }
                }
              }
              storage.rawSet("dealId", l_dealId)
            }
          } catch (error) {
            console.error("Error:", error)
          }
        }
        async function CheckIfUserExist(
          dealId,
          redirectUrl,
          particularSectionName,
          particularSectionValue,
          log_utilityID,
        ) {
__ea_trace("modules/self-serve/self-serve.ts","CheckIfUserExist",[dealId,redirectUrl,particularSectionName,particularSectionValue,log_utilityID],["dealId","redirectUrl","particularSectionName","particularSectionValue","log_utilityID"]);
          var email = storage.rawGet("logEmail")
          email = email.toLowerCase()
          storage.rawSet("dealId", dealId)
          var _catchdata = ""
          try {
            const data = {
              email: email,
            }
            const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            _catchdata = data
            const dataa = await response.json()
            responseFromAPI = JSON.stringify(dataa)
            if (dataa.message === "User Found") {
              await getUtilityNameFromDeal(dealId)
              var _log_referral_url = dataa.userValue.properties.referral_url
              var log_attribution_code = dataa.userValue.properties.attribution_code
              var recordId = dataa.userValue.properties.hs_object_id
              var firstName = dataa.userValue.properties.firstname
              var lastName = dataa.userValue.properties.lastname
              var onboardToken = dataa.userValue.properties.bayou_onboarding_token
              var home_phone = dataa.userValue.properties.phone
              var cell_phone = dataa.userValue.properties.mobilephone
              var dateOfBirth = dataa.userValue.properties.date_of_birth
              var bayouContactId = dataa.userValue.properties.bayou_id
              var is_enrolled_for_bayou = dataa.userValue.properties.is_enrolled_for_bayou
              storage.rawSet("RecordId", recordId)
              storage.rawSet("LoggedName", `${firstName} ${lastName}`)
              storage.rawSet("FirstName", firstName)
              storage.rawSet("LastName", lastName)
              storage.rawSet("CompanyName", `${firstName}&${lastName}`)
              storage.rawSet("DateOfBirth", dateOfBirth)
              storage.rawSet("onboarding_token", onboardToken)
              storage.rawSet("bayou_contact_id", bayouContactId)
              storage.rawSet("CellPhone", cell_phone)
              storage.rawSet("HomePhone", home_phone)
              var lcml = storage.rawGet("is_enrolled_for_bayou")
              if (lcml === "no") {
                storage.rawSet("is_enrolled_for_bayou", "no")
              } else {
                if (is_enrolled_for_bayou === "yes") {
                  storage.rawSet("is_enrolled_for_bayou", "yes")
                }
              }

              if (log_attribution_code != null && log_attribution_code !== "") {
                sampleOriginType = "Invite"
                sampleSessiontype = "Consumer Completing"
              } else {
                sampleOriginType = "Direct"
                sampleSessiontype = "Consumer Only"
              }
              await fillLocalStorage(log_utilityID)
              await SaveSessionDetailsOnLocalStorage(log_utilityID)

              await addDataToContactRecord(email, particularSectionValue)
              if (storage.rawGet("userEmail") !== email) {
                if (storage.rawGet("skipUsage") !== null) {
                  storage.rawRemove("skipUsage")
                }
              }
              storage.rawSet("userEmail", email.toLowerCase())
              //                 document.querySelector('#page_0_returning_user_widget #userNotExist').innerHTML = '';
              await addUserAgentData(redirectUrl, particularSectionName, particularSectionValue)
              var l_contactId = dataa.userValue.id
              storage.rawSet("contactId", l_contactId)
            }
          } catch (error) {
            console.error("Error:", error)
          }
        }

        /*** --------------------------- variations my info code ---------------------------------- ****/
        async function loggetAvalability(particularSectionValue) {
__ea_trace("modules/self-serve/self-serve.ts","loggetAvalability",[particularSectionValue],["particularSectionValue"]);
          var exampleUtilityId = storage.rawGet("utility_id")
          // live session config id 15223637
          const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id__eq=${exampleUtilityId}`
          const response = await fetch(hubDBEndpoint, { method: "GET" })
          const data = await response.json()
          const rows = data.objects
          var _IsUtilityIdMatched = false
          if (rows.length >= 1) {
            storage.rawSet("Session Config ID", rows[0].id)
            rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
              if (exampleUtilityId === element.values["1"]) {
                storage.rawSet("stateForLMIConfig", element.values["13"].name)
                storage.rawSet("UtilitySessionDetails", JSON.stringify(element.values))
                _IsUtilityIdMatched = true
                _utilityIdSession = element.values["1"]

                if (element.values["30"] === "1") {
                  _LmiAvailability = "Yes"
                } else if (element.values["30"] === "0") {
                  _LmiAvailability = "No"
                } else {
                  _LmiAvailability = ""
                }
                if (element.values["31"] === "1") {
                  _LmiCensusAvailability = "Yes"
                } else if (element.values["31"] === "0") {
                  _LmiCensusAvailability = "No"
                } else {
                  _LmiCensusAvailability = ""
                }
                logcheckLMIConfigurationVariation(particularSectionValue)
              } else {
              }
            })
          }
        }
        // check variation for the LMI page ----------------------------------------------------------------------------------------------
        async function logcheckLMIConfigurationVariation(_particularSectionValue) {
__ea_trace("modules/self-serve/self-serve.ts","logcheckLMIConfigurationVariation",[_particularSectionValue],["_particularSectionValue"]);
          // live site lmi configuration table id 15221612
          await logcheckUsageConfigurationVariation()
          await logcheckConsentConfigurationVariation()
        }
        // check variation for the LMI page ----------------------------------------------------------------------------------------------
        async function logcheckUsageConfigurationVariation() {
__ea_trace("modules/self-serve/self-serve.ts","logcheckUsageConfigurationVariation",[],[]);
          var _usageAvaiablity
          var rows
          var SessionLocalStorage = await JSON.parse(storage.rawGet("UtilitySessionDetails"))
          if (SessionLocalStorage["32"] === 0) {
            _usageAvaiablity = "No"
          } else if (SessionLocalStorage["32"] === 1) {
            _usageAvaiablity = "Yes"
          } else {
            _usageAvaiablity = ""
          }
          try {
            const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.usageConfig}/rows?portalId=${window.__ENV__.dataPortalId}&usage_required_for_contract__eq=Yes&origin_type__eq=${sampleOriginType}&session_type__eq=${sampleSessiontype}`

            const response = await fetch(hubDBEndpoint, { method: "GET" })
            const data = await response.json()
            rows = data.objects

            if (rows.length >= 1) {
              if (rows[0].values["5"].name === "Yes") {
                DisplayUsageElementList.push("UTILITY CREDENTIALS DISPLAY")
              }
              if (rows[0].values["7"].name === "Yes") {
                DisplayUsageElementList.push("CREATE UTILITY ACCOUNT DISPLAY")
              }
              if (rows[0].values["9"].name === "Yes") {
                DisplayUsageElementList.push("SKIP FOR NOW DISPLAY")
              }
              if (rows[0].values["11"].name === "Yes") {
                DisplayUsageElementList.push("UTILITY ACCOUNT NUMBER DISPLAY")
              }
              if (rows[0].values["13"].name === "Yes") {
                DisplayUsageElementList.push("BILL UPLOAD DISPLAY")
              }
              if (rows[0].values["6"].name === "Yes") {
                requireUsageElementList.push("UTILITY CREDENTIALS REQUIRED")
              }
              if (rows[0].values["8"].name === "Yes") {
                requireUsageElementList.push("CREATE UTILITY ACCOUNT REQUIRED")
              }
              if (rows[0].values["10"].name === "Yes") {
                requireUsageElementList.push("SKIP FOR NOW REQUIRED")
              }
              if (rows[0].values["12"].name === "Yes") {
                requireUsageElementList.push("UTILITY ACCOUNT NUMBER REQUIRED")
              }
              if (rows[0].values["14"].name === "Yes") {
                requireUsageElementList.push("BILL UPLOAD REQUIRED")
              }
              storage.rawSet("usageDisplayelementList", JSON.stringify(DisplayUsageElementList))
              storage.rawSet("usagerequireElementList", JSON.stringify(requireUsageElementList))
            } else {
              storage.rawSet("usageDisplayelementList", JSON.stringify(DisplayUsageElementList))
              storage.rawSet("usagerequireElementList", JSON.stringify(requireUsageElementList))
            }
          } catch (error) {
            console.error("Error in Usage hubdb fetch block:", error)
          }
        }
        async function logcheckConsentConfigurationVariation() {
__ea_trace("modules/self-serve/self-serve.ts","logcheckConsentConfigurationVariation",[],[]);
          var SessionLocalStorage = JSON.parse(storage.rawGet("UtilitySessionDetails"))
          if (SessionLocalStorage["33"] === 0) {
            consetPaymentReq = "No"
          } else if (SessionLocalStorage["33"] === 1) {
            consetPaymentReq = "Yes"
          } else {
            consetPaymentReq = "No"
          }
          const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.paymentConfig}/rows?portalId=${window.__ENV__.dataPortalId}&payment_required_for_billing__eq=${consetPaymentReq}&origin_type__eq=${sampleOriginType}&session_type__eq=${sampleSessiontype}`
          try {
            const response = await fetch(hubDBEndpoint, { method: "GET" })
            const data = await response.json()
            rows = data.objects

            if (rows.length >= 1) {
              if (rows[0].values["5"].name === "Yes") {
                DisplayConsentElementList.push("PAYMENT OPTIONS DISPLAY")
              }
              if (rows[0].values["7"].name === "Yes") {
                DisplayConsentElementList.push("AUTHORIZATION CONSENT DISPLAY")
              }
              if (rows[0].values["9"].name === "Yes") {
                DisplayConsentElementList.push("CREDIT CHECK CONSENT DISPLAY")
              }
              if (rows[0].values["11"].name === "Yes") {
                DisplayConsentElementList.push("SUBSCRIPTION SIGNATURE DISPLAY")
              }
              if (rows[0].values["13"].name === "Yes") {
                DisplayConsentElementList.push("SUB ACKNOWLEDGMENT DISPLAY")
              }
              if (rows[0].values["15"].name === "Yes") {
                DisplayConsentElementList.push("DISCLOSURE SIGNATURE DISPLAY")
              }
              if (rows[0].values["17"].name === "Yes") {
                DisplayConsentElementList.push("DISC ACKNOWLEDGMENT DISPLAY")
              }
              if (rows[0].values["19"].name === "Yes") {
                DisplayConsentElementList.push("SUBSCRIPTION SIGNATURE SIGN DISPLAY")
              }
              if (rows[0].values["21"].name === "Yes") {
                DisplayConsentElementList.push("DISCLOSURE SIGNATURE SIGNED DISPLAY")
              }

              if (rows[0].values["6"].name === "Yes") {
                requireConsentElementList.push("PAYMENT OPTIONS REQUIRED")
              }
              if (rows[0].values["8"].name === "Yes") {
                requireConsentElementList.push("AUTHORIZATION CONSENT REQUIRED")
              }
              if (rows[0].values["10"].name === "Yes") {
                requireConsentElementList.push("CREDIT CHECK CONSENT REQUIRED")
              }
              if (rows[0].values["12"].name === "Yes") {
                requireConsentElementList.push("SUBSCRIPTION SIGNATURE REQUIRED")
              }
              if (rows[0].values["14"].name === "Yes") {
                requireConsentElementList.push("SUB ACKNOWLEDGMENT REQUIRED")
              }
              if (rows[0].values["16"].name === "Yes") {
                requireConsentElementList.push("DISCLOSURE SIGNATURE REQUIRED")
              }
              if (rows[0].values["18"].name === "Yes") {
                requireConsentElementList.push("DISC ACKNOWLEDGMENT REQUIRED")
              }
              if (rows[0].values["20"].name === "Yes") {
                requireConsentElementList.push("SUBSCRIPTION SIGNATURE SIGN REQUIRED")
              }
              if (rows[0].values["22"].name === "Yes") {
                requireConsentElementList.push("DISCLOSURE SIGNATURE SIGNED REQUIRED")
              }
              storage.rawSet("consentDisplayelementList", JSON.stringify(DisplayConsentElementList))
              storage.rawSet("consentrequireElementList", JSON.stringify(requireConsentElementList))
            } else {
              storage.rawSet("consentDisplayelementList", JSON.stringify(DisplayConsentElementList))
              storage.rawSet("consentrequireElementList", JSON.stringify(requireConsentElementList))
            }
          } catch (error) {
            console.error("Error in Usage hubdb fetch block:", error)
          }
        }
        /*** ----------------------------------------- variations my info code ----------------------------------------- ****/
        // ------------- get Deal stage and redirect the page accordingly -------------------------------
        async function CheckDealStageAndRedirectAccordingly(
          redirectUrl,
          particularSectionName,
          particularSectionValue,
        ) {
__ea_trace("modules/self-serve/self-serve.ts","CheckDealStageAndRedirectAccordingly",[redirectUrl,particularSectionName,particularSectionValue],["redirectUrl","particularSectionName","particularSectionValue"]);
          storage.rawSet(particularSectionName, particularSectionValue)
          window.location.href = redirectUrl
        }
        // ------------- get Deal stage and redirect the page accordingly -------------------------------

        async function viewDealItems(dealId) {
__ea_trace("modules/self-serve/self-serve.ts","viewDealItems",[dealId],["dealId"]);
          var _catchdata = ""
          try {
            const data = {
              deal_id: dealId,
            }
            const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
            _catchdata = data
            const dataa = await response.json()
            responseFromAPI = JSON.stringify(dataa)
            var l_dealStage = dataa.userValue.properties.dealstage
            var completionDate = dataa.userValue.properties.hs_v2_date_entered_127892575
            var completionDateIl = dataa.userValue.properties.hs_v2_date_entered_984219225
            var _log_email = dataa.userValue.properties.deal_email_test
            var _l_dealId = dataa.userValue.id

            var street_address_1 = dataa.userValue.properties.street_address
            var street_address_2 = dataa.userValue.properties.street_address_2
            if (street_address_2 == null) {
              street_address_2 = ""
            }
            var service_city = dataa.userValue.properties.city
            var service_state_abbreviation = dataa.userValue.properties.service_state_abbreviation
            var _county = dataa.userValue.properties.county
            var Service_postal_code = dataa.userValue.properties.postal_code
            var enrollment_number = dataa.userValue.properties.enrollment_number
            var _utility_account_number = dataa.userValue.properties.uan_1_value
            var comb_utility_account_number = dataa.userValue.properties.combined_utility_account_number
            if (comb_utility_account_number == null || comb_utility_account_number === "") {
              comb_utility_account_number = "Not Yet Provided"
            }
            var payment_method = dataa.userValue.properties.payment_method
            if (payment_method === "Credit Card") {
              payment_method = "CC"
            }
            var lmi_optionn = dataa.userValue.properties.lmi_option
            var lmi_option = "Yes"
            if (lmi_optionn === "Threshold Opt-Out") {
              lmi_option = "No"
            } else {
              lmi_option = "Yes"
            }
            var dealStage

            // storage.rawSet("repid", log_repid);
            if (l_dealStage === 127892578 /* completed */) {
              dealStage = "Complete"
            } else if (l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */) {
              dealStage = "Complete"
            } else if (l_dealStage === 127892575 /* Staged (Sales Pipeline) */) {
              dealStage = "Complete"
            } else if (l_dealStage === 127892570 /* Submitted (Sales Pipeline) */) {
              dealStage = "Complete"
            } else if (l_dealStage === 984278689 /* 7. Submitted (IL Pipeline) */) {
              dealStage = "Complete"
            } else if (l_dealStage === 984219225 /* 8. Staged (IL Pipeline) */) {
              dealStage = "Complete"
            } else if (l_dealStage === 984341032 /* 9. Interfaced (IL Pipeline) */) {
              dealStage = "Complete"
            } else if (l_dealStage === 157471033 /* Account Created (Sales Pipeline) */) {
              dealStage = "My Info"
            } else if (l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */) {
              dealStage = "My Usage"
            } else if (l_dealStage === 157471034 /* My Info (Sales Pipeline) */) {
              dealStage = "My Info"
            } else if (l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */) {
              dealStage = "My Info"
            } else if (l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */) {
              dealStage = "My Info"
            } else if (l_dealStage === 127892569 /* Usage (Sales Pipeline) */) {
              dealStage = "My Usage"
            } else if (l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */) {
              dealStage = "My Usage"
            } else if (l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */) {
              dealStage = "My Usage"
            } else if (l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */) {
              dealStage = "My Consent"
            } else if (l_dealStage === 127892568 /* Consent All (Sales Pipeline) */) {
              dealStage = "My Consent"
            } else if (l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */) {
              dealStage = "My Consent"
            } else if (l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */) {
              dealStage = "My Consent"
            } else if (l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */) {
              dealStage = "My Consent"
            } else if (l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */) {
              dealStage = "My Usage"
            } else if (l_dealStage === 127892572 /* Verify LMI (Sales Pipeline) */) {
              dealStage = "My Info"
            } else if (l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */) {
              dealStage = "Complete"
            } else if (l_dealStage === 127892574 /* Verified (Sales Pipeline) */) {
              dealStage = "Complete"
            } else if (l_dealStage === 127892577 /* Dormant (Sales Pipeline) */) {
              dealStage = "Dormant"
            } else if (l_dealStage === 127892579 /* Graveyard (Sales Pipeline) */) {
              dealStage = "Graveyard"
            } else if (l_dealStage === 984341033 /* Dormant (IL Pipeline) */) {
              dealStage = "Dormant"
            } else if (l_dealStage === 984341035 /* Graveyard (IL Pipeline) */) {
              dealStage = "Graveyard"
            } else if (l_dealStage === 127892580 /* Trashcan (Sales Pipeline) */) {
              dealStage = "Trashcan"
            } else if (l_dealStage === 984341036 /* Trashcan (IL Pipeline)  */) {
              dealStage = "Trashcan"
            } else if (l_dealStage === 157471031 /* Assisted Create (Sales Pipeline) */) {
              dealStage = "Assisted Create"
            } else if (l_dealStage === 157471032 /* Invite Sent (Sales Pipeline) */) {
              dealStage = "Invite Sent"
            } else {
              dealStage = "Pending"
            }
            var name = storage.rawGet("name")
            var firstname = storage.rawGet("FirstName")
            var lastname = storage.rawGet("LastName")
            var dateOfBirth = storage.rawGet("DateOfBirth")
            //                     var dateOfBirth = storage.rawGet("DateOfBirth");
            var logEmail = storage.rawGet("logEmail")
            /* header content */
            var contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-header")
            if (contentListSelector) {
              contentListSelector.innerHTML = ""
            }
            var _contentList = `<ul><li>Account #${comb_utility_account_number}</li><li>${name}</li></ul>`
            contentListSelector.innerHTML += contentList

            var contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            if (contentListSelector) {
              contentListSelector.innerHTML = ""
            }
            var _contentList = `<ul><li class="accountDetailsViewTitle">Status</li><li>${dealStage}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            if (storage.rawGet("FarmStateAbbreviation") === "IL") {
              completionDate = completionDateIl
            } else {
            }
            var dateObject = new Date(completionDate)
            // Format the date to YYYY-MM-DD
            var year = dateObject.getFullYear()
            var month = (dateObject.getMonth() + 1).toString().padStart(2, "0")
            var day = dateObject.getDate().toString().padStart(2, "0")
            completionDate = `${month}/${day}/${year}`
            if (year <= 2023) {
              completionDate = ""
            }
            var _contentList = `<ul><li class="accountDetailsViewTitle">Completion Date</li><li>${completionDate}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">First Name</li><li>${firstname}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">Last Name</li><li>${lastname}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            function _formatDateWithoutTimezone(dateString) {
__ea_trace("modules/self-serve/self-serve.ts","_formatDateWithoutTimezone",[dateString],["dateString"]);
              const [year, month, day] = dateString.split("-")
              return `${month}/${day}/${year}`
            }
            var _contentList = `<ul><li class="accountDetailsViewTitle">DOB</li><li>${dateOfBirth}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">Email Address</li><li>${logEmail}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">Service Address</li><li>${street_address_1}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">Service Address 2</li><li>${street_address_2}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">Service City</li><li>${service_city}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">Service State</li><li>${service_state_abbreviation}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">Service Zip Code</li><li>${Service_postal_code}</li></ul>`
            contentListSelector.innerHTML += contentList

            if (enrollment_number != null) {
              var contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
              var contentList = `<ul><li class="accountDetailsViewTitle">Enrollment Number</li><li>${enrollment_number}</li></ul>`
              contentListSelector.innerHTML += contentList
            }
            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">Utility Account Number</li><li>${comb_utility_account_number}</li></ul>`
            contentListSelector.innerHTML += contentList

            var _contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var _contentList = `<ul><li class="accountDetailsViewTitle">Payment Type</li><li>${payment_method}</li></ul>`
            contentListSelector.innerHTML += contentList

            var contentListSelector = document.querySelector(".accountDetailsView-inner .accountDetailsView-content")
            var contentList = `<ul><li class="accountDetailsViewTitle qDLID">Qualifies for Low-Income Discount</li><li class="qDLID">${lmi_option}</li></ul>`
            contentListSelector.innerHTML += contentList

            if (lmi_optionn == null || lmi_optionn === "") {
              document.querySelectorAll(".qDLID").forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                li.style.display = "none"
              })
            } else {
              document.querySelectorAll(".qDLID").forEach((li) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[li],["li"]);
                li.style.display = "block"
              })
            }

            closeProgressBar()
            showDetailsViewPopup()
          } catch (error) {
            console.error("Error:", error)
            closeProgressBar()
          }
        }

        // Index Db Part
        var request = indexedDB.open("myDatabase", 1)
        var db
        request.onerror = (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
          console.log(`Database error: ${(event.target as any).errorCode}`)
        }
        request.onsuccess = (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
          db = event.target.result
        }
        request.onupgradeneeded = (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
          var db = event.target.result

          // Create an object store (similar to a table in relational databases)
          var objectStore = db.createObjectStore("files", { autoIncrement: true })

          // Optionally, you can create indexes for efficient querying
          objectStore.createIndex("name", "name", { unique: false })
        }
        function clearDatabase() {
__ea_trace("modules/self-serve/self-serve.ts","clearDatabase",[],[]);
          var transaction = db.transaction(db.objectStoreNames, "readwrite")

          transaction.oncomplete = (_event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[_event],["_event"]);}

          transaction.onerror = (_event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[_event],["_event"]);}

          Array.from(db.objectStoreNames).forEach((storeName) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[storeName],["storeName"]);
            var objectStore = transaction.objectStore(storeName)
            objectStore.clear()
          })
        }

        if (dealRecordLength === 1) {
          if (
            openDealsCount === 1 &&
            (subsciptionRecordLength === 0 ||
              subsciptionRecordLength == null ||
              subsciptionRecordLength === undefined ||
              subsciptionRecordLength === "")
          ) {
            storage.rawSet("is_enrolled_for_bayou", "no")
            var myInfoButton = document.querySelector(".lastBtn.list_manage.allStepsRemaining")
            var lmiManualButton = document.querySelector(".lastBtn.list_manage.MyInfo")
            var usageButton = document.querySelector(".lastBtn.list_manage.UtilityInformation")
            var consentSignatureButton = document.querySelector(".lastBtn.list_manage.ContractSignatures")
            var consentAllButton = document.querySelector(".lastBtn.list_manage.PaymentInfo")
            var verifyUtilityButton = document.querySelector(".lastBtn.list_manage.UtilityCredentials")
            var verifyACHButton = document.querySelector(".lastBtn.list_manage.VeryfyACH")
            /* ---------------------------------- Start click event of myInfo --------------------------------- */
            if (myInfoButton) {
              openProgressBar()

              var ulElement = myInfoButton.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")

              storage.rawSet("FarmStateAbbreviation", stateAB)

              var redirectUrl = "/my-info?mltenlmt"
              var particularSectionName = false
              var particularSectionValue = false

              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            }
            /* ---------------------------------- Start click event of myInfo --------------------------------- */
            /* ---------------------------------- Start click event of lmi --------------------------------- */
            if (lmiManualButton) {
              openProgressBar()
              //                     clearDatabase();

              var ulElement = lmiManualButton.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")

              storage.rawSet("FarmStateAbbreviation", stateAB)

              var redirectUrl = "/my-info?mltenlmt"
              var particularSectionName = "mil"
              var particularSectionValue = "MiLM"

              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            }
            /* ---------------------------------- Start click event of lmi --------------------------------- */
            /* ---------------------------------- Start click event of myUsage --------------------------------- */
            if (usageButton) {
              ;(async () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
                var ulElement = usageButton.closest("ul")
                /* getting credential provider */
                var exampleUtilityId = ulElement.getAttribute("utilityid")
                const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id__eq=${exampleUtilityId}`
                const response = await fetch(hubDBEndpoint, { method: "GET" })
                const data = await response.json()
                const rows = data.objects

                if (rows.length >= 1) {
                  rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
                    if (exampleUtilityId === element.values["1"]) {
                      storage.rawSet("SessionDetails", JSON.stringify(element.values))
                      if (element.values["24"] !== undefined) {
                        storage.rawSet("credentialProvider", element.values["24"].name)
                      }
                    }
                  })
                }
                /* getting credential provider */
                openProgressBar()
                //                         clearDatabase();

                var credentialProvider = storage.rawGet("credentialProvider")
                var dealId = ulElement.getAttribute("dealid")
                var stateAB = ulElement.getAttribute("stabr")
                storage.rawSet("FarmStateAbbreviation", stateAB)
                var lmioption = ulElement.getAttribute("lmioption")
                storage.rawSet("lmi_option", lmioption)

                var redirectUrl = ""

                if (stateAB === "IL") {
                  redirectUrl = "/il-usage"
                } else {
                  if (credentialProvider === "NSE (Hansen)" && lmioption === "Threshold Opt-Out") {
                    redirectUrl = "/my-usage"
                  } else if (
                    credentialProvider === "Bayou" &&
                    (lmioption === "Threshold Opt-Out" ||
                      lmioption === null ||
                      lmioption === undefined ||
                      lmioption === "null" ||
                      lmioption === "undefined" ||
                      lmioption === "")
                  ) {
                    redirectUrl = "/myusage"
                  } else if (credentialProvider === "Bayou") {
                    redirectUrl = "/my_usage"
                  } else if (credentialProvider === "NSE (Hansen)") {
                    redirectUrl = "/my-usage-lh"
                  } else {
                    redirectUrl = "/my-usage"
                  }
                }

                var particularSectionName = false
                var particularSectionValue = false

                CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, exampleUtilityId)
              })()
            }
            /* ---------------------------------- Start click event of myUsage --------------------------------- */
            /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
            if (consentSignatureButton) {
              openProgressBar()
              //                     clearDatabase();

              var ulElement = consentSignatureButton.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              storage.rawSet("FarmStateAbbreviation", stateAB)

              var redirectUrl = ""
              if (stateAB === "IL") {
                redirectUrl = "/il-my-consent"
              } else {
                redirectUrl = "/my-consent"
              }

              var particularSectionName = "rp"
              var particularSectionValue = "NpEv"

              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            }
            /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
            /* ---------------------------------- Start click event of MyConsent ConsentAll --------------------------------- */
            if (consentAllButton) {
              openProgressBar()
              //                     clearDatabase();

              var ulElement = consentAllButton.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              storage.rawSet("FarmStateAbbreviation", stateAB)

              var redirectUrl = "/my-consent"
              var particularSectionName = "rp"
              var particularSectionValue = "QxtVq"

              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            }
            /* ---------------------------------- Start click event of MyConsent ConsentAll --------------------------------- */
            /* ---------------------------------- Start click event of Verify Utility --------------------------------- */
            if (verifyUtilityButton) {
              openProgressBar()
              //                     clearDatabase();

              var ulElement = verifyUtilityButton.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              var sbs = ulElement.getAttribute("sbs")

              storage.rawSet("FarmStateAbbreviation", stateAB)

              var redirectUrl = sbs === "Yes" ? "/myusageverification" : "/my-usage-verification"

              var particularSectionName = false
              var particularSectionValue = false

              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            }
            /* ---------------------------------- Start click event of Verify Utility --------------------------------- */
            /* ---------------------------------- Start click event of Verify ACH --------------------------------- */
            if (verifyACHButton) {
              openProgressBar()
              //                     clearDatabase();

              var ulElement = verifyACHButton.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              var _sbs = ulElement.getAttribute("sbs")

              storage.rawSet("FarmStateAbbreviation", stateAB)

              var redirectUrl = "/ach-verification-page"

              var particularSectionName = false
              var particularSectionValue = false

              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            }
            /* ---------------------------------- Start click event of Verify ACH --------------------------------- */
          } else {
            // Get all elements with the class 'lastBtn list_manage'
            var viewDetailButtons = document.querySelectorAll(".lastBtn.list_manage.submitted")
            var myInfoButton = document.querySelectorAll(".lastBtn.list_manage.allStepsRemaining")
            var lmiManualButton = document.querySelectorAll(".lastBtn.list_manage.MyInfo")
            var usageButton = document.querySelectorAll(".lastBtn.list_manage.UtilityInformation")
            var consentSignatureButton = document.querySelectorAll(".lastBtn.list_manage.ContractSignatures")
            var consentAllButton = document.querySelectorAll(".lastBtn.list_manage.PaymentInfo")
            var verifyUtilityButton = document.querySelectorAll(".lastBtn.list_manage.UtilityCredentials")
            var verifyACHButton = document.querySelector(".lastBtn.list_manage.VeryfyACH")

            /* ---------------------------------- Start click event of viewDetail --------------------------------- */
            viewDetailButtons.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
              button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
                openProgressBar()
                event.preventDefault()

                var ulElement = event.target.closest("ul")
                var dealId = ulElement.getAttribute("dealid")
                var stateAB = ulElement.getAttribute("stabr")
                viewDealItems(dealId, stateAB)
              })
            })
            /* ---------------------------------- End click event of viewDetail --------------------------------- */
            /* ---------------------------------- Start click event of myInfo --------------------------------- */
            myInfoButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
              button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
                storage.rawSet("is_enrolled_for_bayou", "no")
                openProgressBar()
                clearDatabase()
                event.preventDefault()
                var ulElement = event.target.closest("ul")
                var dealId = ulElement.getAttribute("dealid")
                var stateAB = ulElement.getAttribute("stabr")
                var utilityid = ulElement.getAttribute("utilityid")
                storage.rawSet("FarmStateAbbreviation", stateAB)
                var redirectUrl = "/my-info?mltenlmt"
                var particularSectionName = false
                var particularSectionValue = false
                CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
              })
            })
            /* ---------------------------------- Start click event of myInfo --------------------------------- */
            /* ---------------------------------- Start click event of lmi --------------------------------- */
            lmiManualButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
              button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
                storage.rawSet("is_enrolled_for_bayou", "no")
                openProgressBar()
                clearDatabase()
                event.preventDefault()
                var ulElement = event.target.closest("ul")
                var dealId = ulElement.getAttribute("dealid")
                var stateAB = ulElement.getAttribute("stabr")
                var utilityid = ulElement.getAttribute("utilityid")
                storage.rawSet("FarmStateAbbreviation", stateAB)
                var redirectUrl = "/my-info?mltenlmt"
                var particularSectionName = "mil"
                var particularSectionValue = "MiLM"
                CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
              })
            })
            /* ---------------------------------- Start click event of lmi --------------------------------- */
            /* ---------------------------------- Start click event of myUsage --------------------------------- */
            usageButton.forEach(async (button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
              button.addEventListener("click", async (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
                storage.rawSet("is_enrolled_for_bayou", "no")
                var _ulElement = event.target.closest("ul")
                /* getting credential provider */
                var exampleUtilityId = ulElement.getAttribute("utilityid")
                const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id__eq=${exampleUtilityId}`
                const response = await fetch(hubDBEndpoint, { method: "GET" })
                const data = await response.json()
                const rows = data.objects
                if (rows.length >= 1) {
                  //                     storage.rawSet('Config ID', rows[0].id);
                  rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
                    if (exampleUtilityId === element.values["1"]) {
                      storage.rawSet("SessionDetails", JSON.stringify(element.values))
                      if (element.values["24"] !== undefined) {
                        storage.rawSet("credentialProvider", element.values["24"].name)
                      }
                    }
                  })
                } else {
                }

                /* getting credential provider */

                openProgressBar()
                clearDatabase()
                event.preventDefault()
                var credentialProvider = storage.rawGet("credentialProvider")
                var ulElement = event.target.closest("ul")
                var dealId = ulElement.getAttribute("dealid")
                var stateAB = ulElement.getAttribute("stabr")
                storage.rawSet("FarmStateAbbreviation", stateAB)
                var lmioption = ulElement.getAttribute("lmioption")
                storage.rawSet("lmi_option", lmioption)
                var redirectUrl = ""
                if (storage.rawGet("FarmStateAbbreviation") === "IL") {
                  redirectUrl = "/il-usage" // redirect to normal hansen myusage page
                } else {
                  if (credentialProvider === "NSE (Hansen)" && lmioption === "Threshold Opt-Out") {
                    redirectUrl = "/my-usage" // redirect to normal hansen myusage page
                  } else if (credentialProvider === "Bayou" && lmioption === "Threshold Opt-Out") {
                    redirectUrl = "/myusage" // redirect to normal bayou myusage page
                  } else if (credentialProvider === "Bayou" && lmioption == null) {
                    redirectUrl = "/myusage" // redirect to normal bayou myusage page
                  } else if (credentialProvider === "Bayou" && lmioption === undefined) {
                    redirectUrl = "/myusage" // redirect to normal bayou myusage page
                  } else if (credentialProvider === "Bayou" && lmioption === "null") {
                    redirectUrl = "/myusage" // redirect to normal bayou myusage page
                  } else if (credentialProvider === "Bayou" && lmioption === "undefined") {
                    redirectUrl = "/myusage" // redirect to normal bayou myusage page
                  } else if (credentialProvider === "Bayou" && lmioption === "") {
                    redirectUrl = "/myusage" // redirect to normal bayou myusage page
                  } else if (credentialProvider === "Bayou") {
                    redirectUrl = "/my_usage" // redirect to lmi bayou myusage page
                  } else if (credentialProvider === "NSE (Hansen)") {
                    redirectUrl = "/my-usage-lh" // redirect to lmi hansen myusage page
                  } else {
                    redirectUrl = "/my-usage"
                  }
                }

                var particularSectionName = false
                var particularSectionValue = false
                CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, exampleUtilityId)
              })
            })
            /* ---------------------------------- Start click event of myUsage --------------------------------- */
            /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
            consentSignatureButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
              button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
                storage.rawSet("is_enrolled_for_bayou", "no")
                openProgressBar()
                clearDatabase()
                event.preventDefault()
                var ulElement = event.target.closest("ul")
                var dealId = ulElement.getAttribute("dealid")
                var stateAB = ulElement.getAttribute("stabr")
                var utilityid = ulElement.getAttribute("utilityid")
                storage.rawSet("FarmStateAbbreviation", stateAB)
                var redirectUrl = ""
                if (storage.rawGet("FarmStateAbbreviation") === "IL") {
                  redirectUrl = "/il-my-consent" // redirect to normal hansen myusage page
                } else {
                  redirectUrl = "/my-consent"
                }
                var particularSectionName = "rp"
                var particularSectionValue = "NpEv"
                CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
              })
            })
            /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
            /* ---------------------------------- Start click event of MyConsent ConsentAll --------------------------------- */
            consentAllButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
              button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
                storage.rawSet("is_enrolled_for_bayou", "no")
                openProgressBar()
                clearDatabase()
                event.preventDefault()
                var ulElement = event.target.closest("ul")
                var dealId = ulElement.getAttribute("dealid")
                var stateAB = ulElement.getAttribute("stabr")
                var utilityid = ulElement.getAttribute("utilityid")
                storage.rawSet("FarmStateAbbreviation", stateAB)
                var redirectUrl = "/my-consent"
                var particularSectionName = "rp"
                var particularSectionValue = "QxtVq"
                CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
              })
            })
            /* ---------------------------------- Start click event of MyConsent ConsentAll --------------------------------- */
            /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
            verifyUtilityButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
              button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
                storage.rawSet("is_enrolled_for_bayou", "no")
                openProgressBar()
                clearDatabase()
                event.preventDefault()
                var ulElement = event.target.closest("ul")
                var dealId = ulElement.getAttribute("dealid")
                var stateAB = ulElement.getAttribute("stabr")
                var utilityid = ulElement.getAttribute("utilityid")
                storage.rawSet("FarmStateAbbreviation", stateAB)
                var sbs = ulElement.getAttribute("sbs")
                if ((sbs = "Yes")) {
                  var _redirectUrl = "/myusageverification"
                } else {
                  var redirectUrl = "/my-usage-verification"
                }
                var particularSectionName = false
                var particularSectionValue = false
                CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
              })
            })
            /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
            if (verifyACHButton) {
              openProgressBar()
              //                     clearDatabase();

              var ulElement = verifyACHButton.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              var _sbs = ulElement.getAttribute("sbs")

              storage.rawSet("FarmStateAbbreviation", stateAB)

              var redirectUrl = "/ach-verification-page"

              var particularSectionName = false
              var particularSectionValue = false

              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            }
          }
        } else {
          // Get all elements with the class 'lastBtn list_manage'
          var viewDetailButtons = document.querySelectorAll(".lastBtn.list_manage.submitted")
          var myInfoButton = document.querySelectorAll(".lastBtn.list_manage.allStepsRemaining")
          var lmiManualButton = document.querySelectorAll(".lastBtn.list_manage.MyInfo")
          var usageButton = document.querySelectorAll(".lastBtn.list_manage.UtilityInformation")
          var consentSignatureButton = document.querySelectorAll(".lastBtn.list_manage.ContractSignatures")
          var consentAllButton = document.querySelectorAll(".lastBtn.list_manage.PaymentInfo")
          var verifyUtilityButton = document.querySelectorAll(".lastBtn.list_manage.UtilityCredentials")
          var verifyACHButton = document.querySelector(".lastBtn.list_manage.VeryfyACH")

          /* ---------------------------------- Start click event of viewDetail --------------------------------- */
          viewDetailButtons.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
            button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
              openProgressBar()
              event.preventDefault()
              var ulElement = event.target.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              viewDealItems(dealId, stateAB)
            })
          })
          /* ---------------------------------- End click event of viewDetail --------------------------------- */
          /* ---------------------------------- Start click event of myInfo --------------------------------- */
          myInfoButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
            button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
              openProgressBar()
              clearDatabase()
              event.preventDefault()
              var ulElement = event.target.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              storage.rawSet("FarmStateAbbreviation", stateAB)
              var redirectUrl = "/my-info?mltenlmt"
              var particularSectionName = false
              var particularSectionValue = false
              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            })
          })
          /* ---------------------------------- Start click event of myInfo --------------------------------- */
          /* ---------------------------------- Start click event of lmi --------------------------------- */
          lmiManualButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
            button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
              openProgressBar()
              clearDatabase()
              event.preventDefault()
              var ulElement = event.target.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              storage.rawSet("FarmStateAbbreviation", stateAB)
              var redirectUrl = "/my-info?mltenlmt"
              var particularSectionName = "mil"
              var particularSectionValue = "MiLM"
              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            })
          })
          /* ---------------------------------- Start click event of lmi --------------------------------- */
          /* ---------------------------------- Start click event of myUsage --------------------------------- */
          usageButton.forEach(async (button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
            button.addEventListener("click", async (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
              var _ulElement = event.target.closest("ul")
              /* getting credential provider */
              var exampleUtilityId = ulElement.getAttribute("utilityid")
              const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id__eq=${exampleUtilityId}`
              const response = await fetch(hubDBEndpoint, { method: "GET" })
              const data = await response.json()
              const rows = data.objects
              if (rows.length >= 1) {
                //                     storage.rawSet('Config ID', rows[0].id);
                rows.forEach((element) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[element],["element"]);
                  if (exampleUtilityId === element.values["1"]) {
                    storage.rawSet("SessionDetails", JSON.stringify(element.values))
                    if (element.values["24"] !== undefined) {
                      storage.rawSet("credentialProvider", element.values["24"].name)
                    }
                  }
                })
              }

              /* getting credential provider */

              openProgressBar()
              clearDatabase()
              event.preventDefault()
              var credentialProvider = storage.rawGet("credentialProvider")
              var ulElement = event.target.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              storage.rawSet("FarmStateAbbreviation", stateAB)
              var lmioption = ulElement.getAttribute("lmioption")
              storage.rawSet("lmi_option", lmioption)
              var redirectUrl = ""
              if (storage.rawGet("FarmStateAbbreviation") === "IL") {
                redirectUrl = "/il-usage" // redirect to normal hansen myusage page
              } else {
                if (credentialProvider === "NSE (Hansen)" && lmioption === "Threshold Opt-Out") {
                  redirectUrl = "/my-usage" // redirect to normal hansen myusage page
                } else if (credentialProvider === "Bayou" && lmioption === "Threshold Opt-Out") {
                  redirectUrl = "/myusage" // redirect to normal bayou myusage page
                } else if (credentialProvider === "Bayou" && lmioption == null) {
                  redirectUrl = "/myusage" // redirect to normal bayou myusage page
                } else if (credentialProvider === "Bayou" && lmioption === undefined) {
                  redirectUrl = "/myusage" // redirect to normal bayou myusage page
                } else if (credentialProvider === "Bayou" && lmioption === "null") {
                  redirectUrl = "/myusage" // redirect to normal bayou myusage page
                } else if (credentialProvider === "Bayou" && lmioption === "undefined") {
                  redirectUrl = "/myusage" // redirect to normal bayou myusage page
                } else if (credentialProvider === "Bayou" && lmioption === "") {
                  redirectUrl = "/myusage" // redirect to normal bayou myusage page
                } else if (credentialProvider === "Bayou") {
                  redirectUrl = "/my_usage" // redirect to lmi bayou myusage page
                } else if (credentialProvider === "NSE (Hansen)") {
                  redirectUrl = "/my-usage-lh" // redirect to lmi hansen myusage page
                } else {
                  redirectUrl = "/my-usage"
                }
              }

              var particularSectionName = false
              var particularSectionValue = false
              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, exampleUtilityId)
            })
          })
          /* ---------------------------------- Start click event of myUsage --------------------------------- */
          /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
          consentSignatureButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
            button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
              openProgressBar()
              clearDatabase()
              event.preventDefault()
              var ulElement = event.target.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              storage.rawSet("FarmStateAbbreviation", stateAB)
              var redirectUrl = ""
              if (storage.rawGet("FarmStateAbbreviation") === "IL") {
                redirectUrl = "/il-my-consent" // redirect to normal hansen myusage page
              } else {
                redirectUrl = "/my-consent"
              }
              var particularSectionName = "rp"
              var particularSectionValue = "NpEv"
              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            })
          })
          /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
          /* ---------------------------------- Start click event of MyConsent ConsentAll --------------------------------- */
          consentAllButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
            button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
              openProgressBar()
              clearDatabase()
              event.preventDefault()
              var ulElement = event.target.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              storage.rawSet("FarmStateAbbreviation", stateAB)
              var redirectUrl = "/my-consent"
              var particularSectionName = "rp"
              var particularSectionValue = "QxtVq"
              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            })
          })
          /* ---------------------------------- Start click event of MyConsent ConsentAll --------------------------------- */
          /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
          verifyUtilityButton.forEach((button) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[button],["button"]);
            button.addEventListener("click", (event) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[event],["event"]);
              openProgressBar()
              clearDatabase()
              event.preventDefault()
              var ulElement = event.target.closest("ul")
              var dealId = ulElement.getAttribute("dealid")
              var stateAB = ulElement.getAttribute("stabr")
              var utilityid = ulElement.getAttribute("utilityid")
              storage.rawSet("FarmStateAbbreviation", stateAB)
              var sbs = ulElement.getAttribute("sbs")
              if ((sbs = "Yes")) {
                var _redirectUrl = "/myusageverification"
              } else {
                var redirectUrl = "/my-usage-verification"
              }
              var particularSectionName = false
              var particularSectionValue = false
              CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
            })
          })
          /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
          if (verifyACHButton) {
            openProgressBar()
            //                     clearDatabase();

            var ulElement = verifyACHButton.closest("ul")
            var dealId = ulElement.getAttribute("dealid")
            var stateAB = ulElement.getAttribute("stabr")
            var utilityid = ulElement.getAttribute("utilityid")
            var _sbs = ulElement.getAttribute("sbs")

            storage.rawSet("FarmStateAbbreviation", stateAB)

            var redirectUrl = "/ach-verification-page"

            var particularSectionName = false
            var particularSectionValue = false

            CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue, utilityid)
          }
        }
      }

      var failedPayments

      // Fetch NSE Services
      const fetchAssociatedNSEServices = async (subscriptionId) => {
__ea_trace("modules/self-serve/self-serve.ts","fetchAssociatedNSEServices",[subscriptionId],["subscriptionId"]);
        const postsubscriptionId = JSON.stringify({ id: subscriptionId })

        fetch('/_hcms/api/get-nse-services-based-on-nse-subscription', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: postsubscriptionId,
        })
          .then((response) => response.json())
          .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
            if (data.status !== "error") {
              const filteredData = data.filter(
                (item) =>
                  item.properties?.type === "Make a Payment" &&
                  item.properties?.hansen_sync_status !== "Error - Make a Payment",
              )
              failedPayments = data.filter(
                (item) =>
                  item.properties?.type === "Make a Payment" &&
                  item.properties?.hansen_sync_status === "Error - Make a Payment",
              )

              const sevenDaysAgo = new Date()
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

              const container = document.querySelector(".mp-amountDetailRows")
              const fpcontainer = document.querySelector(".mp-failedpayments .mp-amountDetailRows")
              if (!container) {
                console.warn("Target container .mp-amountDetailRows not found")
                return
              }

              container.innerHTML = ""
              fpcontainer.innerHTML = ""

              var isAnyPaymentIncomplete = false
              var _isAnyFailedPayment = false
              var totalAmount = 0

              filteredData.forEach((item, index) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[item,index],["item","index"]);
                const confirmationId = item.properties?.payment_confirmation || "N/A"
                const amount = parseFloat(item.properties?.payment_amount || 0)
                const paymentStatus = item.properties?.payment_status

                if (
                  !paymentStatus ||
                  paymentStatus.toLowerCase() === "staged" ||
                  paymentStatus.toLowerCase() === "processing"
                ) {
                  if (amount > 0) {
                    isAnyPaymentIncomplete = true
                    totalAmount += amount

                    var filterAmount = formatMoney(amount.toFixed(2))

                    const rowHTML = `
                          <div class="row">
                              <div class="titleCol">Pending Payment</div>
                              <div class="valueCol">${filterAmount}</div>
                              <div class="valueCol">${confirmationId}</div>
                          </div>`
                    container.insertAdjacentHTML("beforeend", rowHTML)
                  }
                }

                if (index === filteredData.length - 1) {
                  const detailContainer = document.querySelector(".mp-amountDetail")
                  if (isAnyPaymentIncomplete && detailContainer) {
                    detailContainer.style.display = "block"
                  } else if (detailContainer) {
                    detailContainer.style.display = "none"
                  }
                  var bal = document.querySelector(".subscriptionAmount span").textContent
                  bal = String(bal).replace(/\$/g, "")
                  totalAmount = String(totalAmount).replace(/\$/g, "")

                  const finalamount = Number(bal.replace(/,/g, "")) - Number(totalAmount.replace(/,/g, ""))
                  document.querySelector(".finalAmount").textContent = formatMoney(finalamount)
                }
              })

              failedPayments.forEach((item, _index) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[item,_index],["item","_index"]);
                const createDate = item.properties?.hs_createdate
                const amount = parseFloat(item.properties?.payment_amount || 0)
                const date = new Date(createDate)

                const formattedDateCT =
                  String(date.getMonth() + 1).padStart(2, "0") +
                  "-" +
                  String(date.getDate()).padStart(2, "0") +
                  "-" +
                  date.getFullYear()

                if (amount > 0) {
                  if (date >= sevenDaysAgo) {
                    _isAnyFailedPayment = true
                    totalAmount += amount

                    var filterAmount = formatMoney(amount.toFixed(2))

                    const rowHTML = `
                                  <div class="row">
                                      <div class="valueCol">${filterAmount}</div>
                                      <div class="valueCol">${formattedDateCT}</div>
                                      <div class="valueCol">Payment Method Invalid</div>
                                  </div>`
                    fpcontainer.insertAdjacentHTML("beforeend", rowHTML)
                  }
                }
              })
            }
          })
          .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
            mpAccountDetailNone = true
            document.querySelector(".mp-amountDetail").style.display = "none"
            console.error("Error fetching NSE Services:", error)
          })
      }
      // Fetch NSE Subscriptions
      const fetchNSESubscriptions = async () => {
__ea_trace("modules/self-serve/self-serve.ts","fetchNSESubscriptions",[],[]);
        fetch('/_hcms/api/get-nse-subscription', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: postcontactData,
        })
          .then((response) => response.json())
          .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
            responseFromAPI = JSON.stringify(data)
            subsciptionRecordLength = data.length
            window.nseSubscriptionVars = []

            const selectElements = document.querySelectorAll("#subSelect") // Get all select elements on the page
            if (!selectElements.length) {
              console.error("No select elements found")
              return
            }

            const itemDetailList = document.querySelector(".itemDetailList")
            if (!itemDetailList) {
              console.error("Item Detail List not found")
              return
            }

            let firstRun = true
            data.forEach((subscription) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[subscription],["subscription"]);
              const props = subscription.properties

              const subscriptionVars = {
                enrollmentNumber: props.enrollment_number,
                accountBalance: props.account_balance,
                billingType: props.billing_type,
                hsObjectId: props.hs_object_id,
                fname: window.contactData.firstname, // From global contact data
                lname: window.contactData.lastname, // From global contact data
                email: window.contactData.email,
                currentErStatus: props.current_er_status,
                serviceAddress1: props.service_address_1,
                serviceAddress2: props.service_address_2,
                serviceCity: props.service_city,
                serviceZip: props.service_zip,
                serviceState: props.service_state,
                combinedutilityAccountNum: props.utility_account_number,
                utilityDisplayName: props.utility_display_name,
                paymentMethod: props.payment_method,
                ccLast4: props.cc_last_4,
                ccExpireDate: props.cc_expire_date,
                utilityCode: props.utility_code,
                billingStatus: props.billing_status,
                billingStatusMP: props.billing_status_mp,
                stripePaymentId: props.stripe_payment_id,
                stripePaymentMethod: props.stripe_payment_method,
                stripePaymentMethodid: props.stripe_payment_method_id,
                stripeCustomerId: props.stripe_customer_id,
                stripeMicrodepositType: props.microdeposit_type,
                stripeMicrodepositTypeMP: props.microdeposit_type_mp,
              }
              window.nseSubscriptionVars.push(subscriptionVars)

              selectElements.forEach((select) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[select],["select"]);
                const option = document.createElement("option")
                option.value = subscriptionVars.hsObjectId // Use hsObjectId as the value
                option.setAttribute("enrollmentnumber", subscriptionVars.enrollmentNumber) // Use hsObjectId as the value
                option.setAttribute("utilityCode", subscriptionVars.utilityCode)
                option.setAttribute("billingStatus", subscriptionVars.billingStatus)
                option.setAttribute("billingStatusMP", subscriptionVars.billingStatusMP)
                option.setAttribute("paymentMethod", subscriptionVars.paymentMethod)
                option.setAttribute("stripePaymentId", subscriptionVars.stripePaymentId)
                option.setAttribute("stripePaymentMethod", subscriptionVars.stripePaymentMethod)
                option.setAttribute("stripePaymentMethodid", subscriptionVars.stripePaymentMethodid)
                option.setAttribute("stripeCustomerId", subscriptionVars.stripeCustomerId)
                option.setAttribute("serviceAddress1", subscriptionVars.serviceAddress1)
                option.setAttribute("serviceAddress2", subscriptionVars.serviceAddress2)
                option.setAttribute("stripeMicrodepositType", subscriptionVars.stripeMicrodepositType)
                option.setAttribute("stripeMicrodepositTypeMP", subscriptionVars.stripeMicrodepositTypeMP)
                option.setAttribute("combinedutilityAccountNum", subscriptionVars.combinedutilityAccountNum)

                const _name = [subscriptionVars.fname, subscriptionVars.lname].filter(Boolean).join(" ")
                var address = subscriptionVars.serviceAddress1
                if (
                  typeof subscriptionVars.serviceAddress2 === "string" &&
                  subscriptionVars.serviceAddress2.trim() !== ""
                ) {
                  address += `, ${subscriptionVars.serviceAddress2.trim()}`
                }
                var cerst = ""
                if (subscriptionVars.currentErStatus != null && subscriptionVars.currentErStatus !== "") {
                  if (subscriptionVars.currentErStatus === "CUST") {
                    cerst = "Active"
                  } else if (subscriptionVars.currentErStatus === "TBR") {
                    cerst = "Processing"
                  } else if (
                    subscriptionVars.currentErStatus === "CANC" ||
                    subscriptionVars.currentErStatus === "PFNL" ||
                    subscriptionVars.currentErStatus === "FNLD" ||
                    subscriptionVars.currentErStatus === "FAIL"
                  ) {
                    cerst = "Cancelled"
                  } else {
                    cerst = "TBD"
                  }
                } else {
                  cerst = "TBD"
                }
                // Conditionally include only non-null values
                const details = [address, subscriptionVars.combinedutilityAccountNum, cerst].filter(Boolean).join(" - ") // Removes null, undefined, or empty strings

                option.textContent = details
                select.appendChild(option)
              })
              if (firstRun) {
                firstRun = false
                storage.rawSet("billingType", subscriptionVars.billingType)
                storage.rawSet("currentErStatus", subscriptionVars.currentErStatus)
                storage.rawSet("StripeCustomerId", subscriptionVars.stripeCustomerId)
                storage.rawSet("stripeMicrodepositType", subscriptionVars.stripeMicrodepositType)
                storage.rawSet("stripeMicrodepositTypeMP", subscriptionVars.stripeMicrodepositTypeMP)
                microdepostiType = subscriptionVars.stripeMicrodepositType
                _microdepostiTypeMp = subscriptionVars.stripeMicrodepositTypeMP
                if (subscriptionVars.stripeMicrodepositType === "amounts") {
                  document.querySelector("#achVerificationMainUp #andtext").style.display = "none"
                  document.querySelector("#descriptorCodeLabel").style.display = "none"
                  document.querySelector("#descriptorCode").style.display = "none"
                  document.querySelector("#ACHDepDesTitle").style.display = "block"
                  document.querySelector("#ACHDepositAmount1Up").style.display = "block"
                  document.querySelector("#ACHDepositAmount2Up").style.display = "block"
                } else if (subscriptionVars.stripeMicrodepositType === "descriptor_code") {
                  document.querySelector("#achVerificationMainUp #andtext").style.display = "none"
                  document.querySelector("#ACHDepositAmount1Up").style.display = "none"
                  document.querySelector("#ACHDepositAmount2Up").style.display = "none"
                  document.querySelector("#ACHDepDesTitle").style.display = "block"
                  document.querySelector("#descriptorCodeLabel").style.display = "block"
                  document.querySelector("#descriptorCode").style.display = "block"
                } else {
                  document.querySelector("#achVerificationMainUp #andtext").style.display = "none"
                  document.querySelector("#descriptorCodeLabel").style.display = "none"
                  document.querySelector("#descriptorCode").style.display = "none"
                  document.querySelector("#ACHDepDesTitle").style.display = "block"
                  document.querySelector("#ACHDepositAmount1Up").style.display = "block"
                  document.querySelector("#ACHDepositAmount2Up").style.display = "block"
                }

                if (subscriptionVars.stripeMicrodepositTypeMP === "amounts") {
                  document.querySelector("#achVerificationMain #andtextMp").style.display = "none"
                  document.querySelector("#descriptorCodeLabelMp").style.display = "none"
                  document.querySelector("#descriptorCodeMp").style.display = "none"
                  document.querySelector("#ACHDepDesTitleMp").style.display = "block"
                  document.querySelector("#ACHDepositAmount1").style.display = "block"
                  document.querySelector("#ACHDepositAmount2").style.display = "block"
                } else if (subscriptionVars.stripeMicrodepositTypeMP === "descriptor_code") {
                  document.querySelector("#achVerificationMain #andtextMp").style.display = "none"
                  document.querySelector("#ACHDepositAmount1").style.display = "none"
                  document.querySelector("#ACHDepositAmount2").style.display = "none"
                  document.querySelector("#ACHDepDesTitleMp").style.display = "block"
                  document.querySelector("#descriptorCodeLabelMp").style.display = "block"
                  document.querySelector("#descriptorCodeMp").style.display = "block"
                } else {
                  document.querySelector("#achVerificationMain #andtextMp").style.display = "none"
                  document.querySelector("#descriptorCodeLabelMp").style.display = "none"
                  document.querySelector("#descriptorCodeMp").style.display = "none"
                  document.querySelector("#ACHDepDesTitleMp").style.display = "block"
                  document.querySelector("#ACHDepositAmount1").style.display = "block"
                  document.querySelector("#ACHDepositAmount2").style.display = "block"
                }
              }
            })

            // Function to update details when selection changes
            const updateSubscriptionDetails = (selectedHsObjectId, selectedEnrollmentNumber, selectedpaymentMethod) => {
__ea_trace("modules/self-serve/self-serve.ts","updateSubscriptionDetails",[selectedHsObjectId,selectedEnrollmentNumber,selectedpaymentMethod],["selectedHsObjectId","selectedEnrollmentNumber","selectedpaymentMethod"]);
              const selectedSubscription = window.nseSubscriptionVars.find(
                (sub) => sub.hsObjectId === selectedHsObjectId,
              )

              if (selectedSubscription) {
                // Update all account balance display elements
                const accountBalanceElement = document.querySelector(".accountBalance .amount p span")
                if (
                  selectedSubscription.accountBalance == null ||
                  selectedSubscription.accountBalance === "null" ||
                  selectedSubscription.accountBalance === "" ||
                  selectedSubscription.accountBalance === undefined ||
                  selectedSubscription.accountBalance === 0 ||
                  selectedSubscription.accountBalance === "0"
                ) {
                  accountBalanceElement.textContent = "$0.00"
                  document.querySelector(".mp-amountDetail .subscriptionAmount").innerHTML = "$<span>0.00</span>"
                  document.querySelector(".accountBalanceCol2 .makePayment").style.display = "none"
                } else {
                  accountBalanceElement.textContent = formatMoney(selectedSubscription.accountBalance)
                  document.querySelector(".mp-amountDetail .subscriptionAmount").innerHTML =
                    `<span>${formatMoney(selectedSubscription.accountBalance)}</span>`
                  document.querySelector(".accountBalanceCol2 .makePayment").style.display = "block"
                }
                if (
                  selectedSubscription.combinedutilityAccountNum != null &&
                  selectedSubscription.combinedutilityAccountNum !== ""
                ) {
                  document.querySelector(".headerSection .yourSubs .desc .ucn").textContent =
                    `${selectedSubscription.combinedutilityAccountNum},`
                }
                if (selectedSubscription.utilityDisplayName != null && selectedSubscription.utilityDisplayName !== "") {
                  document.querySelector(".headerSection .yourSubs .desc .udn").textContent =
                    `${selectedSubscription.utilityDisplayName},`
                }
                if (selectedSubscription.currentErStatus != null && selectedSubscription.currentErStatus !== "") {
                  if (selectedSubscription.currentErStatus === "CUST") {
                    document.querySelector(".headerSection .yourSubs .desc .erStatus").textContent = "Active"
                  } else if (selectedSubscription.currentErStatus === "TBR") {
                    document.querySelector(".headerSection .yourSubs .desc .erStatus").textContent = "Processing"
                  } else if (
                    selectedSubscription.currentErStatus === "CANC" ||
                    selectedSubscription.currentErStatus === "PFNL" ||
                    selectedSubscription.currentErStatus === "FNLD" ||
                    selectedSubscription.currentErStatus === "FAIL"
                  ) {
                    document.querySelector(".headerSection .yourSubs .desc .erStatus").textContent = "Cancelled"
                  } else {
                    document.querySelector(".headerSection .yourSubs .desc .erStatus").textContent = "TBD"
                  }
                } else {
                  document.querySelector(".headerSection .yourSubs .desc .erStatus").textContent = "TBD"
                }
                const container = document.querySelector(".allreadySubmitDetail .itemDetailList")
                const mpcontainer = document.querySelector(".mp-allreadySubmitDetail .itemDetailList")

                // Clear previous rows
                container.innerHTML = ""
                mpcontainer.innerHTML = ""

                // Utility function to create a row
                function createRow(title, value) {
__ea_trace("modules/self-serve/self-serve.ts","createRow",[title,value],["title","value"]);
                  const row = document.createElement("div")
                  row.className = "row"
                  row.innerHTML = `<div class="titleCol">${title}</div><div class="valueCol">${value}</div>`
                  return row
                }

                // Append rows if data exists
                if (selectedSubscription.paymentMethod) {
                  document
                    .querySelectorAll(".allreadySubmitDetail .itemDetailList, .mp-allreadySubmitDetail .itemDetailList")
                    .forEach((el) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[el],["el"]);
                      el.style.setProperty("border", "1px solid var(--border, #e2e8f0)", "important")
                    })
                  container.appendChild(createRow("Payment Method Type", selectedSubscription.paymentMethod))
                  mpcontainer.appendChild(createRow("Payment Method Type", selectedSubscription.paymentMethod))
                }

                if (selectedSubscription.ccLast4) {
                  document
                    .querySelectorAll(".allreadySubmitDetail .itemDetailList, .mp-allreadySubmitDetail .itemDetailList")
                    .forEach((el) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[el],["el"]);
                      el.style.setProperty("border", "1px solid var(--border, #e2e8f0)", "important")
                    })
                  container.appendChild(createRow("Account Last 4 Digits", selectedSubscription.ccLast4))
                  mpcontainer.appendChild(createRow("Account Last 4 Digits", selectedSubscription.ccLast4))
                }

                if (selectedSubscription.ccExpireDate) {
                  document
                    .querySelectorAll(".allreadySubmitDetail .itemDetailList, .mp-allreadySubmitDetail .itemDetailList")
                    .forEach((el) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[el],["el"]);
                      el.style.setProperty("border", "1px solid var(--border, #e2e8f0)", "important")
                    })
                  container.appendChild(
                    createRow("Expiration Date (only credit cards)", selectedSubscription.ccExpireDate),
                  )
                  mpcontainer.appendChild(
                    createRow("Expiration Date (only credit cards)", selectedSubscription.ccExpireDate),
                  )
                }

                if (
                  !selectedSubscription.paymentMethod &&
                  !selectedSubscription.ccLast4 &&
                  !selectedSubscription.ccExpireDate
                ) {
                  document
                    .querySelectorAll(".allreadySubmitDetail .itemDetailList, .mp-allreadySubmitDetail .itemDetailList")
                    .forEach((el) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[el],["el"]);
                      el.style.setProperty("border", "none", "important")
                    })
                }

                const rowData = [
                  { title: "Enrollment Number", value: selectedSubscription.enrollmentNumber },
                  { title: "Service Street", value: selectedSubscription.serviceAddress1 },
                  { title: "Apt/Suite", value: selectedSubscription.serviceAddress2 },
                  { title: "Service City", value: selectedSubscription.serviceCity },
                  { title: "Service Zip", value: selectedSubscription.serviceZip },
                  { title: "Service State", value: selectedSubscription.serviceState },
                ]
                storage.rawSet("billingType", selectedSubscription.billingType)
                storage.rawSet("currentErStatus", selectedSubscription.currentErStatus)
                storage.rawSet("selectedSubscriptionId", selectedSubscription.hsObjectId)
                storage.rawSet("StripeCustomerId", selectedSubscription.stripeCustomerId)

                if (
                  selectedpaymentMethod === "ACH" ||
                  selectedpaymentMethod === "Credit Card" ||
                  selectedpaymentMethod === "Other"
                ) {
                } else {
                  document.querySelector(".checkAmountSectionWrapper").style.display = "none"
                  document.querySelector(".checkAmountBelowtext").style.display = "none"
                  document.querySelector("#fwtoMain").style.display = "none"
                  document
                    .querySelector(".make_a_payment .tabinInfo")
                    .insertAdjacentHTML(
                      "beforeend",
                      '<p id="goToPaymentDetail">You currently have no active payment methods. <a href="javascript:;" style="color:red;"  onclick="redirectToUpdatePaymentTab()">Go to Payment Details</a></p>',
                    )
                }

                getDataFromSSPTable("changeEvent")
                getBills(selectedEnrollmentNumber)
                paymentHistory(selectedEnrollmentNumber)
                getContracts(selectedEnrollmentNumber)
                fetchAssociatedNSEServices(selectedSubscription.hsObjectId)

                itemDetailList.innerHTML = "" // Clear previous details
                rowData.forEach((item) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[item],["item"]);
                  const row = document.createElement("div")
                  row.classList.add("row")

                  const titleCol = document.createElement("div")
                  titleCol.classList.add("titleCol")
                  titleCol.textContent = item.title

                  const valueCol = document.createElement("div")
                  valueCol.classList.add("valueCol")
                  valueCol.textContent = item.value

                  row.appendChild(titleCol)
                  row.appendChild(valueCol)

                  itemDetailList.appendChild(row)
                })
              }
            }

            // Add event listener to all select elements to sync their value
            selectElements.forEach((select) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[select],["select"]);
              select.addEventListener("change", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
                openProgressBar()

                const selectedOption = select.options[select.selectedIndex] // Get selected <option>
                const selectedHsObjectId = selectedOption.value
                const selectedEnrollmentNumber = selectedOption.getAttribute("enrollmentnumber")
                const selectedUtilityCode = selectedOption.getAttribute("utilityCode")
                const selectedBillingStatus = selectedOption.getAttribute("billingStatus")
                const selectedBillingStatusMP = selectedOption.getAttribute("billingStatusMP")
                const selectedpaymentMethod = selectedOption.getAttribute("paymentMethod")
                const selectedStripePaymentId = selectedOption.getAttribute("stripePaymentId")
                const selectedStripePaymentMethod = selectedOption.getAttribute("stripePaymentMethod")
                const selectedStripePaymentMethodid = selectedOption.getAttribute("stripePaymentMethodid")
                const selectedstripeMicrodepositType = selectedOption.getAttribute("stripeMicrodepositType")
                const selectedstripeMicrodepositTypeMP = selectedOption.getAttribute("stripeMicrodepositTypeMP")
                storage.rawSet("stripeMicrodepositType", selectedOption.selectedstripeMicrodepositType)
                storage.rawSet("stripeMicrodepositTypeMP", selectedOption.selectedstripeMicrodepositTypeMP)
                microdepostiType = selectedstripeMicrodepositType
                _microdepostiTypeMp = selectedstripeMicrodepositTypeMP
                if (selectedstripeMicrodepositType === "amounts") {
                  document.querySelector("#achVerificationMainUp #andtext").style.display = "none"
                  document.querySelector("#descriptorCodeLabel").style.display = "none"
                  document.querySelector("#descriptorCode").style.display = "none"
                  document.querySelector("#ACHDepDesTitle").style.display = "block"
                  document.querySelector("#ACHDepositAmount1Up").style.display = "block"
                  document.querySelector("#ACHDepositAmount2Up").style.display = "block"
                } else if (selectedstripeMicrodepositType === "descriptor_code") {
                  document.querySelector("#achVerificationMainUp #andtext").style.display = "none"
                  document.querySelector("#ACHDepositAmount1Up").style.display = "none"
                  document.querySelector("#ACHDepositAmount2Up").style.display = "none"
                  document.querySelector("#ACHDepDesTitle").style.display = "block"
                  document.querySelector("#descriptorCodeLabel").style.display = "block"
                  document.querySelector("#descriptorCode").style.display = "block"
                } else {
                  document.querySelector("#achVerificationMainUp #andtext").style.display = "none"
                  document.querySelector("#descriptorCodeLabel").style.display = "none"
                  document.querySelector("#descriptorCode").style.display = "none"
                  document.querySelector("#ACHDepDesTitle").style.display = "block"
                  document.querySelector("#ACHDepositAmount1Up").style.display = "block"
                  document.querySelector("#ACHDepositAmount2Up").style.display = "block"
                }

                if (selectedstripeMicrodepositTypeMP === "amounts") {
                  document.querySelector("#achVerificationMain #andtextMp").style.display = "none"
                  document.querySelector("#descriptorCodeLabelMp").style.display = "none"
                  document.querySelector("#descriptorCodeMp").style.display = "none"
                  document.querySelector("#ACHDepDesTitleMp").style.display = "block"
                  document.querySelector("#ACHDepositAmount1").style.display = "block"
                  document.querySelector("#ACHDepositAmount2").style.display = "block"
                } else if (selectedstripeMicrodepositTypeMP === "descriptor_code") {
                  document.querySelector("#achVerificationMain #andtextMp").style.display = "none"
                  document.querySelector("#ACHDepositAmount1").style.display = "none"
                  document.querySelector("#ACHDepositAmount2").style.display = "none"
                  document.querySelector("#ACHDepDesTitleMp").style.display = "block"
                  document.querySelector("#descriptorCodeLabelMp").style.display = "block"
                  document.querySelector("#descriptorCodeMp").style.display = "block"
                } else {
                  document.querySelector("#achVerificationMain #andtextMp").style.display = "none"
                  document.querySelector("#descriptorCodeLabelMp").style.display = "none"
                  document.querySelector("#descriptorCodeMp").style.display = "none"
                  document.querySelector("#ACHDepDesTitleMp").style.display = "block"
                  document.querySelector("#ACHDepositAmount1").style.display = "block"
                  document.querySelector("#ACHDepositAmount2").style.display = "block"
                }

                selectElements.forEach((otherSelect) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[otherSelect],["otherSelect"]);
                  otherSelect.value = selectedHsObjectId
                })
                checkUtilityIdInFarmTable(
                  selectedUtilityCode,
                  selectedBillingStatus,
                  selectedStripePaymentMethodid,
                  selectedStripePaymentMethod,
                  selectedStripePaymentId,
                  selectedBillingStatusMP,
                  selectedpaymentMethod,
                )
                updateSubscriptionDetails(selectedHsObjectId, selectedEnrollmentNumber, selectedpaymentMethod)
                var idsToHide = ["jnpiays-bank", "jnpiays-credit", "jnpiays-update"]
                idsToHide.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                  const el = document.getElementById(id)
                  if (el) {
                    el.style.display = "none"
                  }
                })

                document.querySelector(".jnpiays-changeDefMetUpdate").style.display = "block"
              })
            })

            // Trigger the change event to show details for the first subscription
            selectElements.forEach((select) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[select],["select"]);
              select.selectedIndex = 1
            })

            const changeEvent = new Event("change")
            selectElements[0].dispatchEvent(changeEvent)

            getDataFromSSPTable()

            ICCiframe()
            IBNiframe()
            MPICCiframe()
            MPIBNiframe()
            findAssociatedDeals(contactId)
            setTimeout(() => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
              closeProgressBar()
            }, 40000)
            setTimeout(() => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
              BayouGetCustomers()
            }, 3000)

            setTimeout(() => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
              const validOptionsCount = Array.from(selectBox.options).filter((option) => !option.disabled).length

              if (validOptionsCount >= 10) {
                searchWrapper.style.display = "block"
              } else {
                searchWrapper.style.display = "none"
              }
            }, 3000)
          })
          .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
            mpAccountDetailNone = true
            document.querySelector(".mp-amountDetail").style.display = "none"
            findAssociatedDeals(contactId, "no")
            console.error("Error fetching NSE subscriptions:", error)
          })
      }
      const _fetchNSEService = async (serviceActionID) => {
__ea_trace("modules/self-serve/self-serve.ts","_fetchNSEService",[serviceActionID],["serviceActionID"]);
        const postserviceId = JSON.stringify({ id: serviceActionID })
        fetch('/_hcms/api/get-nse-service', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: postserviceId,
        })
          .then((response) => response.json())
          .then((data) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[data],["data"]);
            responseFromAPI = JSON.stringify(data)

            const props = data.properties
            if (props.confirmation_id_number == null || props.confirmation_id_number === "null") {
              var buttonParent = document.querySelector(".mp-jnpiays-update")
              if (buttonParent?.querySelector(".mp-update-card-info")) {
                var textElement = document.createElement("p")
                textElement.classList.add("success-message")
                textElement.textContent =
                  "Your payment is currently being processed. Please check back later for an updated status."
                buttonParent.after(textElement)

                // Remove the message after 4 seconds
                setTimeout(() => textElement.remove(), 10000)
                closeProgressBar()
              }
            } else {
              var buttonParent = document.querySelector(".mp-jnpiays-update")
              if (buttonParent?.querySelector(".mp-update-card-info")) {
                var textElement = document.createElement("p")
                textElement.classList.add("success-message")
                textElement.textContent = `Your payment is currently being processed. Please check back later for an updated status. Your Confirmation ID is: ${props.confirmation_id_number}.`
                buttonParent.after(textElement)

                // Remove the message after 4 seconds
                setTimeout(() => textElement.remove(), 10000)
                closeProgressBar()
              }
            }
            closeProgressBar()
          })
          .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
            console.error("Error fetching NSE subscriptions:", error)
          })
      }

      // Update Contact Property

      var st = storage.rawGet("supportType")
      if (st !== "agent") {
        document.querySelector("#closeAblePopupClose")?.addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
          const closepopup = document.querySelector(".closeAblePopup")
          document.querySelector("#closeAblePopupOverlay").style.display = "none"
          closepopup.style.display = "none"
          document.querySelector("#amountField").value = 0
          document.getElementById("fwtoMain").style.display = "none"
          document.querySelector(".checkAmountSectionWrapper").style.display = "block"
        })
        document.querySelector("#up-closeAblePopupClose")?.addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
          const upclosepopup = document.querySelector(".up-closeAblePopup")
          document.querySelector("#up-closeAblePopupOverlay").style.display = "none"
          upclosepopup.style.display = "none"
        })

        document.querySelector(".save_btn a").addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          checkbox = document.getElementById("current_accountupdate_email")

          document.querySelectorAll(".error-message").forEach((el) => el.remove())

          const phoneInput = document.getElementById("new_phone")
          const cellInput = document.getElementById("new_cellphone")

          const fieldss = [
            document.querySelector("input[name='new_email']"),
            phoneInput,
            cellInput,
            document.querySelector("input[name='new_mailtostreet']"),
            document.querySelector("input[name='new_mailetosuite']"),
            document.querySelector("input[name='new_mailtocity']"),
            document.querySelector("input[name='new_mailtostate']"),
            document.querySelector("input[name='new_mailtozip']"),
          ]

          const atLeastOneFieldHasValue = fieldss.some((input) => input.value.trim() !== "")

          const phoneValue = phoneInput.value.replace(/\D/g, "")
          const cellValue = cellInput.value.replace(/\D/g, "")

          const checkboxChanged = checkbox.checked !== initialCheckboxValue

          // 🚨 Check if nothing changed
          if (!atLeastOneFieldHasValue && !checkboxChanged) {
            showGeneralError("Please update at least one field.")
            e.preventDefault()
            return
          }

          // ✅ Validate phone number
          if (phoneValue && phoneValue.length !== 10) {
            showFieldError(phoneInput, "Phone number must be exactly 10 digits.")
            e.preventDefault()
            return
          }

          if (cellValue && cellValue.length !== 10) {
            showFieldError(cellInput, "Cell phone number must be exactly 10 digits.")
            e.preventDefault()
            return
          }

          function showGeneralError(message) {
__ea_trace("modules/self-serve/self-serve.ts","showGeneralError",[message],["message"]);
            const buttonParent = document.querySelector(".button_parent")
            if (buttonParent?.querySelector(".save_btn")) {
              const errorText = document.createElement("p")
              errorText.classList.add("error-message", "general-error")
              errorText.textContent = message
              buttonParent.after(errorText)
              setTimeout(() => errorText.remove(), 3000)
            }
          }

          // ✅ Show inline error beside input
          function showFieldError(inputElement, message) {
__ea_trace("modules/self-serve/self-serve.ts","showFieldError",[inputElement,message],["inputElement","message"]);
            const existingError = inputElement.nextElementSibling
            if (!existingError?.classList.contains("error-message")) {
              const errorText = document.createElement("span")
              errorText.classList.add("error-message")
              errorText.style.color = "red"
              errorText.style.fontSize = "14px"
              errorText.style.display = "block"
              errorText.style.marginTop = "4px"
              errorText.textContent = message
              inputElement.after(errorText)
            }
          }
          // ✅ Remove phone/cell error on input change
          ;["new_phone", "new_cellphone"].forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
            const input = document.getElementById(id)
            const maxLength = 10
            input.addEventListener("input", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
              let value = this.value.replace(/\D/g, "") // Only digits
              if (value.length > maxLength) value = value.slice(0, maxLength)
              this.value = value

              const nextEl = this.nextElementSibling
              if (nextEl?.classList.contains("error-message")) {
                nextEl.remove()
              }
            })
          })

          openProgressBar("We are updating your contact preferences")
          e.preventDefault()

          const updatedProperties = {}

          const fields = [
            { name: "new_firstname", key: "firstname" },
            { name: "new_lastname", key: "lastname" },
            { name: "new_email", key: "email" },
            { name: "new_phone", key: "phone" },
            { name: "new_cellphone", key: "mobilephone" },
            { name: "new_mailtostreet", key: "address" },
            { name: "new_mailetosuite", key: "street_address_2" },
            { name: "new_mailtocity", key: "city" },
            { name: "new_mailtostate", key: "state" },
            { name: "new_mailtozip", key: "zip" },
            {
              name: "current_accountupdate_email",
              key: "account_updates_news__and_surveys_via_email",
              type: "checkbox",
            },
          ]

          var phoneExtension = ""
          fields.forEach((field) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[field],["field"]);
            const inputElement = document.querySelector(`input[name="${field.name}"]`)
            if (field.type === "checkbox") {
              if (inputElement.checked) {
                updatedProperties[field.key] = true
              } else {
                updatedProperties[field.key] = false
              }
            } else if (field.key === "phone") {
              if (inputElement && inputElement.value.trim() !== "") {
                const phoneValue = inputElement.value.trim()
                updatedProperties[field.key] = phoneValue

                phoneExtension = phoneValue.substring(0, 3)
              }
            } else {
              if (inputElement && inputElement.value.trim() !== "") {
                updatedProperties[field.key] = inputElement.value.trim()
              }
            }
          })

          if (Object.keys(updatedProperties).length === 0) {
            //                     alert("No new information entered to update.");
            return
          }

          const updatedData = {
            id: contactId,
            properties: updatedProperties,
          }

          try {
            const contactUpdateResponse = await fetch('/_hcms/api/upload-contact-record', {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(updatedData),
            })

            const contactUpdateResult = await contactUpdateResponse.json()
            responseFromAPI = JSON.stringify(contactUpdateResult)
            if (contactUpdateResult.status === "error") {
              closeProgressBar()
              console.error("❌ Contact Update Error:", contactUpdateResult.message)
              return
            }

            fetchContactData()

            fields.forEach((field) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[field],["field"]);
              const inputElement = document.querySelector(`input[name="${field.name}"]`)
              if (inputElement) inputElement.value = ""
            })

            const selectElement = document.querySelector("#subSelect")
            if (!selectElement) return

            const selectedSubscriptionId = selectElement.value
            const selectedSubscription = window.nseSubscriptionVars.find(
              (sub) => sub.hsObjectId === selectedSubscriptionId,
            )

            if (!selectedSubscription) return

            const enrollmentNumber = selectedSubscription.enrollmentNumber
            const contactId = storage.rawGet("RecordId") || (window.contactData ? window.contactData.id : null)
            const email = window.contactData ? window.contactData.email : null

            const _lastSavedSubscriptionId = storage.rawGet("last_nse_subscription")
            const _lastSavedEnrollmentNumber = storage.rawGet("last_enrollment_number")

            var fName = ""
            var lName = ""
            fName = storage.rawGet("FirstName")
            lName = storage.rawGet("LastName")
            if (st === "admin") {
              var admnEmail = storage.rawGet("adminEmail")
              var _serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  updatedBy: "Admin",
                  adminEmail: admnEmail,
                  type: "Updated Contact Preferences",
                  phoneExtension: phoneExtension,
                  contactId: contactId,
                  email: email,
                  fName: fName,
                  lName: lName,
                }),
              })
            } else {
              var serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  contactId: contactId,
                  email: email,
                  updatedBy: "Customer",
                  adminEmail: "",
                  phoneExtension: phoneExtension,
                  type: "Updated Contact Preferences",
                  fName: fName,
                  lName: lName,
                }),
              })
            }

            const serviceActionData = await serviceActionResponse.json()
            responseFromAPI = JSON.stringify(serviceActionData)

            if (serviceActionData.serviceActionId) {
              storage.rawSet("last_nse_subscription", selectedSubscriptionId)
              storage.rawSet("last_enrollment_number", enrollmentNumber)
              storage.rawSet("nse_service_action", serviceActionData.serviceActionId)

              var serviceActionID = serviceActionData.serviceActionId

              const associateResponse = await fetch('/_hcms/api/associate-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  serviceActionId: serviceActionID,
                  nseSubscriptionId: selectedSubscriptionId,
                  contactId: contactId,
                }),
              })

              const associateData = await associateResponse.json()

              if (associateData.status === "success") {
                //                             alert('🎉 Service action created and associated successfully!');
              } else {
                closeProgressBar()
                console.error("❌ Association Error:", associateData)
                throw new Error("Failed to associate service action.")
              }

              const updatenseserviceResponse = await fetch(
                '/_hcms/api/update-contact-data-in-service-action',
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    serviceActionId: serviceActionID,
                    properties: updatedData.properties, // Ensure it’s wrapped correctly
                  }),
                },
              )

              const _updatenseserviceData = await updatenseserviceResponse.json()

              const buttonParent = document.querySelector(".button_parent")
              if (buttonParent?.querySelector(".save_btn")) {
                const textElement = document.createElement("p")
                textElement.classList.add("success-message")
                textElement.textContent = "We have updated your enrollment. Thank you"
                buttonParent.after(textElement)

                // Remove the message after 4 seconds
                setTimeout(() => textElement.remove(), 10000)
              }
            } else {
              closeProgressBar()
              console.error("❌ Service Action Creation Failed:", serviceActionData)
              throw new Error("Failed to create service action.")
            }
          } catch (error) {
            closeProgressBar()
            console.error("❌ Error:", error)
          }
          closeProgressBar()
        })

        // ----------  Update Payment info Details
        document.querySelector(".update-card-info").addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          e.preventDefault()
          if (!document.querySelector(".update-card-info")?.classList.contains("disabled")) {
            // Check if a payment type is selected
            const selectedPaymentType = document.querySelector('input[name="paymentType"]:checked')

            if (!selectedPaymentType) {
              var errorMessage = document.getElementById("payment-error-message")
              errorMessage.textContent = "Please select a payment method before proceeding."
              errorMessage.style.display = "block"
              return
            } else {
              document.querySelector(".update-card-info").classList.add("disabled")
              document.querySelector(".update-card-info").disabled = true
              var idsToHide = ["jnpiays-bank", "jnpiays-credit", "jnpiays-update"]
              idsToHide.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                const el = document.getElementById(id)
                if (el) {
                  el.style.display = "none"
                }
              })

              var selectedPaymentVal = document.querySelector('input[name="paymentType"]:checked').value
              if (selectedPaymentVal === "ACH") {
                var iccmsgElement = document.querySelector(".jnpiays-bank-details #iBNMSG")
                var iccmsgText = iccmsgElement ? iccmsgElement.textContent.trim() : ""
                if (iccmsgText) {
                  var errorMessage = document.getElementById("payment-error-message")
                  errorMessage.textContent = ""
                  errorMessage.style.display = "none"
                } else {
                  document.querySelector(".update-card-info").classList.remove("disabled")
                  document.querySelector(".update-card-info").disabled = false
                  var idsToShow = ["jnpiays-bank", "jnpiays-credit", "jnpiays-update"]
                  idsToShow.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                    const el = document.getElementById(id)
                    if (el) {
                      el.style.display = "block" // or 'flex' if needed
                      el.classList.remove("hidden")
                    }
                  })

                  var errorMessage = document.getElementById("payment-error-message")
                  errorMessage.textContent = "Please add Bank details before proceeding."
                  errorMessage.style.display = "block"
                  return
                }
              } else if (selectedPaymentVal === "Credit Card") {
                var iccmsgElement = document.querySelector(".jnpiays-credit-details #ICCMSG")
                var iccmsgText = iccmsgElement ? iccmsgElement.textContent.trim() : ""
                if (iccmsgText) {
                  var errorMessage = document.getElementById("payment-error-message")
                  errorMessage.textContent = ""
                  errorMessage.style.display = "none"
                } else {
                  document.querySelector(".update-card-info").classList.remove("disabled")
                  document.querySelector(".update-card-info").disabled = false
                  var idsToShow = ["jnpiays-bank", "jnpiays-credit", "jnpiays-update"]
                  idsToShow.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                    const el = document.getElementById(id)
                    if (el) {
                      el.style.display = "block" // or 'flex' if needed
                      el.classList.remove("hidden")
                    }
                  })

                  var errorMessage = document.getElementById("payment-error-message")
                  errorMessage.textContent = "Please add Credit card details before proceeding."
                  errorMessage.style.display = "block"
                  return
                }
              }
            }
            openProgressBar("We are updating your payment information")
            // Hide error message if a selection is made
            document.getElementById("payment-error-message").style.display = "none"

            const selectElement = document.querySelector("#subSelect")
            if (!selectElement) return

            const selectedSubscriptionId = selectElement.value
            const selectedSubscription = window.nseSubscriptionVars.find(
              (sub) => sub.hsObjectId === selectedSubscriptionId,
            )

            if (!selectedSubscription) return

            const enrollmentNumber = selectedSubscription.enrollmentNumber
            const contactId = storage.rawGet("RecordId") || (window.contactData ? window.contactData.id : null)
            const email = window.contactData ? window.contactData.email : null

            let serviceActionID = storage.rawGet("nse_service_action") // Check if service action already exists

            try {
              var fName = ""
              var lName = ""
              fName = storage.rawGet("FirstName")
              lName = storage.rawGet("LastName")
              if (st === "admin") {
                var admnEmail = storage.rawGet("adminEmail")
                var _serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    enrollmentNumber: enrollmentNumber,
                    contactId: contactId,
                    email: email,
                    paymentType: selectedPaymentType.value,
                    updatedBy: "Admin",
                    adminEmail: admnEmail,
                    type: "Updated Payment Info",
                    fName: fName,
                    lName: lName,
                  }),
                })
              } else {
                var serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    enrollmentNumber: enrollmentNumber,
                    contactId: contactId,
                    email: email,
                    paymentType: selectedPaymentType.value,
                    updatedBy: "Customer",
                    adminEmail: "",
                    type: "Updated Payment Info",
                    fName: fName,
                    lName: lName,
                  }),
                })
              }

              const serviceActionData = await serviceActionResponse.json()
              responseFromAPI = JSON.stringify(serviceActionData)

              if (serviceActionData.serviceActionId) {
                storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
                serviceActionID = serviceActionData.serviceActionId

                // Associate service action with NSE subscription
                const associateResponse = await fetch('/_hcms/api/associate-service-action', {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    serviceActionId: serviceActionID,
                    nseSubscriptionId: selectedSubscriptionId,
                    contactId: contactId,
                  }),
                })

                const associateData = await associateResponse.json()

                if (associateData.status === "success") {
                  await updateServiceActionWithPaymentDetails(serviceActionID, selectedPaymentType.value, "Option 2")
                  var buttonParent = document.querySelector(".jnpiays-update")
                  if (buttonParent?.querySelector(".update-card-info")) {
                    var textElement = document.createElement("p")
                    textElement.classList.add("success-message")
                    textElement.textContent =
                      "Your new payment method has been submitted. It may take up to 24 hours to reflect on this page."
                    buttonParent.after(textElement)
                    document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                      "Your new payment method has been submitted. It may take up to 24 hours to reflect on this page."
                    document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
                    document.querySelector(".up-closeAblePopup").style.display = "block"

                    // Remove the message after 4 seconds
                    setTimeout(() => textElement.remove(), 10000)
                  }
                } else {
                  document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                    "Our system did not capture your payment. Please wait a moment and try again."
                  document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
                  document.querySelector(".up-closeAblePopup").style.display = "block"
                  document.querySelector(".update-card-info").classList.remove("disabled")
                  document.querySelector(".update-card-info").disabled = false
                  var idsToShow = ["jnpiays-bank", "jnpiays-credit", "jnpiays-update"]
                  idsToShow.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                    const el = document.getElementById(id)
                    if (el) {
                      el.style.display = "block" // or 'flex' if needed
                      el.classList.remove("hidden")
                    }
                  })
                  closeProgressBar()
                  console.error("❌ Association Error:", associateData)
                  throw new Error("Failed to associate service action.")
                }
              } else {
                document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                  "Our system did not capture your payment. Please wait a moment and try again."
                document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
                document.querySelector(".up-closeAblePopup").style.display = "block"
                document.querySelector(".update-card-info").classList.remove("disabled")
                document.querySelector(".update-card-info").disabled = false
                var idsToShow = ["jnpiays-bank", "jnpiays-credit", "jnpiays-update"]
                idsToShow.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                  const el = document.getElementById(id)
                  if (el) {
                    el.style.display = "block" // or 'flex' if needed
                    el.classList.remove("hidden")
                  }
                })
                closeProgressBar()
                console.error("❌ Service Action Creation Failed:", serviceActionData)
                throw new Error("Failed to create service action.")
              }
            } catch (error) {
              document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                "Our system did not capture your payment. Please wait a moment and try again."
              document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
              document.querySelector(".up-closeAblePopup").style.display = "block"
              document.querySelector(".update-card-info").classList.remove("disabled")
              document.querySelector(".update-card-info").disabled = false
              var idsToShow = ["jnpiays-bank", "jnpiays-credit", "jnpiays-update"]
              idsToShow.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                const el = document.getElementById(id)
                if (el) {
                  el.style.display = "block" // or 'flex' if needed
                  el.classList.remove("hidden")
                }
              })
              closeProgressBar()
              console.error("❌ Error:", error)
              //                         alert("An error occurred while processing.");
            }
            closeProgressBar()
          }
        })
        var buttonChangeMethod = document.querySelector(".jnpiays-changeDefMetUpdate")
        buttonChangeMethod.addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
          // Hide the button
          buttonChangeMethod.style.display = "none"

          // Unhide three items (dummy IDs)
          const idsToShow = ["jnpiays-bank", "jnpiays-credit", "jnpiays-update"]

          idsToShow.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
            const el = document.getElementById(id)
            if (el) {
              el.style.display = "block" // or 'flex' if needed
              el.classList.remove("hidden")
            }
          })
        })
        var stipebuttonChangeMethod = document.querySelector(".up-strp-jnpiays-update-changeDefMetUpdate")
        stipebuttonChangeMethod.addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
          stipebuttonChangeMethod.style.display = "none"
          const idsToShow = ["stripe-container", "up-strp-jnpiays-update"]
          idsToShow.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
            const el = document.getElementById(id)
            if (el) {
              el.style.display = "block" // or 'flex' if needed
              el.classList.remove("hidden")
            }
          })
        })

        document.querySelector(".up-strp-update-card-info").addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          e.preventDefault()

          if (!document.querySelector(".up-strp-update-card-info")?.classList.contains("disabled")) {
            // Check if a payment type is selected
            openProgressBar("We are making your payment")

            if (IsStripeFormDoneUp === false) {
              const errorMessage = document.getElementById("up-strp-payment-error-message")
              errorMessage.textContent = "Please select a payment method before proceeding."
              errorMessage.style.display = "block"
              closeProgressBar()
              return
            }

            document.querySelector(".up-strp-update-card-info").classList.add("disabled")
            document.querySelector(".up-strp-update-card-info").disabled = true
            var _idsToHide = ["stripe-container", "up-strp-jnpiays-update"]
            idsToHide.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
              const el = document.getElementById(id)
              if (el) {
                el.style.display = "none"
              }
            })
            document.getElementById("up-strp-payment-error-message").style.display = "none"

            // Hide error message if a selection is made

            const selectElement = document.querySelector("#subSelect")
            if (!selectElement) return

            const selectedSubscriptionId = selectElement.value
            const selectedSubscription = window.nseSubscriptionVars.find(
              (sub) => sub.hsObjectId === selectedSubscriptionId,
            )

            if (!selectedSubscription) return

            const enrollmentNumber = selectedSubscription.enrollmentNumber
            const contactId = storage.rawGet("RecordId") || (window.contactData ? window.contactData.id : null)
            const email = window.contactData ? window.contactData.email : null

            let serviceActionID = storage.rawGet("nse_service_action") // Check if service action already exists

            try {
              var fName = ""
              var lName = ""
              fName = storage.rawGet("FirstName")
              lName = storage.rawGet("LastName")
              if (st === "admin") {
                var admnEmail = storage.rawGet("adminEmail")
                var _serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    enrollmentNumber: enrollmentNumber,
                    contactId: contactId,
                    email: email,
                    // paymentType: selectedPaymentType.value,
                    updatedBy: "Admin",
                    adminEmail: admnEmail,
                    type: "Updated Payment Info",
                    fName: fName,
                    lName: lName,
                  }),
                })
              } else {
                var serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    enrollmentNumber: enrollmentNumber,
                    contactId: contactId,
                    email: email,
                    // paymentType: selectedPaymentType.value,
                    updatedBy: "Customer",
                    adminEmail: "",
                    type: "Updated Payment Info",
                    fName: fName,
                    lName: lName,
                  }),
                })
              }

              const serviceActionData = await serviceActionResponse.json()
              responseFromAPI = JSON.stringify(serviceActionData)

              if (serviceActionData.serviceActionId) {
                storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
                serviceActionID = serviceActionData.serviceActionId

                // Associate service action with NSE subscription
                const associateResponse = await fetch('/_hcms/api/associate-service-action', {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    serviceActionId: serviceActionID,
                    nseSubscriptionId: selectedSubscriptionId,
                    contactId: contactId,
                  }),
                })

                const associateData = await associateResponse.json()

                if (associateData.status === "success") {
                  await updateServiceActionWithStripePaymentDetails(serviceActionID, "Option 2")
                  var buttonParent = document.querySelector(".up-strp-jnpiays-update")
                  if (buttonParent?.querySelector(".up-strp-update-card-info")) {
                    var textElement = document.createElement("p")
                    textElement.classList.add("success-message")
                    textElement.textContent = "Your payment information is submited"
                    buttonParent.after(textElement)
                    // Remove the message after 4 seconds
                    setTimeout(() => textElement.remove(), 10000)
                    closeProgressBar()
                    document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                      "Your new payment method has been submitted. It may take up to 24 hours to reflect on this page."
                    document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
                    document.querySelector(".up-closeAblePopup").style.display = "block"
                  }
                  if (StripePaymentMethodUp !== "Credit Card" && StripePaymentMethodUp !== "CC") {
                    if (billingStatusUp === "requires_action") {
                      document.querySelector("#stripeBankCreditMainUp").style.display = "none"
                      document.querySelector("#achVerificationMainUp").style.display = "block"

                      document.querySelector(".up-strp-update-card-info").classList.add("disabled")
                      document.querySelector(".up-strp-update-card-info").disabled = true
                      var idsToHide = ["stripe-container", "up-strp-jnpiays-update"]
                      idsToHide.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                        const el = document.getElementById(id)
                        if (el) {
                          el.style.display = "none"
                        }
                      })
                    } else {
                      document.querySelector("#stripeBankCreditMainUp").style.display = "block"
                      document.querySelector("#achVerificationMainUp").style.display = "none"

                      document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                        "Our system did not capture your payment. Please wait a moment and try again."
                      document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
                      document.querySelector(".up-closeAblePopup").style.display = "block"
                      document.querySelector(".up-strp-update-card-info").classList.remove("disabled")
                      document.querySelector(".up-strp-update-card-info").disabled = false
                      var idsToHide = ["stripe-container", "up-strp-jnpiays-update"]
                      idsToHide.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                        const el = document.getElementById(id)
                        if (el) {
                          el.style.display = "block"
                        }
                      })
                    }
                  }
                } else {
                  document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                    "Our system did not capture your payment. Please wait a moment and try again."
                  document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
                  document.querySelector(".up-closeAblePopup").style.display = "block"
                  document.querySelector(".up-strp-update-card-info").classList.remove("disabled")
                  document.querySelector(".up-strp-update-card-info").disabled = false
                  var idsToHide = ["stripe-container", "up-strp-jnpiays-update"]
                  idsToHide.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                    const el = document.getElementById(id)
                    if (el) {
                      el.style.display = "block"
                    }
                  })
                  closeProgressBar()
                  console.error("❌ Association Error:", associateData)
                  throw new Error("Failed to associate service action.")
                }
              } else {
                document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                  "Our system did not capture your payment. Please wait a moment and try again."
                document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
                document.querySelector(".up-closeAblePopup").style.display = "block"
                document.querySelector(".up-strp-update-card-info").classList.remove("disabled")
                document.querySelector(".up-strp-update-card-info").disabled = false
                var idsToHide = ["stripe-container", "up-strp-jnpiays-update"]
                idsToHide.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                  const el = document.getElementById(id)
                  if (el) {
                    el.style.display = "block"
                  }
                })
                closeProgressBar()
                console.error("❌ Service Action Creation Failed:", serviceActionData)
                throw new Error("Failed to create service action.")
              }
            } catch (error) {
              document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                "Our system did not capture your payment. Please wait a moment and try again."
              document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
              document.querySelector(".up-closeAblePopup").style.display = "block"
              document.querySelector(".up-strp-update-card-info").classList.remove("disabled")
              document.querySelector(".up-strp-update-card-info").disabled = false
              var idsToHide = ["stripe-container", "up-strp-jnpiays-update"]
              idsToHide.forEach((id) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[id],["id"]);
                const el = document.getElementById(id)
                if (el) {
                  el.style.display = "block"
                }
              })
              closeProgressBar()
              console.error("❌ Error:", error)
            }
          }
        })
        // ----------  Update Payment info Details

        // ----------  Make Payment Details
        document.querySelector(".mp-update-card-info").addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          e.preventDefault()

          // Check if a payment type is selected
          const selectedPaymentType = document.querySelector('input[name="mp-paymentType"]:checked')

          if (!selectedPaymentType) {
            const errorMessage = document.getElementById("mp-payment-error-message")
            errorMessage.textContent = "Please select a payment method before proceeding."
            errorMessage.style.display = "block"
            return
          } else {
            var selectedPaymentVal = document.querySelector('input[name="mp-paymentType"]:checked').value
            if (selectedPaymentVal === "ACH") {
              var iccmsgElement = document.querySelector(".mp-jnpiays-bank-details #mp-iBNMSG")
              var iccmsgText = iccmsgElement ? iccmsgElement.textContent.trim() : ""
              if (iccmsgText) {
                var errorMessage = document.getElementById("mp-payment-error-message")
                errorMessage.textContent = ""
                errorMessage.style.display = "none"
              } else {
                var errorMessage = document.getElementById("mp-payment-error-message")
                errorMessage.textContent = "Please add Bank details before proceeding."
                errorMessage.style.display = "block"
                return
              }
            } else if (selectedPaymentVal === "Credit Card") {
              var iccmsgElement = document.querySelector(".mp-jnpiays-credit-details #mp-ICCMSG")
              var iccmsgText = iccmsgElement ? iccmsgElement.textContent.trim() : ""
              if (iccmsgText) {
                var errorMessage = document.getElementById("mp-payment-error-message")
                errorMessage.textContent = ""
                errorMessage.style.display = "none"
              } else {
                var errorMessage = document.getElementById("mp-payment-error-message")
                errorMessage.textContent = "Please add Credit card details before proceeding."
                errorMessage.style.display = "block"
                return
              }
            }
          }

          openProgressBar("We are making your payment")
          // Hide error message if a selection is made
          document.getElementById("mp-payment-error-message").style.display = "none"

          const selectElement = document.querySelector("#subSelect")
          if (!selectElement) return

          const selectedSubscriptionId = selectElement.value
          const selectedSubscription = window.nseSubscriptionVars.find(
            (sub) => sub.hsObjectId === selectedSubscriptionId,
          )

          if (!selectedSubscription) return

          const enrollmentNumber = selectedSubscription.enrollmentNumber
          const contactId = storage.rawGet("RecordId") || (window.contactData ? window.contactData.id : null)
          const email = window.contactData ? window.contactData.email : null

          let serviceActionID = storage.rawGet("nse_service_action") // Check if service action already exists

          try {
            var fName = ""
            var lName = ""
            fName = storage.rawGet("FirstName")
            lName = storage.rawGet("LastName")
            if (st === "admin") {
              var admnEmail = storage.rawGet("adminEmail")
              var _serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  contactId: contactId,
                  email: email,
                  paymentType: selectedPaymentType.value,
                  updatedBy: "Admin",
                  adminEmail: admnEmail,
                  type: "Make a Payment",
                  fName: fName,
                  lName: lName,
                }),
              })
            } else {
              var serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  contactId: contactId,
                  email: email,
                  paymentType: selectedPaymentType.value,
                  updatedBy: "Customer",
                  adminEmail: "",
                  type: "Make a Payment",
                  fName: fName,
                  lName: lName,
                }),
              })
            }

            const serviceActionData = await serviceActionResponse.json()
            responseFromAPI = JSON.stringify(serviceActionData)

            if (serviceActionData.serviceActionId) {
              storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
              serviceActionID = serviceActionData.serviceActionId

              // Associate service action with NSE subscription
              const associateResponse = await fetch('/_hcms/api/associate-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  serviceActionId: serviceActionID,
                  nseSubscriptionId: selectedSubscriptionId,
                  contactId: contactId,
                }),
              })

              const associateData = await associateResponse.json()

              if (associateData.status === "success") {
                await updateServiceActionWithPaymentDetails(serviceActionID, selectedPaymentType.value, "Option 3")
                var buttonParent = document.querySelector(".make_a_payment .tabinInfo")
                var textElement = document.createElement("p")
                textElement.classList.add("success-message")
                textElement.textContent =
                  "✅Your one time payment has been successfully received. Payments may take 24 hours to reflect in your account."
                buttonParent.after(textElement)
                closeProgressBar()
                document.querySelector(".closeAblePopup .loaderText span").textContent =
                  "Success! Your payment submission has been accepted. It may take a few moments to appear in your pending payments."
                document.querySelector("#closeAblePopupOverlay").style.display = "block"
                document.querySelector(".closeAblePopup").style.display = "block"
              } else {
                closeProgressBar()
                document.querySelector(".closeAblePopup .loaderText span").textContent =
                  "Our system did not capture your payment. Please wait a moment and try again."
                document.querySelector("#closeAblePopupOverlay").style.display = "block"
                document.querySelector(".closeAblePopup").style.display = "block"
                console.error("❌ Association Error:", associateData)
                throw new Error("Failed to associate service action.")
              }
            } else {
              closeProgressBar()
              document.querySelector(".closeAblePopup .loaderText span").textContent =
                "Our system did not capture your payment. Please wait a moment and try again."
              document.querySelector("#closeAblePopupOverlay").style.display = "block"
              document.querySelector(".closeAblePopup").style.display = "block"
              console.error("❌ Service Action Creation Failed:", serviceActionData)
              throw new Error("Failed to create service action.")
            }
          } catch (error) {
            closeProgressBar()
            document.querySelector(".closeAblePopup .loaderText span").textContent =
              "Our system did not capture your payment. Please wait a moment and try again."
            document.querySelector("#closeAblePopupOverlay").style.display = "block"
            document.querySelector(".closeAblePopup").style.display = "block"
            console.error("❌ Error:", error)
          }
        })
        document.querySelector(".mp-strp-update-card-info").addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          e.preventDefault()
          // Check if a payment type is selected
          openProgressBar("We are making your payment")

          if (IsStripeFormDone === false) {
            const errorMessage = document.getElementById("mp-strp-payment-error-message")
            errorMessage.textContent = "Please select a payment method before proceeding."
            errorMessage.style.display = "block"
            closeProgressBar()
            return
          }

          document.getElementById("mp-strp-payment-error-message").style.display = "none"

          // Hide error message if a selection is made

          const selectElement = document.querySelector("#subSelect")
          if (!selectElement) return

          const selectedSubscriptionId = selectElement.value
          const selectedSubscription = window.nseSubscriptionVars.find(
            (sub) => sub.hsObjectId === selectedSubscriptionId,
          )

          if (!selectedSubscription) return

          const enrollmentNumber = selectedSubscription.enrollmentNumber
          const contactId = storage.rawGet("RecordId") || (window.contactData ? window.contactData.id : null)
          const email = window.contactData ? window.contactData.email : null

          let serviceActionID = storage.rawGet("nse_service_action") // Check if service action already exists

          try {
            var fName = ""
            var lName = ""
            fName = storage.rawGet("FirstName")
            lName = storage.rawGet("LastName")
            if (st === "admin") {
              var admnEmail = storage.rawGet("adminEmail")
              var _serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  contactId: contactId,
                  email: email,
                  //                                 paymentType: selectedPaymentType.value,
                  updatedBy: "Admin",
                  adminEmail: admnEmail,
                  type: "Make a Payment",
                  fName: fName,
                  lName: lName,
                }),
              })
            } else {
              var serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  contactId: contactId,
                  email: email,
                  //                                 paymentType: selectedPaymentType.value,
                  updatedBy: "Customer",
                  adminEmail: "",
                  type: "Make a Payment",
                  fName: fName,
                  lName: lName,
                }),
              })
            }

            const serviceActionData = await serviceActionResponse.json()
            responseFromAPI = JSON.stringify(serviceActionData)

            if (serviceActionData.serviceActionId) {
              storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
              serviceActionID = serviceActionData.serviceActionId

              // Associate service action with NSE subscription
              const associateResponse = await fetch('/_hcms/api/associate-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  serviceActionId: serviceActionID,
                  nseSubscriptionId: selectedSubscriptionId,
                  contactId: contactId,
                }),
              })

              const associateData = await associateResponse.json()

              if (associateData.status === "success") {
                await updateServiceActionWithStripePaymentDetails(serviceActionID, "Option 3")
                var buttonParent = document.querySelector(".make_a_payment .tabinInfo")
                var textElement = document.createElement("p")
                textElement.classList.add("success-message")
                textElement.textContent =
                  "✅Your one time payment has been successfully received. Payments may take 24 hours to reflect in your account."
                buttonParent.after(textElement)
                closeProgressBar()
                document.querySelector(".closeAblePopup .loaderText span").textContent =
                  "Success! Your payment submission has been accepted. It may take a few moments to appear in your pending payments."
                document.querySelector("#closeAblePopupOverlay").style.display = "block"
                document.querySelector(".closeAblePopup").style.display = "block"
              } else {
                closeProgressBar()
                document.querySelector(".closeAblePopup .loaderText span").textContent =
                  "Our system did not capture your payment. Please wait a moment and try again."
                document.querySelector("#closeAblePopupOverlay").style.display = "block"
                document.querySelector(".closeAblePopup").style.display = "block"
                console.error("❌ Association Error:", associateData)
                throw new Error("Failed to associate service action.")
              }
            } else {
              closeProgressBar()
              document.querySelector(".closeAblePopup .loaderText span").textContent =
                "Our system did not capture your payment. Please wait a moment and try again."
              document.querySelector("#closeAblePopupOverlay").style.display = "block"
              document.querySelector(".closeAblePopup").style.display = "block"
              console.error("❌ Service Action Creation Failed:", serviceActionData)
              throw new Error("Failed to create service action.")
            }
          } catch (error) {
            closeProgressBar()
            document.querySelector(".closeAblePopup .loaderText span").textContent =
              "Our system did not capture your payment. Please wait a moment and try again."
            document.querySelector("#closeAblePopupOverlay").style.display = "block"
            document.querySelector(".closeAblePopup").style.display = "block"
            console.error("❌ Error:", error)
          }
        })
        document.getElementById("opt1Submit").addEventListener("click", async (_e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[_e],["_e"]);
          openProgressBar("We are making your payment")
          // Your custom logic here
          const enteredAmount = parseFloat(amountField.value) || 0

          const selectElement = document.querySelector("#subSelect")
          if (!selectElement) return

          const selectedSubscriptionId = selectElement.value
          const selectedSubscription = window.nseSubscriptionVars.find(
            (sub) => sub.hsObjectId === selectedSubscriptionId,
          )

          if (!selectedSubscription) return

          const enrollmentNumber = selectedSubscription.enrollmentNumber
          const contactId = storage.rawGet("RecordId") || (window.contactData ? window.contactData.id : null)
          const email = window.contactData ? window.contactData.email : null

          let serviceActionID = storage.rawGet("nse_service_action") // Check if service action already exists

          try {
            var fName = ""
            var lName = ""
            fName = storage.rawGet("FirstName")
            lName = storage.rawGet("LastName")
            if (st === "admin") {
              var admnEmail = storage.rawGet("adminEmail")
              var _serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  contactId: contactId,
                  email: email,
                  //                                 paymentType: selectedPaymentType.value,
                  updatedBy: "Admin",
                  adminEmail: admnEmail,
                  type: "Make a Payment",
                  fName: fName,
                  lName: lName,
                }),
              })
            } else {
              var serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  contactId: contactId,
                  email: email,
                  //                                 paymentType: selectedPaymentType.value,
                  updatedBy: "Customer",
                  adminEmail: "",
                  type: "Make a Payment",
                  fName: fName,
                  lName: lName,
                }),
              })
            }

            const serviceActionData = await serviceActionResponse.json()
            responseFromAPI = JSON.stringify(serviceActionData)

            if (serviceActionData.serviceActionId) {
              storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
              serviceActionID = serviceActionData.serviceActionId

              // Associate service action with NSE subscription
              const associateResponse = await fetch('/_hcms/api/associate-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  serviceActionId: serviceActionID,
                  nseSubscriptionId: selectedSubscriptionId,
                  contactId: contactId,
                }),
              })

              const associateData = await associateResponse.json()

              if (associateData.status === "success") {
                await updateServiceActionWithOpt1PaymentDetails(serviceActionID, enteredAmount, "Option 1")
                var buttonParent = document.querySelector(".make_a_payment .tabinInfo")
                var textElement = document.createElement("p")
                textElement.classList.add("success-message")
                textElement.textContent =
                  "✅Your one time payment has been successfully received. Payments may take 24 hours to reflect in your account."
                buttonParent.after(textElement)
                closeProgressBar()
                document.querySelector(".closeAblePopup .loaderText span").textContent =
                  "Success! Your payment submission has been accepted. It may take a few moments to appear in your pending payments."
                document.querySelector("#closeAblePopupOverlay").style.display = "block"
                document.querySelector(".closeAblePopup").style.display = "block"
              } else {
                closeProgressBar()
                document.querySelector(".closeAblePopup .loaderText span").textContent =
                  "We encountered an internal error. Please wait a moment and try submitting your payment again."
                document.querySelector("#closeAblePopupOverlay").style.display = "block"
                document.querySelector(".closeAblePopup").style.display = "block"
                console.error("❌ Association Error:", associateData)
                throw new Error("Failed to associate service action.")
              }
            } else {
              closeProgressBar()
              document.querySelector(".closeAblePopup .loaderText span").textContent =
                "We encountered an internal error. Please wait a moment and try submitting your payment again."
              document.querySelector("#closeAblePopupOverlay").style.display = "block"
              document.querySelector(".closeAblePopup").style.display = "block"
              console.error("❌ Service Action Creation Failed:", serviceActionData)
              throw new Error("Failed to create service action.")
            }
          } catch (error) {
            closeProgressBar()
            document.querySelector(".closeAblePopup .loaderText span").textContent =
              "We encountered an internal error. Please wait a moment and try submitting your payment again."
            document.querySelector("#closeAblePopupOverlay").style.display = "block"
            document.querySelector(".closeAblePopup").style.display = "block"
            console.error("❌ Error:", error)
            //                         alert("An error occurred while processing.");
          }
        })
        // ----------  Make Payment Details

        // ----------  Update Utility Info
        document.querySelector(".customIframe a").addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          e.preventDefault()
          openProgressBar("We are updating your utility info")

          // Hide error message if a selection is made
          document.getElementById("mp-payment-error-message").style.display = "none"

          const selectElement = document.querySelector("#subSelect")
          if (!selectElement) return

          const selectedSubscriptionId = selectElement.value
          const selectedSubscription = window.nseSubscriptionVars.find(
            (sub) => sub.hsObjectId === selectedSubscriptionId,
          )

          if (!selectedSubscription) return
          document.querySelector(".customIframe").style.display = "none"
          const enrollmentNumber = selectedSubscription.enrollmentNumber
          const contactId = storage.rawGet("RecordId") || (window.contactData ? window.contactData.id : null)
          const email = window.contactData ? window.contactData.email : null

          let serviceActionID = storage.rawGet("nse_service_action") // Check if service action already exists

          try {
            // Create NSE service action
            var fName = ""
            var lName = ""
            fName = storage.rawGet("FirstName")
            lName = storage.rawGet("LastName")
            if (st === "admin") {
              var admnEmail = storage.rawGet("adminEmail")
              var _serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  contactId: contactId,
                  email: email,
                  paymentType: "",
                  updatedBy: "Admin",
                  adminEmail: admnEmail,
                  type: "Updated Utility Info",
                  fName: fName,
                  lName: lName,
                }),
              })
            } else {
              var serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  enrollmentNumber: enrollmentNumber,
                  contactId: contactId,
                  email: email,
                  paymentType: "",
                  updatedBy: "Customer",
                  adminEmail: "",
                  type: "Updated Utility Info",
                  fName: fName,
                  lName: lName,
                }),
              })
            }

            const serviceActionData = await serviceActionResponse.json()
            responseFromAPI = JSON.stringify(serviceActionData)

            if (serviceActionData.serviceActionId) {
              storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
              serviceActionID = serviceActionData.serviceActionId

              // Associate service action with NSE subscription
              const associateResponse = await fetch('/_hcms/api/associate-service-action', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  serviceActionId: serviceActionID,
                  nseSubscriptionId: selectedSubscriptionId,
                  contactId: contactId,
                }),
              })

              const associateData = await associateResponse.json()

              if (associateData.status === "success") {
                //                             await updateServiceActionWithPaymentDetails(serviceActionID, selectedPaymentType.value);
                var buttonParent = document.querySelector(".customIframe")
                if (buttonParent?.querySelector("#customIframeButton")) {
                  var textElement = document.createElement("p")
                  textElement.classList.add("success-message")
                  textElement.textContent = "We have received your updated utility credentials. Thank you"
                  buttonParent.after(textElement)

                  document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                    "We have received your updated utility credentials. Thank you"
                  document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
                  document.querySelector(".up-closeAblePopup").style.display = "block"

                  // Remove the message after 4 seconds
                  setTimeout(() => textElement.remove(), 10000)
                  closeProgressBar()
                }
              } else {
                document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                  "We have received an error when updating your utility credentials. Please try again"
                document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
                document.querySelector(".up-closeAblePopup").style.display = "block"
                document.querySelector(".customIframe").style.display = "block"
                closeProgressBar()
                console.error("❌ Association Error:", associateData)
                throw new Error("Failed to associate service action.")
              }
            } else {
              document.querySelector(".up-closeAblePopup .loaderText span").textContent =
                "We have received an error when updating your utility credentials. Please try again"
              document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
              document.querySelector(".up-closeAblePopup").style.display = "block"
              document.querySelector(".customIframe").style.display = "block"
              closeProgressBar()
              console.error("❌ Service Action Creation Failed:", serviceActionData)
              throw new Error("Failed to create service action.")
            }
          } catch (error) {
            document.querySelector(".up-closeAblePopup .loaderText span").textContent =
              "We have received an error when updating your utility credentials. Please try again"
            document.querySelector("#up-closeAblePopupOverlay").style.display = "block"
            document.querySelector(".up-closeAblePopup").style.display = "block"
            document.querySelector(".customIframe").style.display = "block"
            closeProgressBar()
            console.error("❌ Error:", error)
          }
        })

        // Update Service Action With Payment Details Function
        async function updateServiceActionWithPaymentDetails(serviceActionID, paymentType, option) {
__ea_trace("modules/self-serve/self-serve.ts","updateServiceActionWithPaymentDetails",[serviceActionID,paymentType,option],["serviceActionID","paymentType","option"]);
          var paymentAmount = document.querySelector("#amountField").value

          var wallName = "ONE-TIME"
          if (option === "Option 2") {
            wallName = "DEFAULT"
          } else {
            wallName = "ONE-TIME"
          }

          let paymentData

          if (paymentType === "ACH") {
            if (iFrameaccountType === "PC") {
              iFrameaccountType = "Personal Checking"
            } else if (iFrameaccountType === "PS") {
              iFrameaccountType = "Personal Savings"
            } else if (iFrameaccountType === "BC") {
              iFrameaccountType = "Business Checking"
            } else if (iFrameaccountType === "BS") {
              iFrameaccountType = "Business Savings"
            } else if (iFrameaccountType === "GL") {
              iFrameaccountType = "General Ledger"
            }

            paymentData = {
              serviceActionId: serviceActionID,
              paymentType: "ACH",
              properties: {
                ach_rout_number: iFrameRoutingNo || "",
                ach_account_number: iFrameaccountNumber || "",
                ach_name: iFrameaccountName || "",
                ach_account_type: iFrameaccountType || "",
                ach_user_auth: "true",
                payment_vendor: iFrameBanksource || "",
                wallet_token: iFrameBanktoken || "",
                //                             is_ach_default_payment_method: isACHDefault ? "true" : "false",
                is_cc_default_payment_method: "false",
                cc_name: "",
                cc_last_4: "",
                cc_exp_date: "",
                cc_exp: "",
                cc_user_auth: "",
                payment_amount: paymentAmount,
                payment_method: "ACH",
                payment_source: "ONE-TIME",
                default_wallet_flag: "",
                recurring_flag: "",
                wallet_name: wallName,
                //                             type: 'Updated Payment Info',
                token_expiration_date: "Jan 1, 2080",
                make_payment_options: option,
              },
            }
          } else {
            paymentData = {
              serviceActionId: serviceActionID,
              paymentType: "Credit Card",
              properties: {
                // Force ACH Fields to Empty
                ach_rout_number: "",
                ach_account_number: "",
                ach_name: "",
                ach_account_type: "",
                ach_user_auth: "",
                wallet_token: IFrameCreditcardToken || "",
                cc_name: iFrameCreditaccountName || "",
                cc_last_4: iFrameCreditCardNo ? iFrameCreditCardNo.slice(-4) : "",
                cc_exp: iFrameCreditcardExpDate || "",
                cc_exp_date: iFrameCreditcardExpFullDate || "",
                token_expiration_date: iFrameCreditcardExpFullDate || "",
                cc_user_auth: "true",
                //                             is_cc_default_payment_method: isCCDefault ? "true" : "false",
                is_ach_default_payment_method: "false", // ACH should not be default
                payment_amount: paymentAmount,
                payment_method: "CC",
                payment_vendor: IFrameCreditcardsource,
                payment_source: "ONETIME",
                default_wallet_flag: "",
                wallet_name: wallName,
                recurring_flag: "",
                make_payment_options: option,
                //                             type: 'Updated Payment Info'
              },
            }
          }

          if (sourceIframeId === "mp-iFrameCC" || sourceIframeId === "mp-iFrameBN") {
            paymentData.payment_amount = paymentAmount
            paymentData.type = "Make a Payment"
          }

          try {
            const updateResponse = await fetch('/_hcms/api/update-service-action', {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(paymentData),
            })

            const updateResult = await updateResponse.json()
            responseFromAPI = JSON.stringify(updateResult)

            if (updateResult.status === "success") {
              //                         alert("🎉 Payment details updated successfully in the service action record!");
            } else {
              closeProgressBar()
              console.error("❌ Update Failed:", updateResult)
              throw new Error("Failed to update service action with payment details.")
            }
          } catch (error) {
            closeProgressBar()
            console.error("❌ Error Updating Service Action:", error)
            //                     alert("An error occurred while updating payment details.");
          }
        }
        async function updateServiceActionWithStripePaymentDetails(serviceActionID, option) {
__ea_trace("modules/self-serve/self-serve.ts","updateServiceActionWithStripePaymentDetails",[serviceActionID,option],["serviceActionID","option"]);
          if (StripePaymentMethodUp === "Credit Card") {
            StripePaymentMethodUp = "CC"
          }
          var wallName = "ONE-TIME"
          var stcuid = storage.rawGet("StripeCustomerId")
          if (option === "Option 2") {
            wallName = "DEFAULT"
          } else {
            wallName = "ONE-TIME"
          }
          var paymentAmount = document.querySelector("#amountField").value
          let paymentData
          paymentData = {
            serviceActionId: serviceActionID,
            //                         paymentType: "Credit Card",
            properties: {
              //                         payment_amount: paymentAmount,
              stripe_payment_id: stripe_payment_idUp,
              stripe_payment_status: stripe_payment_statusUp,
              stripe_payment_method: stripe_payment_methodUp,
              stripe_payment_method_id: stripe_payment_method_idUp,
              stripe_transaction_response: stripe_transaction_responseUp,
              stripe_payment_receipt_email: stripe_payment_receipt_emailUp,
              stripe_billing_type: billingTypeUp,
              stripe_billing_details: billingDetailsUp,
              stripe_billing_response: billingResponseUp,
              stripe_cc_bnrand: StripeCCbrandUp,
              stripe_country: StripeCCCountryUp,
              cc_last_4: StripeCCLast4Up,
              cc_exp: `${StripeCCExpMonthUp}/${StripeCCExpYearUp}`,
              cc_exp_date: `${StripeCCExpMonthUp}/${StripeCCExpYearUp}`,
              token_expiration_date: "",
              cc_user_auth: StripeCCUserAuthUp,
              card_type: StripeCCbrandUp,
              wallet_token: stripe_payment_method_idUp,
              payment_vendor: "STRIPE",
              ach_name: StripeBankNameUp,
              ach_rout_number: StripeRountingNumberUp,
              ach_account_number: StripeACHLast4Up,
              ach_account_type: StripeAccountTypeUp,
              ach_user_auth: StripeAchUserAuthUp,
              payment_method: StripePaymentMethodUp,
              billing_status: billingStatusUp,
              default_wallet_flag: "",
              recurring_flag: "",
              wallet_name: wallName,
              stripe_customer_id: stcuid,
              make_payment_options: option,
              payment_amount: paymentAmount,
            },
          }

          try {
            const updateResponse = await fetch('/_hcms/api/update-service-action', {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(paymentData),
            })

            const updateResult = await updateResponse.json()
            responseFromAPI = JSON.stringify(updateResult)

            if (updateResult.status === "success") {
              //                         alert("🎉 Payment details updated successfully in the service action record!");
            } else {
              closeProgressBar()
              console.error("❌ Update Failed:", updateResult)
              throw new Error("Failed to update service action with payment details.")
            }
          } catch (error) {
            closeProgressBar()
            console.error("❌ Error Updating Service Action:", error)
            //                     alert("An error occurred while updating payment details.");
          }
        }
        async function _updateServiceActionWithStripeAchVerificationDetails(
          serviceActionID,
          amount1,
          amount2,
          res,
          billingStatus,
        ) {
__ea_trace("modules/self-serve/self-serve.ts","_updateServiceActionWithStripeAchVerificationDetails",[serviceActionID,amount1,amount2,res,billingStatus],["serviceActionID","amount1","amount2","res","billingStatus"]);
          //                 var paymentAmount = document.querySelector('#amountField').value;
          let paymentData
          paymentData = {
            serviceActionId: serviceActionID,
            //                         paymentType: "Credit Card",
            properties: {
              ach_deposit_amount_1: amount1,
              ach_deposit_amount_2: amount2,
              ach_verification_manual_response: res,
              billing_status: billingStatus,
              stripe_payment_status: billingStatus,
            },
          }

          try {
            const updateResponse = await fetch('/_hcms/api/update-service-action', {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(paymentData),
            })

            const updateResult = await updateResponse.json()
            responseFromAPI = JSON.stringify(updateResult)

            if (updateResult.status === "success") {
              //                         alert("🎉 Payment details updated successfully in the service action record!");
            } else {
              closeProgressBar()
              console.error("❌ Update Failed:", updateResult)
              throw new Error("Failed to update service action with payment details.")
            }
          } catch (error) {
            closeProgressBar()
            console.error("❌ Error Updating Service Action:", error)
          }
        }
        async function updateServiceActionWithOpt1PaymentDetails(serviceActionID, payment, option) {
__ea_trace("modules/self-serve/self-serve.ts","updateServiceActionWithOpt1PaymentDetails",[serviceActionID,payment,option],["serviceActionID","payment","option"]);
          var paymentType = storage.rawGet("FarmPayment")
          if (paymentType === "icheck") {
            paymentType = "ICHECK"
          } else if (paymentType === "stripe") {
            paymentType = "STRIPE"
          } else {
            paymentType = "STRIPE"
          }
          let paymentData
          paymentData = {
            serviceActionId: serviceActionID,
            properties: {
              payment_amount: payment,
              make_payment_options: option,
              default_wallet_flag: "Y",
              recurring_flag: "Y",
              payment_vendor: paymentType,
            },
          }

          try {
            const updateResponse = await fetch('/_hcms/api/update-service-action', {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(paymentData),
            })

            const updateResult = await updateResponse.json()
            responseFromAPI = JSON.stringify(updateResult)

            if (updateResult.status === "success") {
              //                         alert("🎉 Payment details updated successfully in the service action record!");
            } else {
              closeProgressBar()
              console.error("❌ Update Failed:", updateResult)
              throw new Error("Failed to update service action with payment details.")
            }
          } catch (error) {
            closeProgressBar()
            console.error("❌ Error Updating Service Action:", error)
            //                     alert("An error occurred while updating payment details.");
          }
        }
        async function _hansenApiForMakePayment(enrollmentNumber) {
__ea_trace("modules/self-serve/self-serve.ts","_hansenApiForMakePayment",[enrollmentNumber],["enrollmentNumber"]);
          var paymentAmount = document.querySelector("#amountField").value

          var paymentDataa
          var selectElement = document.querySelector("#subSelect")
          if (!selectElement) return

          var selectedSubscriptionId = selectElement.value
          var selectedSubscription = window.nseSubscriptionVars.find((sub) => sub.hsObjectId === selectedSubscriptionId)

          if (!selectedSubscription) return

          paymentDataa = {
            EnrollmentNumber: enrollmentNumber,
            PaymentAmount: paymentAmount,
            PaymentSource: "ONETIME",
            WalletToken: IFrameCreditcardToken,
          }

          try {
            const updateResponse = await fetch('http://hansen.danmarcrm.com/dmcNSE.php?apiVer=1&makePayment=true', {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(paymentDataa),
            })

            var updateResult = await updateResponse.json()
            responseFromAPI = JSON.stringify(updateResult)

            if (updateResult.status !== "success") {
              closeProgressBar()
              console.error("❌ Update Failed:", updateResult)
              throw new Error("Failed to update service action with payment details.")
            }
          } catch (error) {
            closeProgressBar()
            console.error("❌ Error Updating Service Action:", error)
          }
        }

        // Undo Changes
        document.querySelector(".undo_btn a").addEventListener("click", (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          e.preventDefault()
          document.querySelectorAll('input[name^="new_"]').forEach((input) => (input.value = ""))
        })

        // Update Password Button
        document.querySelector(".updatePwdBtn button").addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          openProgressBar("We are updating your password")
          e.preventDefault()

          const newPassword = document.getElementById("newPassword").value
          const confirmPassword = document.getElementById("confirmPassword").value

          document.querySelector(".pwderror").textContent = ""

          const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/

          if (newPassword !== confirmPassword) {
            document.querySelector(".pwderror").textContent = "Passwords do not match."
            closeProgressBar()
            return
          }

          if (!passwordRegex.test(newPassword)) {
            document.querySelector(".pwderror").textContent =
              "Password must be at least 8 characters and include a lowercase letter, an uppercase letter, a number, and a special character."
            closeProgressBar()
            return
          }

          try {
            // 🔽 Get current encrypted password from HubSpot
            const contactRes = await fetch('/_hcms/api/get-contact', {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: contactId }),
            })

            const contactData = await contactRes.json()
            const encryptedCurrentPassword = contactData?.properties?.password

            if (encryptedCurrentPassword) {
              const decryptedCurrentPassword = crypt.decrypt(encryptedCurrentPassword)
              if (decryptedCurrentPassword === newPassword) {
                document.querySelector(".pwderror").textContent =
                  "The password you entered has already been used in the past. Please select a different password."
                closeProgressBar()
                return
              }
            }

            // Encrypt and submit new password
            const encryptPassword = crypt.encrypt(newPassword)
            const passwordData = { id: contactId, properties: { password: encryptPassword } }

            const result = await fetch('/_hcms/api/upload-contact-record', {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(passwordData),
            }).then((r) => r.json())

            closeProgressBar()
            responseFromAPI = JSON.stringify(result)

            document.getElementById("newPassword").value = ""
            document.getElementById("confirmPassword").value = ""

            const buttonParent = document.querySelector(".updatePwdBtn")
            if (buttonParent?.querySelector("button")) {
              const textElement = document.createElement("p")
              textElement.classList.add("success-message")
              textElement.textContent = "We have updated your enrollment. Thank you"
              buttonParent.after(textElement)
              setTimeout(() => textElement.remove(), 10000)
            }
          } catch (error) {
            closeProgressBar()
            console.error("Password Update Error:", error)
          }
        })
      } else {
        // Disable the "Save" button
        const saveBtn = document.querySelector(".save_btn a")
        if (saveBtn) {
          saveBtn.classList.add("disabled")
          saveBtn.style.pointerEvents = "none" // Prevent clicking
        }

        // Disable the "Update Card Info" button
        const updateCardBtn = document.querySelector(".update-card-info")
        if (updateCardBtn) {
          updateCardBtn.classList.add("disabled")
          updateCardBtn.disabled = true
        }

        // Disable the "Undo" button
        const undoBtn = document.querySelector(".undo_btn a")
        if (undoBtn) {
          undoBtn.classList.add("disabled")
          undoBtn.style.pointerEvents = "none" // Prevent clicking
        }

        // Disable the "Update Password" button
        const updatePwdBtn = document.querySelector(".updatePwdBtn button")
        if (updatePwdBtn) {
          updatePwdBtn.classList.add("disabled")
          updatePwdBtn.disabled = true
        }

        // Disable the "Make a Payment" buttons
        const startPaymentBtn = document.querySelector("#checkAmountSection button")
        if (startPaymentBtn) {
          startPaymentBtn.classList.add("disabled")
          startPaymentBtn.disabled = true
        }
        const startPaymentInput = document.querySelector("#checkAmountSection #amountField")
        if (startPaymentInput) {
          startPaymentInput.classList.add("disabled")
          startPaymentInput.disabled = true
        }

        // Disable the "Continue Enrollment" button

        const continueEnrollment = document.querySelector(".listContent ul li.lastBtn")
        if (continueEnrollment) {
          continueEnrollment.classList.add("disabled")
          continueEnrollment.disabled = true
        }
        //             closeProgressBar();
      }
    } else {
      var currentUrl = window.location.href
      storage.rawSet("selfServeUrl", currentUrl)
      const urlParams = new URLSearchParams(window.location.search)
      const hasAuth = urlParams.has("auth")
      const c_urlParams = new URLSearchParams(window.location.search)
      const hasUTM = c_urlParams.has("utm_source")
      if (hasUTM) {
        const utm_sourceValue = c_urlParams.get("utm_source")

        const c_url = new URL(window.location.href)
        c_url.searchParams.delete("utm_source")
        window.history.replaceState({}, "", c_url.toString())
        if (utm_sourceValue === "SSP") {
          storage.rawSet("utm_source", "SSP")
        } else {
          storage.rawSet("utm_source", "")
        }
      } else {
        storage.rawSet("utm_source", "")
      }

      var utmSource = storage.rawGet("utm_source")
      if (utmSource === "SSP") {
        document.querySelector(".conditionPopup").style.display = "block"

        const closeBtn = document.querySelector(".conditionPopup-crossIcon img")
        const popup = document.querySelector(".conditionPopup")

        if (closeBtn && popup) {
          closeBtn.addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
            popup.style.display = "none"
          })
        }
      } else {
        document.querySelector(".conditionPopup").style.display = "none"
      }

      if (hasAuth) {
        const authValue = urlParams.get("auth")
        var _decryptedStoredPassword = decrypteEmail(authValue)

        closeProgressBar()
        document.querySelector(".admin_agent").style.display = "block"
        document.querySelector(".customer").style.display = "none"

        document.querySelector(".ssmainsection-outer").style.display = "none"
        document.querySelector(".login-outer").style.display = "block"

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        document.getElementById("admin_agent_email").addEventListener("input", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
          const adminEmail = this.value.trim()
          const messageEl = document.getElementById("admin_agent_email-message")
          const submitBtn = document.getElementById("admin_agent_submit-btn")

          if (!emailRegex.test(adminEmail)) {
            messageEl.textContent = "Please enter correct email."
            submitBtn.disabled = true
          } else {
            messageEl.textContent = ""
            submitBtn.disabled = false
          }
        })
        document.querySelector("#popup #admin_agent_submit-btn").addEventListener("click", (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          openProgressBar()
          e.preventDefault()

          const email = document.getElementById("admin_agent_email").value.trim()

          if (!email) {
            closeProgressBar()
            document.querySelector("#admin_agent_email-message").innerHTML = "Please enter your email"
            return
          } else {
            getHubspotUser(email)
          }
        })
      } else {
        document.querySelector(".customer").style.display = "block"
        document.querySelector(".admin_agent").style.display = "none"

        closeProgressBar()
        document.querySelector(".ssmainsection-outer").style.display = "none"
        document.querySelector(".login-outer").style.display = "block"

        // Regex for password validation
        const _passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/

        // Check password validity on input
        document.getElementById("loginpassword").addEventListener("input", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
          const password = this.value.trim()
          const messageEl = document.getElementById("password-message")
          const submitBtn = document.getElementById("submit-btn")

          const validPassword = validatePass(password)
          if (validPassword.valid) {
            // This means we're good, we can continue processing the form
            messageEl.textContent = ""
            submitBtn.disabled = false
          } else {
            // We're not good, we should display errors and halt submitting the form
            messageEl.textContent = validPassword.errors[0]
            submitBtn.disabled = true
          }
        })

        // Handle form submission
        document.querySelector('#popup button[type="submit"]').addEventListener("click", async (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
          openProgressBar()
          e.preventDefault()

          const email = document.getElementById("loginemail").value.trim()
          const inputPassword = document.getElementById("loginpassword").value.trim()
          const wrongMessageEl = document.getElementById("wrong-message")

          if (!email || !inputPassword) {
            closeProgressBar()
            document.getElementById("password-message").textContent = "Please enter both email and password."
            return
          }

          const validPassword = validatePass(inputPassword)
          if (!validPassword.valid) {
            closeProgressBar()
            // We're not good, we should display errors and halt submitting the form
            document.getElementById("password-message").textContent = validPassword.errors[0]
            return
          }

          // Fetch request to validate user credentials
          fetch('/_hcms/api/get-login', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }), // Only send email
          })
            .then((response) => response.json())
            .then((result) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[result],["result"]);
              responseFromAPI = JSON.stringify(result)
              if (result.contactId && result.encryptedPassword) {
                if (result.encryptedPassword === inputPassword) {
                  getAssoContractRecord(result.contactId, result.email)
                } else {
                  const decryptedStoredPassword = CryptoJS.AES.decrypt(result.encryptedPassword, "CIPHERKEY").toString(
                    CryptoJS.enc.Utf8,
                  )

                  if (decryptedStoredPassword === inputPassword) {
                    getAssoContractRecord(result.contactId, result.email)
                  } else {
                    closeProgressBar()
                    wrongMessageEl.style.display = "block"
                  }
                }
              } else {
                closeProgressBar()
                wrongMessageEl.style.display = "block"
              }
            })
            .catch((error) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[error],["error"]);
              wrongMessageEl.style.display = "block"
              closeProgressBar()
              console.error("Login Error:", error)
            })
        })
      }
    }

    const tabs = document.querySelectorAll(".ssmainsection-tabs ul li")
    tabs.forEach((tab) =>
      tab.addEventListener("click", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
        tabs.forEach((t) => t.classList.remove("active"))
        this.classList.add("active")
        const dataTab = this.getAttribute("data")
        sections.forEach((section, index) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[section,index],["section","index"]);
          if (dataTab === "enrollments") {
            if (mpAccountDetailNone === false) {
              // Show original element again
              var source = document.querySelector(".mp-amountDetail")
              if (source) source.style.display = "block"

              // Remove previously appended copies
              document.querySelectorAll(".mp-amountDetail-appended").forEach((el) => el.remove())
              document.querySelectorAll(".mp-failedpayments-appended").forEach((el) => el.remove())
            }

            document.querySelector(".header-part .accountBalance").style.display = "none"
            document.querySelector(".header-part .SelectAnotherSub").style.display = "none"
            document.querySelector(".header-part .yourSubs").style.visibility = "hidden"
          } else if (dataTab === "make_a_payment") {
            document.querySelector(".header-part .accountBalance").style.display = "flex"
            document.querySelector(".header-part .SelectAnotherSub").style.display = "block"
            document.querySelector(".header-part .yourSubs").style.visibility = "unset"

            if (mpAccountDetailNone === false) {
              var source = document.querySelector(".mp-amountDetail")
              var sourcefp = document.querySelector(".mp-failedpayments")
              var target = document.querySelector(".make_a_payment")

              if (source && target) {
                // Hide original
                source.style.display = "none"

                // Append only if not already appended
                if (!target.querySelector(".mp-amountDetail-appended")) {
                  var newDiv = document.createElement("div")
                  newDiv.classList.add("mp-amountDetail-appended")
                  newDiv.innerHTML = source.innerHTML
                  target.appendChild(newDiv)
                }
              }

              if (sourcefp && target) {
                if (!target.querySelector(".mp-paymentFailed-appended")) {
                  var newDiv = document.createElement("div")
                  newDiv.classList.add("mp-paymentFailed-appended")
                  newDiv.style.display = "none"
                  newDiv.innerHTML = `<div class="mp-failedpaymentsMain"><h4>Recent Failed Payments</h4><div class="mp-failedpayments">${sourcefp.innerHTML}</div></div>`
                  setTimeout(() => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
                    target.appendChild(newDiv)

                    const fpcontainer = document.querySelector(".mp-failedpayments .mp-amountDetailRows")

                    var isAnyFailedPayment = false
                    var _totalAmount = 0

                    var sevenDaysAgo = new Date()
                    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

                    failedPayments.forEach((item, index) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[item,index],["item","index"]);
                      const createDate = item.properties?.hs_createdate
                      const amount = parseFloat(item.properties?.payment_amount || 0)
                      const date = new Date(createDate)

                      const formattedDateCT =
                        String(date.getMonth() + 1).padStart(2, "0") +
                        "-" +
                        String(date.getDate()).padStart(2, "0") +
                        "-" +
                        date.getFullYear()

                      if (amount > 0) {
                        if (date >= sevenDaysAgo) {
                          isAnyFailedPayment = true
                          _totalAmount += amount

                          var filterAmount = formatMoney(amount.toFixed(2))

                          const rowHTML = `
                                  <div class="row">
                                      <div class="valueCol">${filterAmount}</div>
                                      <div class="valueCol">${formattedDateCT}</div>
                                      <div class="valueCol">Payment Method Invalid</div>
                                  </div>`
                          fpcontainer.insertAdjacentHTML("beforeend", rowHTML)
                        }
                      }

                      if (index === failedPayments.length - 1) {
                        const detailContainer = document.querySelector(".mp-paymentFailed-appended")
                        if (isAnyFailedPayment) {
                          detailContainer.style.display = "block"
                        } else {
                          detailContainer.style.display = "none"
                        }
                      }
                    })
                  }, 1000)
                }
              }
            }
          } else {
            if (mpAccountDetailNone === false) {
              var source = document.querySelector(".mp-amountDetail")
              if (source) source.style.display = "block"

              // Remove previously appended copies
              document.querySelectorAll(".mp-amountDetail-appended").forEach((el) => el.remove())
              document.querySelectorAll(".mp-failedpayments-appended").forEach((el) => el.remove())
            }
            document.querySelector(".header-part .accountBalance").style.display = "flex"
            document.querySelector(".header-part .SelectAnotherSub").style.display = "block"
            document.querySelector(".header-part .yourSubs").style.visibility = "unset"
          }
          if (index !== 0) {
            section.style.display = section.getAttribute("data") === dataTab ? "block" : "none"
          }
        })
      }),
    )

    if (window.innerWidth < 991) {
      const selectedTag = document.querySelector(".selected-tag")
      const ul = document.querySelector(".ssmainsection-tabs ul")
      selectedTag.addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
        ul.style.display = ul.style.display === "block" ? "none" : "block"
        selectedTag.classList.toggle("no-lower-border")
      })
      tabs.forEach((tab) =>
        tab.addEventListener("click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
          selectedTag.textContent = tab.textContent
          selectedTag.classList.toggle("no-lower-border")
          ul.style.display = "none"
        }),
      )
    }

    document.querySelector(".mp-strp-jnpiays-update #mp-strp-update-card-info").style.display = "none"
  })

  /* ----------- password eye ball ----------- */
  const togglePassworddd = document.querySelector("#togglePasswordSS")
  const passworddd = document.querySelector("#loginpassword")
  togglePassworddd.addEventListener("click", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
    // toggle the type attribute
    const typee = passworddd.getAttribute("type") === "password" ? "text" : "password"
    passworddd.setAttribute("type", typee)
    // toggle the icon
    this.classList.toggle("fa-eye-slash")
  })
  $("i#togglePasswordSS").click(function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
    $(this).toggleClass("colored")
  })
  /* ----------- password eye ball ----------- */

  async function _createNSEServiceOnUpdateUtilityInfo() {
__ea_trace("modules/self-serve/self-serve.ts","_createNSEServiceOnUpdateUtilityInfo",[],[]);
    var st = storage.rawGet("supportType")
    openProgressBar("We are updating your payment details")

    const selectElement = document.querySelector("#subSelect")
    if (!selectElement) return

    const selectedSubscriptionId = selectElement.value
    const selectedSubscription = window.nseSubscriptionVars.find((sub) => sub.hsObjectId === selectedSubscriptionId)

    if (!selectedSubscription) return

    const enrollmentNumber = selectedSubscription.enrollmentNumber
    const contactId = storage.rawGet("RecordId") || (window.contactData ? window.contactData.id : null)
    const email = window.contactData ? window.contactData.email : null

    let serviceActionID = storage.rawGet("nse_service_action") // Check if service action already exists

    try {
      var fName = ""
      var lName = ""
      fName = storage.rawGet("FirstName")
      lName = storage.rawGet("LastName")
      if (st === "admin") {
        var admnEmail = storage.rawGet("adminEmail")
        var _serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            enrollmentNumber: enrollmentNumber,
            contactId: contactId,
            email: email,
            paymentType: selectedPaymentType.value,
            updatedBy: "Admin",
            adminEmail: admnEmail,
            type: "Updated Payment Info",
            fName: fName,
            lName: lName,
          }),
        })
      } else {
        var serviceActionResponse = await fetch('/_hcms/api/nse-service-action', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            enrollmentNumber: enrollmentNumber,
            contactId: contactId,
            email: email,
            paymentType: selectedPaymentType.value,
            updatedBy: "Customer",
            adminEmail: "",
            type: "Updated Payment Info",
            fName: fName,
            lName: lName,
          }),
        })
      }

      const serviceActionData = await serviceActionResponse.json()
      responseFromAPI = JSON.stringify(serviceActionData)

      if (serviceActionData.serviceActionId) {
        storage.rawSet("nse_service_action", serviceActionData.serviceActionId)
        serviceActionID = serviceActionData.serviceActionId

        // Associate service action with NSE subscription
        const associateResponse = await fetch('/_hcms/api/associate-service-action', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            serviceActionId: serviceActionID,
            nseSubscriptionId: selectedSubscriptionId,
            contactId: contactId,
          }),
        })

        const associateData = await associateResponse.json()

        if (associateData.status !== "success") {
          closeProgressBar()
          console.error("❌ Association Error:", associateData)
          throw new Error("Failed to associate service action.")
        }
      } else {
        closeProgressBar()
        console.error("❌ Service Action Creation Failed:", serviceActionData)
        throw new Error("Failed to create service action.")
      }
    } catch (error) {
      closeProgressBar()
      console.error("❌ Error:", error)
    }
    closeProgressBar()
  }

  /* ----------- contact preference phone number/cell phone validation ----------- */
  function setupNumericInputOnly(inputId, maxLength = 10) {
__ea_trace("modules/self-serve/self-serve.ts","setupNumericInputOnly",[inputId,maxLength],["inputId","maxLength"]);
    const input = document.getElementById(inputId)

    input.addEventListener("input", function () {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
      let value = this.value.replace(/\D/g, "") // Remove non-digits
      if (value.length > maxLength) {
        value = value.slice(0, maxLength) // Limit to max length
      }
      this.value = value

      // ✅ Remove the next .error-message span if it exists
      if (this.nextElementSibling?.classList.contains("error-message")) {
        this.nextElementSibling.remove()
      }

      if (this.value.length <= 3) {
        this.value = this.value // No formatting needed yet
      } else if (this.value.length <= 6) {
        this.value = this.value.replace(/(\d{3})(\d{1,3})/, "$1-$2")
      } else {
        this.value = this.value.replace(/(\d{3})(\d{3})(\d{1,4})/, "$1-$2-$3")
      }
    })

    input.addEventListener("keypress", (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
      // Prevent typing non-numeric characters
      if (!/\d/.test(e.key)) {
        e.preventDefault()
      }
    })
  }
  // Apply to both fields
  setupNumericInputOnly("new_phone")
  setupNumericInputOnly("new_cellphone")

  // ─── Re-bind inline handlers stripped from module.html ──────────────────────
  const bind = (sel, type, fn) => {
__ea_trace("modules/self-serve/self-serve.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  // #logout-popup "Nautilus Home" button
  bind("#logout-popup button", "click", () => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[],[]);
    window.location.href = "/"
  })

  // Contact Care anchor → service_requests tab click
  {
    const el = root.querySelector('.contactSection a[href="javascript:void(0);"]')
    if (el)
      el.addEventListener("click", (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
        e.preventDefault()
        document.getElementById("service_requests")?.click()
      })
  }

  // Update Payment Info: ACH / CC radios
  bind("#ACH", "click", () => showContent("bank"))
  bind("#CreditCard", "click", () => showContent("credit"))

  // Make a Payment: options
  bind("#mp-opt1", "click", () => showOptionsContentMP("1"))
  bind("#mp-opt2", "click", () => showOptionsContentMP("2"))
  bind("#mp-opt3", "click", () => showOptionsContentMP("3"))

  // Make a Payment: redirect to update payment tab anchor
  bind("#redirectToUP", "click", (e) => {
__ea_trace("modules/self-serve/self-serve.ts","(anon)",[e],["e"]);
    e.preventDefault()
    redirectToUpdatePaymentTab()
  })

  // Make a Payment: ACH / CC radios
  bind("#mp-ACH", "click", () => showContentMP("bank"))
  bind("#mp-CreditCard", "click", () => showContentMP("credit"))

  // handleDescriptorInput was undefined in the original — strip only, no binding.

  // Change Password: toggle-password eye spans
  {
    const spans = root.querySelectorAll(".change_password .toggle-password")
    const ids = ["newPassword", "confirmPassword"]
    spans.forEach((el, i) => el.addEventListener("click", () => togglePassword(ids[i], el)))
  }

  // Logout button
  bind("#logout-btn", "click", logoutUser)
}
